/**
 * Generated by '@kontent-ai/model-generator@5.1.1'
 *
 * Project name: 🔴 NESA MAIN
 * Environment: 🔴 PROD
 * Project Id: 341419dc-8ec2-0289-7225-6db7f2d751ef
 */
export const contentTypes = {
  /**
   * 📃🔹Focus Area
   * Last modified: Thu Apr 30 2026 01:03:31 GMT+0000 (Coordinated Universal Time)
   */
  focusarea: {
    codename: 'focusarea',
    id: '94ae9246-c92e-4c6d-bb49-8d10d38c69b9',
    externalId: undefined,
    name: '📃🔹Focus Area',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'ce77b234-2ba1-41b0-a675-1d7d3ee46e06',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: 'd9b05050-9716-4fbc-9c52-96864d0c3019',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content stage specific (modular_content)
       */
      content_staged: {
        codename: 'content_staged',
        id: 'bc0cf777-ff44-4800-aa43-367938036b8b',
        externalId: undefined,
        name: '📜 Content stage specific',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📑 Teaching Advice (modular_content)
       */
      teachingadvice: {
        codename: 'teachingadvice',
        id: 'd0bbb364-b8b6-4c10-a848-1baa34e407d1',
        externalId: undefined,
        name: '📑 Teaching Advice',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📃🔹Related Focus Areas (modular_content)
       *
       * Related Mainstream / Life Skills Focus Area
       */
      related_focusareas: {
        codename: 'related_focusareas',
        id: 'ac011366-a74a-4dab-97a5-9fd52fc61536',
        externalId: undefined,
        name: '📃🔹Related Focus Areas',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📈 Focus Area Continuum Group (modular_content)
       */
      continuumgroups: {
        codename: 'continuumgroups',
        id: '96731262-4856-4622-84e6-22e88a8fdfb5',
        externalId: undefined,
        name: '📈 Focus Area Continuum Group',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Access Points Content (modular_content)
       */
      accesspointcontent: {
        codename: 'accesspointcontent',
        id: 'bf8b893f-49a3-46e2-8720-199d940c1e01',
        externalId: undefined,
        name: '📜 Access Points Content',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📑 Access Points Content Groups (modular_content)
       *
       * Since Access Points have the same structure, we're using Focus Area Group instead
       */
      accesspointgroups: {
        codename: 'accesspointgroups',
        id: 'aac3977a-7c91-4d93-ad35-4a036a7d571b',
        externalId: undefined,
        name: '📑 Access Points Content Groups',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📑 Content Groups (modular_content)
       */
      contentgroups: {
        codename: 'contentgroups',
        id: 'eb589c21-8e06-4a10-b2f6-7f87e4e9e140',
        externalId: undefined,
        name: '📑 Content Groups',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📃 Outcomes (modular_content)
       */
      outcomes: {
        codename: 'outcomes',
        id: '859ac961-3433-4e0a-b3ed-f56da2755a3b',
        externalId: undefined,
        name: '📃 Outcomes',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📃 Related outcomes overwrite (modular_content)
       *
       * ⚠️ Used for PRINT only
       */
      related_outcomes: {
        codename: 'related_outcomes',
        id: '3910ce2f-fbde-48ad-9795-0d266a5db529',
        externalId: undefined,
        name: '📃 Related outcomes overwrite',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📦 Resources Containers (modular_content)
       */
      resource_containers: {
        codename: 'resource_containers',
        id: 'e13f6d56-ad01-48dd-8b56-a9f94b146882',
        externalId: undefined,
        name: '📦 Resources Containers',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📦 Resources other (modular_content)
       */
      resources_other: {
        codename: 'resources_other',
        id: 'c29893e2-4ce5-4777-b848-778af81fd589',
        externalId: undefined,
        name: '📦 Resources other',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📖 Prescriptions (modular_content)
       */
      prescriptions: {
        codename: 'prescriptions',
        id: '1d018b16-7b75-48f5-8e4a-c9def67fdf64',
        externalId: undefined,
        name: '📖 Prescriptions',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Code (text)
       *
       * ⚠️ Not used
       */
      code: {
        codename: 'code',
        id: '6282a0b7-9e2d-4a5b-b10e-70c9a82fa49b',
        externalId: undefined,
        name: '📜 Code',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: 'b74bf81f-5a81-4779-a35c-53c4a03fb281',
        externalId: undefined,
        name: '📒 Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },

      /**
       * 📚 Course (modular_content)
       */
      course: {
        codename: 'course',
        id: 'c6918742-13c8-434d-af1a-328d03500df0',
        externalId: undefined,
        name: '📚 Course',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: '07c153d9-3c2f-4097-86d9-f486afd4e52d',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📚 Syllabus Course
   * Last modified: Thu May 21 2026 00:50:35 GMT+0000 (Coordinated Universal Time)
   */
  course: {
    codename: 'course',
    id: 'cf06da5a-2f86-4fef-a1ca-7d9f44562e77',
    externalId: undefined,
    name: '📚 Syllabus Course',
    elements: {
      /**
       * 📜 Course ID (text)
       *
       * ℹ️ Course number (e.g. 300, 302) from exam system.
       */
      courseid: {
        codename: 'courseid',
        id: 'e66b22be-5bd2-4c0d-b977-4814f8040387',
        externalId: undefined,
        name: '📜 Course ID',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Course name (text)
       *
       * e.g. English 7-10
       */
      name: {
        codename: 'name',
        id: '514a083b-91c0-4f3e-9050-f1a91055e15c',
        externalId: undefined,
        name: '📜 Course name',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Course notes (rich_text)
       */
      course_notes: {
        codename: 'course_notes',
        id: 'b8d01a9d-0641-43b1-ac7d-7283bc2406a2',
        externalId: undefined,
        name: '📜 Course notes',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (modular_content)
       */
      content: {
        codename: 'content',
        id: '86ff8789-cd6d-4bf7-8153-6ea947547a31',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Course Hours (taxonomy)
       */
      coursehours: {
        codename: 'coursehours',
        id: 'a656230f-40e7-479b-bafb-31b6c565d272',
        externalId: undefined,
        name: '🏷️ Course Hours',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Course Units (taxonomy)
       */
      courseunits: {
        codename: 'courseunits',
        id: 'db072623-5444-4d9e-a792-1c25aa917e9c',
        externalId: undefined,
        name: '🏷️ Course Units',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Course Type (taxonomy)
       */
      coursetype: {
        codename: 'coursetype',
        id: '622572b8-fbfb-4553-8d3e-e9c0544b154c',
        externalId: undefined,
        name: '🏷️ Course Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Enrolment Type (taxonomy)
       */
      enrolmenttype: {
        codename: 'enrolmenttype',
        id: '9cd3f6da-3683-42f9-bc17-ebaf66dbd7b8',
        externalId: undefined,
        name: '🏷️ Enrolment Type',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Endorsement type (taxonomy)
       */
      endorsementtype: {
        codename: 'endorsementtype',
        id: 'a93c169a-d338-4afa-8bf4-25a96d75fbf3',
        externalId: undefined,
        name: '🏷️ Endorsement type',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Study via self-tuition (multiple_choice)
       */
      selftuition: {
        codename: 'selftuition',
        id: '98828ff8-05b6-4f95-bc84-1e64e115186f',
        externalId: undefined,
        name: '⚙️ Study via self-tuition',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ HSC Examinable (multiple_choice)
       */
      hscexaminable: {
        codename: 'hscexaminable',
        id: '243d5146-1f8c-4af2-8cf1-decfd3930905',
        externalId: undefined,
        name: '⚙️ HSC Examinable',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Display on course description page (multiple_choice)
       *
       * ⚠️ Should this course be displayed on the advanced course overview page?Yes = This course will be displayed as a section on Syllabus / Overview / Course description tab.No = This course is for content organisation only and will not be displayed on advanced course overview page.
       */
      display_overview: {
        codename: 'display_overview',
        id: '7c1e73e1-aa4f-4c32-b048-7d8bab0d9d41',
        externalId: undefined,
        name: '⚙️ Display on course description page',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '37f72a96-cf04-4815-a324-18fccd45c513',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Content display (multiple_choice)
       *
       * ⚠️ How the teachable content should be displayed on the content tab and in the print document.Yes = This course has content mapped which should be displayed within stage/year content accordionNo = This course does not have any content mapped, it is only displayed on Course Overview page and will be ignored on stage/year content accordions e.g. Music 7-10 or Languages 7-10
       */
      display_mode: {
        codename: 'display_mode',
        id: '2f228cf6-d0e9-4ed7-b4bc-ff7bc6cf144b',
        externalId: undefined,
        name: '⚙️ Content display',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * Content Accordion (taxonomy)
       *
       * ⚠️ Required if Content display is set to Yes.
       */
      content_accordion: {
        codename: 'content_accordion',
        id: '1a23cb02-f1b4-47c5-b88e-2c59e7f08547',
        externalId: undefined,
        name: '🏷️ Content accordion',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content accordion title (text)
       *
       * ⚠️ Required for extension courses, where the title will be appended to the content accordion on the web and the content section in print, e.g., Year 12 - Extension 1.Leave blank for standard (e.g. not extension) courses.
       */
      content_accordion_title: {
        codename: 'content_accordion_title',
        id: '2f687ef9-ccd6-4a80-be9b-f929eb0ff076',
        externalId: undefined,
        name: '📜 Content accordion title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ⚠️ Prescription Requirements (modular_content)
       */
      prescription_requirements: {
        codename: 'prescription_requirements',
        id: '76a594bb-41c3-4860-a9d5-d012cc5c6d3a',
        externalId: undefined,
        name: '⚠️ Prescription Requirements',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       */
      stages: {
        codename: 'stages',
        id: '757831d9-53e6-4f7f-8e30-2109d414bba8',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       */
      stage_years: {
        codename: 'stage_years',
        id: '95923a48-9d34-4947-b0be-c293069d4b70',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Primary Key Learning Area. This field is used to generate the link to this course e.g. /learning-areas/{kla}/{syllabus}/overview/course#{slug}
       */
      key_learning_area_taxo: {
        codename: 'key_learning_area_taxo',
        id: '49b06597-906b-4f90-85e9-c236ab7304cb',
        externalId: undefined,
        name: '🏷️ Key learning area',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus_taxo: {
        codename: 'syllabus_taxo',
        id: 'b69696bc-993e-4857-8816-46e6a1e8495c',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📑 Teaching Advice
   * Last modified: Wed Feb 18 2026 00:55:27 GMT+0000 (Coordinated Universal Time)
   */
  teachingadvice: {
    codename: 'teachingadvice',
    id: '61764978-4d8e-4070-b57b-14ec11ee61d9',
    externalId: undefined,
    name: '📑 Teaching Advice',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'db1c0d89-1fdc-4078-b2ce-15b9c4f7c6d0',
        externalId: undefined,
        name: '📜 Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: 'fda84357-073e-4e92-90b8-141db3611c4d',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📦 Resources Containers (modular_content)
       */
      resource_containers: {
        codename: 'resource_containers',
        id: '9b2b0c9b-c77d-46f6-a875-c48347ce8eeb',
        externalId: undefined,
        name: '📦 Resources Containers',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: 'dbc1ac4b-8a6a-44c0-8c52-4246b842fe30',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '2b7602e5-18cd-4352-8b12-b7d1846fe2bc',
        externalId: undefined,
        name: '📒 Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * 📆 Updated (date_time)
       */
      updated: {
        codename: 'updated',
        id: 'e5e00643-54b0-4ab9-b4e0-b96bd3664b44',
        externalId: undefined,
        name: '📆 Updated',
        required: true,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * 📜 Code (text)
       *
       * ⚠️ Not used
       */
      code: {
        codename: 'code',
        id: '3db54469-fa1a-4161-9143-9bec01ee349c',
        externalId: undefined,
        name: '📜 Code',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Hero banner
   * Last modified: Thu Apr 30 2026 01:21:27 GMT+0000 (Coordinated Universal Time)
   */
  ui_herobanner: {
    codename: 'ui_herobanner',
    id: 'a0d46085-0884-4941-90d4-3597e57065b6',
    externalId: undefined,
    name: '💠 Web UI Hero banner',
    elements: {
      /**
       * 📜 Items (modular_content)
       */
      items: {
        codename: 'items',
        id: 'd0a89471-0539-4199-8c62-46e9c784f532',
        externalId: undefined,
        name: '📜 Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Display (multiple_choice)
       */
      display: {
        codename: 'display',
        id: 'aeae5c7c-7faf-4a2d-8b01-9f85e11fe002',
        externalId: undefined,
        name: '⚙️ Display',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🎨 Theme (multiple_choice)
       */
      theme: {
        codename: 'theme',
        id: '11a37fb8-8af8-4b8f-97ea-08396878854c',
        externalId: undefined,
        name: '🎨 Theme',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🔗 Link Syllabus
   * Last modified: Tue Nov 18 2025 05:46:23 GMT+0000 (Coordinated Universal Time)
   */
  web_link_syllabus: {
    codename: 'web_link_syllabus',
    id: '5690dc10-d959-4a3b-a042-037533342850',
    externalId: undefined,
    name: '🔗 Link Syllabus',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'ed6b6651-0874-4bf1-988e-0227dbc290f1',
        externalId: undefined,
        name: '📜 Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Sub Title (text)
       */
      subtitle: {
        codename: 'subtitle',
        id: '331eedc2-2711-4760-9646-1474de3d7bda',
        externalId: undefined,
        name: '📜 Sub Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Item (modular_content)
       */
      item: {
        codename: 'item',
        id: 'e6854faa-77b3-49f2-9570-5c62d648c0c1',
        externalId: undefined,
        name: '🔗 Item',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚓ Tab (multiple_choice)
       */
      tab: {
        codename: 'tab',
        id: 'bc467736-1b05-43e9-978e-309de0c6f21d',
        externalId: undefined,
        name: '⚓ Tab',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚓ Anchor tag (text)
       *
       * ⚠️ Do not use #character, just the anchot tag itself
       */
      anchorlink: {
        codename: 'anchorlink',
        id: 'f4fb5cbd-29c2-49f5-b746-fac505ef10ac',
        externalId: undefined,
        name: '⚓ Anchor tag',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Additional page (modular_content)
       *
       * ⚠️ Specify additional page if linking to Syllabus Overview tab / Additional pages or to Syllabus Assessment tab / Additional pages.
       */
      additional_page: {
        codename: 'additional_page',
        id: 'aec443af-4e5b-4344-858b-0978d2c38482',
        externalId: undefined,
        name: '🔗 Additional page',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Enable view side-by-side (taxonomy)
       */
      enable_compare_view__enable_compare_view: {
        codename: 'enable_compare_view__enable_compare_view',
        id: '6a071984-aba1-4a39-9ce3-eb395d7c588a',
        externalId: undefined,
        name: '⚙️ Enable view side-by-side',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'enable_compare_view',
      },
    },
  },

  /**
   * 📃 Outcome
   * Last modified: Mon Apr 22 2024 04:30:39 GMT+0000 (Coordinated Universal Time)
   */
  outcome: {
    codename: 'outcome',
    id: '9a898783-88a9-4e0e-86bc-23fbd7989186',
    externalId: undefined,
    name: '📃 Outcome',
    elements: {
      /**
       * 📜 Code (text)
       */
      code: {
        codename: 'code',
        id: '3611f600-e9a9-4be8-aef9-742fbb77b435',
        externalId: undefined,
        name: '📜 Code',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '421c0083-7b3d-45e4-a248-079a7a26419f',
        externalId: undefined,
        name: '📜 Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (rich_text)
       */
      description: {
        codename: 'description',
        id: '127e9a4b-7221-46ce-82aa-00bc450118bc',
        externalId: undefined,
        name: '📜 Description',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '556ad86a-5af9-493a-92f4-514ca1a39360',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },

      /**
       * ⚙️ Is Overarching (multiple_choice)
       */
      isoverarching: {
        codename: 'isoverarching',
        id: 'ec1e469d-da2e-4b7f-b89b-e4abdbb08977',
        externalId: undefined,
        name: '⚙️ Is Overarching',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 📃 Related outcomes (modular_content)
       */
      relatedlifeskillsoutcomes: {
        codename: 'relatedlifeskillsoutcomes',
        id: '5836280b-a5a5-47e3-abdc-23a48eaf1142',
        externalId: undefined,
        name: '📃 Related outcomes',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Media
   * Last modified: Thu Aug 04 2022 03:47:34 GMT+0000 (Coordinated Universal Time)
   */
  ui_media: {
    codename: 'ui_media',
    id: '57273f03-c142-4e8b-82a6-93be4b6f6b31',
    externalId: undefined,
    name: '💠 Web UI Media',
    elements: {
      /**
       * 📜 Caption (text)
       */
      caption: {
        codename: 'caption',
        id: '280e4039-5fb9-4aa4-85e4-88d9c07baa87',
        externalId: undefined,
        name: '📜 Caption',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Media type (multiple_choice)
       *
       * Ensure that image or video link is provided based on Media type selected
       */
      type: {
        codename: 'type',
        id: '0633d600-cefd-4ae4-8f8d-11e5188d1770',
        externalId: undefined,
        name: '⚙️ Media type',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 📦 Item image (asset)
       */
      image: {
        codename: 'image',
        id: 'e514690b-7351-46cc-82df-2668b424f17f',
        externalId: undefined,
        name: '📦 Item image',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Item video (text)
       *
       * Link to video e.g. https://www.youtube.com/embed/HNHu2zRPSB4
       */
      video: {
        codename: 'video',
        id: '5b758347-c882-4883-9493-6af39b516f2c',
        externalId: undefined,
        name: '🔗 Item video',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Width (multiple_choice)
       */
      width: {
        codename: 'width',
        id: '45227deb-4ebd-4124-ab52-5a7c44a91a5c',
        externalId: undefined,
        name: '⚙️ Width',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Align (multiple_choice)
       */
      align: {
        codename: 'align',
        id: 'ebf2d10f-f3ba-4afa-b265-2f95bcb10175',
        externalId: undefined,
        name: '⚙️ Align',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🎨 Theme (multiple_choice)
       */
      theme: {
        codename: 'theme',
        id: '280ad6f1-6e74-4d56-9e01-1ddcbecb3583',
        externalId: undefined,
        name: '🎨 Theme',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Callout
   * Last modified: Thu Jun 30 2022 03:21:50 GMT+0000 (Coordinated Universal Time)
   */
  ui_callout: {
    codename: 'ui_callout',
    id: '7c82f987-dea9-4f5b-a969-9be7f9a0bfab',
    externalId: undefined,
    name: '💠 Web UI Callout',
    elements: {
      /**
       * 📜 Item (modular_content)
       */
      item: {
        codename: 'item',
        id: '2774d69a-f7fd-4a77-8d32-88e0cf9460ea',
        externalId: undefined,
        name: '📜 Item',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📜 Content Block
   * Last modified: Wed Apr 29 2026 08:11:04 GMT+0000 (Coordinated Universal Time)
   */
  contentblock: {
    codename: 'contentblock',
    id: '25c609ed-88c5-4765-be24-6430c36c3652',
    externalId: undefined,
    name: '📜 Content Block',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '919343da-01f8-4d85-b4f0-48ccf64f7a90',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Sub Title (text)
       */
      sub_title: {
        codename: 'sub_title',
        id: 'f5cf990b-ed02-4fcc-96b1-fef9253e73fa',
        externalId: undefined,
        name: '📜 Sub Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '443af4a6-6a88-4844-9d8a-763ec8c72713',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Content Links (modular_content)
       *
       * ℹ️ Used on Hero Search banner only
       */
      content_links: {
        codename: 'content_links',
        id: '7a14106d-db7d-44d7-bdd7-e0275ed19577',
        externalId: undefined,
        name: '🔗 Content Links',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📦 Image (asset)
       */
      image: {
        codename: 'image',
        id: 'c6187010-5f17-448c-8805-9246c3f8fd5a',
        externalId: undefined,
        name: '📦 Image',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * 🆒 SVG Icon (asset)
       */
      svg_icon: {
        codename: 'svg_icon',
        id: '9fd78244-c017-4d67-ac0c-2c95e23b8bfc',
        externalId: undefined,
        name: '🆒 SVG Icon',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * 🔗 More Info Link (modular_content)
       */
      more_info_link: {
        codename: 'more_info_link',
        id: 'cae29bb5-e9fb-439d-9603-e4404fb43452',
        externalId: undefined,
        name: '🔗 More Info Link',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🗄️ ACE Group
   * Last modified: Sat Jul 08 2023 06:41:07 GMT+0000 (Coordinated Universal Time)
   */
  ace_group: {
    codename: 'ace_group',
    id: 'd16d83dc-62bc-4372-bb38-3bc0f1565377',
    externalId: undefined,
    name: '🗄️ ACE Group',
    elements: {
      /**
       * 📜 Code (text)
       */
      code: {
        codename: 'code',
        id: 'a1451d07-9d4b-4c07-89c4-ec608c36886c',
        externalId: undefined,
        name: '📜 Code',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '868559f0-2306-48f7-a239-db7a1250f9b4',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🗃️ Subgroups (modular_content)
       */
      subgroups: {
        codename: 'subgroups',
        id: '14002b63-645b-4690-8557-a995648a067c',
        externalId: undefined,
        name: '🗃️ Subgroups',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },
    },
  },

  /**
   * 🔹 TinyMCE Editor - NOT USED
   * Last modified: Thu Oct 29 2026 10:19:55 GMT+0000 (Coordinated Universal Time)
   */
  tinymce: {
    codename: 'tinymce',
    id: '33d8ad35-8967-413e-840a-1c39de5e22be',
    externalId: undefined,
    name: '🔹 TinyMCE Editor - NOT USED',
    elements: {
      /**
       * 📜 Kontent RTB (rich_text)
       */
      _kontent_rtb: {
        codename: '_kontent_rtb',
        id: 'f6911bc9-51fe-4235-94de-af9dbb6ba8da',
        externalId: undefined,
        name: '📜 Kontent RTB',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 TinyMCE RTB (custom)
       */
      formula: {
        codename: 'formula',
        id: 'b20e4113-ce0a-4650-98d5-27e38cc35abf',
        externalId: undefined,
        name: '📜 TinyMCE RTB',
        required: false,
        type: 'custom',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📃 Assessment Content Item
   * Last modified: Tue Feb 17 2026 01:03:28 GMT+0000 (Coordinated Universal Time)
   */
  syllabus_assessment_item: {
    codename: 'syllabus_assessment_item',
    id: '7e954adb-a0fc-4b44-b5c4-0f32486074cf',
    externalId: undefined,
    name: '📃 Assessment Content Item',
    elements: {
      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: 'de93ed47-a576-4ff4-8a7b-1f9fe656da0b',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Code (text)
       */
      code: {
        codename: 'code',
        id: '042769b4-8325-4d75-8142-b9e5a4ae75d6',
        externalId: undefined,
        name: 'Code',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Note that Multiple KLA option should only be used in Canonical KLA field.
       */
      key_learning_area: {
        codename: 'key_learning_area',
        id: '8bb08e75-aabf-4c64-9f4e-69a307ccb3bb',
        externalId: undefined,
        name: '🏷️ Key learning area',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '4cabe0f4-9832-47f3-b06e-58114eb3af20',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI In-page alert
   * Last modified: Wed Aug 06 2025 05:35:47 GMT+0000 (Coordinated Universal Time)
   */
  ui_inpagealert: {
    codename: 'ui_inpagealert',
    id: '2e9d7500-12ad-4076-b903-d2530967db67',
    externalId: undefined,
    name: '💠 Web UI In-page alert',
    elements: {
      /**
       * 📜 Item (modular_content)
       */
      item: {
        codename: 'item',
        id: 'c220adf0-ab52-4470-bf39-64b42fb88605',
        externalId: undefined,
        name: '📜 Item',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Type (multiple_choice)
       */
      type: {
        codename: 'type',
        id: '4e72554c-20d9-4573-ab43-d012400621d6',
        externalId: undefined,
        name: '⚙️ Type',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Display (multiple_choice)
       */
      display: {
        codename: 'display',
        id: 'f54e8ec0-f039-4687-95a2-450e727511f5',
        externalId: undefined,
        name: '⚙️ Display',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 Web Page
   * Last modified: Tue Jun 23 2026 16:02:03 GMT+0000 (Coordinated Universal Time)
   */
  web_page: {
    codename: 'web_page',
    id: '398abc4f-2591-42f9-a73a-b52a49fc49e9',
    externalId: undefined,
    name: '🌐 Web Page',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'fe81d11c-37c4-4561-930b-aa46b1294f00',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🌐 Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: 'f71c08ab-3d34-48a5-b0e4-c7064ac75094',
        externalId: undefined,
        name: '🌐 Subpages',
        required: false,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 🌐 Left navigation links (modular_content)
       */
      left_navigation: {
        codename: 'left_navigation',
        id: '9e2a6512-61ca-4945-b8e1-5eb3ae9c6bad',
        externalId: undefined,
        name: '🌐 Left navigation links',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: 'ed7fba66-01ed-4664-859b-c33843bca5d0',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 🖇️ Show in-page navigation (multiple_choice)
       */
      show_in_page_navigation: {
        codename: 'show_in_page_navigation',
        id: '97a9c241-dacd-432b-9387-c26208e15fba',
        externalId: undefined,
        name: '🖇️ Show in-page navigation',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect Url (text)
       *
       * Relative or abosute url e.g. /child-page-slug or https://www.externalsite.com/path
       */
      redirect_url: {
        codename: 'redirect_url',
        id: 'c74868f7-5a67-4430-9aee-8f7e54734769',
        externalId: undefined,
        name: '🔗 Redirect Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Tabs
   * Last modified: Fri Nov 29 2024 04:39:31 GMT+0000 (Coordinated Universal Time)
   */
  ui_tabs: {
    codename: 'ui_tabs',
    id: '25ca1d99-a7f8-41ec-9a33-feca8d25763c',
    externalId: undefined,
    name: '💠 Web UI Tabs',
    elements: {
      /**
       * 📜 Items (modular_content)
       */
      items: {
        codename: 'items',
        id: '54435a1f-9e6d-4c1c-a577-92feb018878f',
        externalId: undefined,
        name: '📜 Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Section Level (multiple_choice)
       *
       * ⚠️ Used in print only.Section level where this accordion is placed into. Used during syllabus print to determine the heading level for each child accordion item sections.
       */
      level: {
        codename: 'level',
        id: 'b3b93eac-1392-4758-b3c5-1b4faf0a993a',
        externalId: undefined,
        name: '⚙️ Section Level',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🔗 Web Link Internal
   * Last modified: Fri Jun 12 2026 06:50:48 GMT+0000 (Coordinated Universal Time)
   */
  weblinkint: {
    codename: 'weblinkint',
    id: '7e4b654e-8663-4dfb-a02a-d872a691f900',
    externalId: undefined,
    name: '🔗 Web Link Internal',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'cc3d42cd-6ffe-480c-bd2d-f6f941ab8f0f',
        externalId: undefined,
        name: '📜 Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Sub Title (text)
       */
      subtitle: {
        codename: 'subtitle',
        id: 'd71b13a1-5db4-431c-bae5-9a853befa624',
        externalId: undefined,
        name: '📜 Sub Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Item (modular_content)
       */
      item: {
        codename: 'item',
        id: 'c1504125-e679-411c-83e9-16231ff33404',
        externalId: undefined,
        name: '🔗 Item',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚓ Anchor tag (text)
       *
       * ⚠️ Do not use #character, just the anchot tag itself
       */
      anchorlink: {
        codename: 'anchorlink',
        id: '59509db6-08be-42cc-83b9-1c0778f00df4',
        externalId: undefined,
        name: '⚓ Anchor tag',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ❔Querystring (text)
       *
       * e.g. key=value or key1=value1&key2=value2
       */
      querystring: {
        codename: 'querystring',
        id: '076015b2-0eec-41cb-96b7-4616678debdf',
        externalId: undefined,
        name: '❔Querystring',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠Web UI Homepage Tile Callout
   * Last modified: Fri Jul 22 2022 06:17:56 GMT+0000 (Coordinated Universal Time)
   */
  ui_homepage_tile_callout: {
    codename: 'ui_homepage_tile_callout',
    id: '328cca16-590a-4b9a-9b35-59bb9b730947',
    externalId: undefined,
    name: '💠Web UI Homepage Tile Callout',
    elements: {
      /**
       * 📜 Items (modular_content)
       */
      tiles: {
        codename: 'tiles',
        id: '6ee0a4bc-e763-43af-bdc2-49711b84d11e',
        externalId: undefined,
        name: '📜 Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🎨 Background Color (custom)
       */
      background_color: {
        codename: 'background_color',
        id: 'e3e70d6c-9e47-4c3e-a7cd-83c3dfb268a9',
        externalId: undefined,
        name: '🎨 Background Color',
        required: true,
        type: 'custom',
        snippetCodename: undefined,
      },

      /**
       * 🎨 Divider Color (custom)
       */
      divider_color: {
        codename: 'divider_color',
        id: '622c31d1-995e-4433-b498-4d4bb391e87b',
        externalId: undefined,
        name: '🎨 Divider Color',
        required: true,
        type: 'custom',
        snippetCodename: undefined,
      },

      /**
       * 🎨 Font Color (custom)
       */
      font_color: {
        codename: 'font_color',
        id: 'a44f9d21-23c5-4e28-978d-45826da48bf1',
        externalId: undefined,
        name: '🎨 Font Color',
        required: true,
        type: 'custom',
        snippetCodename: undefined,
      },

      /**
       * 🎨 Arrow Color (custom)
       */
      arrow_color: {
        codename: 'arrow_color',
        id: '1c697de6-8262-453c-8479-ba5c0145080b',
        externalId: undefined,
        name: '🎨 Arrow Color',
        required: true,
        type: 'custom',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Blockquote
   * Last modified: Thu Jun 30 2022 03:21:18 GMT+0000 (Coordinated Universal Time)
   */
  ui_blockquote: {
    codename: 'ui_blockquote',
    id: '1583eb33-b14e-4ee5-88e5-48cd85cd7559',
    externalId: undefined,
    name: '💠 Web UI Blockquote',
    elements: {
      /**
       * 📜 Quote (text)
       */
      quote: {
        codename: 'quote',
        id: '21b5e8e6-0e3f-461d-82eb-06d44fc931ba',
        externalId: undefined,
        name: '📜 Quote',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Cite (text)
       */
      cite: {
        codename: 'cite',
        id: '85e05cf6-29d4-4a3f-8bd4-d981f1934e8b',
        externalId: undefined,
        name: '📜 Cite',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📃 Assessment Group (Band or Grade)
   * Last modified: Mon Feb 16 2026 10:56:37 GMT+0000 (Coordinated Universal Time)
   */
  syllabus_assessment_group: {
    codename: 'syllabus_assessment_group',
    id: '43d4ddab-a156-49ba-8fbb-0cb8d5b4dc6a',
    externalId: undefined,
    name: '📃 Assessment Group (Band or Grade)',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '759df61d-ffe0-4aae-9318-c84db011ee5c',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '50e3a7da-f570-4065-ad80-e027ae9ef2fb',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📃 Assessment content items (modular_content)
       */
      contentitems: {
        codename: 'contentitems',
        id: '7faa4715-81e4-43e7-8227-d81d9d34bb58',
        externalId: undefined,
        name: '📃 Assessment content items',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Code (text)
       */
      code: {
        codename: 'code',
        id: 'b0c12e92-620d-487f-a58a-d466db35d1aa',
        externalId: undefined,
        name: 'Code',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Note that Multiple KLA option should only be used in Canonical KLA field.
       */
      key_learning_area: {
        codename: 'key_learning_area',
        id: '4bdbda5a-97ee-4977-9836-f1e578ea9003',
        externalId: undefined,
        name: '🏷️ Key learning area',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '00fcd23e-46f7-484b-bb75-9b27e602a615',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Assessment Grades (taxonomy)
       */
      assessment_grades: {
        codename: 'assessment_grades',
        id: '27fcce52-b319-4ad7-b558-f7591be252bf',
        externalId: undefined,
        name: '🏷️ Assessment Grades',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Accordion
   * Last modified: Mon May 25 2026 01:00:20 GMT+0000 (Coordinated Universal Time)
   */
  ui_accordion: {
    codename: 'ui_accordion',
    id: '6d5d5ce3-384d-418f-b7c6-d5c3ba660055',
    externalId: undefined,
    name: '💠 Web UI Accordion',
    elements: {
      /**
       * 📜 Items (modular_content)
       */
      items: {
        codename: 'items',
        id: 'c25a3658-70d9-4916-a1a5-3a89ed66d7fa',
        externalId: undefined,
        name: '📜 Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Show Expand / Collapse (multiple_choice)
       */
      showexpandcollapse: {
        codename: 'showexpandcollapse',
        id: 'c2e9f79f-3826-44f6-a8de-3097f26cc96b',
        externalId: undefined,
        name: '⚙️ Show Expand / Collapse',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Section Level (multiple_choice)
       *
       * ⚠️ Used in print only on syllabus info pages.Set to the section level where this accordion is placed into to determine the heading level for each child accordion item sections.Note that if you are using headings within each accordion item, they need to be set to 2 levels down for example:If accordion is placed under Heading 4, set its Section level to 4 and use Heading 6 within content to achieve this structure- H4 container section- H5 accordion item heading- H6 accordion item content headingIf used within Heading 5 section, you cannot use content heading as Heading level 7 are not available.
       */
      level: {
        codename: 'level',
        id: '7e042067-a156-40d9-bdbf-9998a8dbe2b7',
        externalId: undefined,
        name: '⚙️ Section Level',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📂 Collection Syllabuses
   * Last modified: Tue Jul 15 2025 23:23:40 GMT+0000 (Coordinated Universal Time)
   */
  collection_syllabus: {
    codename: 'collection_syllabus',
    id: 'a67388ef-d0bf-44dc-8966-9d4294001b2f',
    externalId: undefined,
    name: '📂 Collection Syllabuses',
    elements: {
      /**
       * Items (modular_content)
       */
      items: {
        codename: 'items',
        id: '962ba352-b8a1-4236-a28b-67d06f7e1519',
        externalId: undefined,
        name: 'Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📃 Assessment Stage Content
   * Last modified: Wed Feb 18 2026 00:31:46 GMT+0000 (Coordinated Universal Time)
   */
  syllabus_assessment_stagecontent: {
    codename: 'syllabus_assessment_stagecontent',
    id: 'bb2dbaae-5387-4041-877c-8cc925d89b83',
    externalId: undefined,
    name: '📃 Assessment Stage Content',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '6ad0c8be-fe69-4277-8b44-ef2a0d9e8f7c',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: 'a3ee3e50-13fa-4271-88bd-abe36f3e1a5a',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📃 Assessment groups (bands or grade) (modular_content)
       */
      gradingitems: {
        codename: 'gradingitems',
        id: '2a69ca46-3431-42e0-b1fc-9948d9217372',
        externalId: undefined,
        name: '📃 Assessment groups (bands or grade)',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📦 Resource Containers (modular_content)
       */
      resource_containers: {
        codename: 'resource_containers',
        id: 'bd87d3b6-bb35-4f24-bb7b-5838dbc9e91e',
        externalId: undefined,
        name: '📦 Resource Containers',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📦 Resources other (modular_content)
       */
      resources_other: {
        codename: 'resources_other',
        id: '305b7e65-1a87-4117-8b36-cfe34e8a8450',
        externalId: undefined,
        name: '📦 Resources other',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Note that Multiple KLA option should only be used in Canonical KLA field.
       */
      key_learning_area: {
        codename: 'key_learning_area',
        id: '7fd7e72a-8f23-4ea0-a5b0-c48a8946eb1b',
        externalId: undefined,
        name: '🏷️ Key learning area',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '47c846ca-e31c-4647-8d24-d761dc76b623',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📒 Syllabus
   * Last modified: Thu Aug 13 2026 02:31:28 GMT+0000 (Coordinated Universal Time)
   */
  syllabus: {
    codename: 'syllabus',
    id: '430d1ba2-bebe-4cf9-836b-3266ad001d0c',
    externalId: undefined,
    name: '📒 Syllabus',
    elements: {
      /**
       * 📜 Title (text)
       *
       * Note that "Title" will also be used to generate the SEO Title on the website
       */
      title: {
        codename: 'title',
        id: 'cf4c6095-997b-4d90-958a-44cf69f4789d',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📅 Publication year (text)
       *
       * ⚠️ If filled in, Publication year will be displayed in parentheses after Title.
       */
      publication_year: {
        codename: 'publication_year',
        id: '2789b0f5-5a5d-477c-b37c-6dcfe1257da4',
        externalId: undefined,
        name: '📅 Publication year',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Status (taxonomy)
       */
      status: {
        codename: 'status',
        id: '37288b25-3cd0-4698-8bad-a179a311ca11',
        externalId: undefined,
        name: '🏷️ Status',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 📅 Status year (text)
       *
       * ⚠️ If filled in, Status year will be displayed after Status.
       */
      status_year: {
        codename: 'status_year',
        id: '80b29aa0-ce04-42a1-bf3e-d748317dce62',
        externalId: undefined,
        name: '📅 Status year',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Implementation title (text)
       */
      implementation_title: {
        codename: 'implementation_title',
        id: '3f623d6f-c068-4cfb-9d3b-c0b0f726a724',
        externalId: undefined,
        name: '📜 Implementation title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Implementation summary (text)
       */
      implementation_summary: {
        codename: 'implementation_summary',
        id: '4cf25969-250c-4927-8b76-5b3d031eff2c',
        externalId: undefined,
        name: '📜 Implementation summary',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Implementation info (rich_text)
       */
      implementation_info: {
        codename: 'implementation_info',
        id: '917c91a8-f424-4ffa-884f-7a8c89e01f59',
        externalId: undefined,
        name: '📜 Implementation info',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Aim (rich_text)
       */
      aim: {
        codename: 'aim',
        id: '3427f867-db4b-41f3-8dbb-31a7d7b90a88',
        externalId: undefined,
        name: '📜 Aim',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Rationale (rich_text)
       *
       * The common understanding of the value and importance of the subject for student learning.
       */
      rationale: {
        codename: 'rationale',
        id: '3e7dd85a-a1a4-402f-a318-b8f29fe32d8e',
        externalId: undefined,
        name: '📜 Rationale',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Note that Multiple KLA option should only be used in Canonical KLA field.
       */
      key_learning_area__items: {
        codename: 'key_learning_area__items',
        id: 'd4be49ed-5b70-4bf1-8396-c4c4ba8a1877',
        externalId: undefined,
        name: 'Key Learning Area',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'key_learning_area',
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Note that Multiple KLA option should only be used here e.g. in Canonical KLA field.
       */
      key_learning_area_default: {
        codename: 'key_learning_area_default',
        id: 'a514a6b0-d3da-4add-9db0-861c750770c9',
        externalId: undefined,
        name: '🏷️ Canonical Key Learning Area',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 📒 Related life skills syllabus (modular_content)
       */
      relatedlifeskillssyllabus: {
        codename: 'relatedlifeskillssyllabus',
        id: '4be39efb-1553-4c7a-8634-525845927ea3',
        externalId: undefined,
        name: '📒 Related life skills syllabus',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },

      /**
       * ⚙️ Self tuition (multiple_choice)
       *
       * Stage 6 only. Whether course is available for study via self-tutition as per ACE rules.
       */
      selftuition: {
        codename: 'selftuition',
        id: '5a2d379b-03ac-4203-8805-970f00053742',
        externalId: undefined,
        name: '⚙️ Self tuition',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 📜 Syllabus Overview (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '48e3a097-31be-4600-b4e9-760b48d9890a',
        externalId: undefined,
        name: '📜 Syllabus Overview',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Course Description (rich_text)
       */
      course_content: {
        codename: 'course_content',
        id: '95902b51-2f2d-47a4-959b-2064921163be',
        externalId: undefined,
        name: '📜 Course Description',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📚 Courses (modular_content)
       */
      courses: {
        codename: 'courses',
        id: 'd3782c9b-9574-4e49-b7a5-c56c79637d04',
        externalId: undefined,
        name: '📚 Courses',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Course Description Footer (rich_text)
       *
       * ⚠️ This section appears below the further information for courses and can be used for related industries, skills and complementary courses (VET). The first line in this content section must be in H4 heading.
       */
      course_content_footer: {
        codename: 'course_content_footer',
        id: '5f5ef20a-f63b-487e-8aaa-8f46832cc56c',
        externalId: undefined,
        name: '📜 Course Description Footer',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📙 Additional Overview Content (modular_content)
       */
      additional_content: {
        codename: 'additional_content',
        id: 'ecb29dce-71b9-4e91-9485-8c6ca68b97b7',
        externalId: undefined,
        name: '📙 Additional Overview Content',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Life Skills info for syllabus (rich_text)
       *
       * This is the content displayed on the first LS section on the printout
       */
      lifeskills_info_syllabus: {
        codename: 'lifeskills_info_syllabus',
        id: 'be920b32-631d-4527-9d25-d43acf3c4977',
        externalId: undefined,
        name: '📜 Life Skills info for syllabus',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Life Skills info for focus areas (rich_text)
       *
       * This is the content displayed for all LS focus areas on the web view
       */
      lifeskills_info_focusareas: {
        codename: 'lifeskills_info_focusareas',
        id: '4803b75f-2893-44de-8c26-2c1bfa34b1fc',
        externalId: undefined,
        name: '📜 Life Skills info for focus areas',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📈 Focus area continum groups (modular_content)
       *
       * Create focus area contimum to group outcomes from related focus areas e.g. Forming groups, Forming groups A and Forming groups B
       */
      focus_area_continum_groups: {
        codename: 'focus_area_continum_groups',
        id: 'd2046dcc-de25-4f69-a6d9-8c33877d7a5b',
        externalId: undefined,
        name: '📈 Focus area continum groups',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📃 Focus areas (modular_content)
       */
      focus_areas: {
        codename: 'focus_areas',
        id: 'eeb3d84a-eab4-4df0-b199-68700855cde4',
        externalId: undefined,
        name: '📃 Focus areas',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Outcomes notifications (modular_content)
       */
      outcomesnotificationslist: {
        codename: 'outcomesnotificationslist',
        id: 'e7a7a08f-5421-4c30-b872-8475f35ef483',
        externalId: undefined,
        name: '📜 Outcomes notifications',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📃 Outcomes (modular_content)
       */
      outcomes: {
        codename: 'outcomes',
        id: '8da96cc9-4ab8-4a21-a41f-b6fa9e5324b8',
        externalId: undefined,
        name: '📃 Outcomes',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Assessment model (multiple_choice)
       */
      assessment_model: {
        codename: 'assessment_model',
        id: '0a21b268-fd3a-40c8-ac2e-30b5201913b2',
        externalId: undefined,
        name: '⚙️ Assessment model',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Assessment UI mode (multiple_choice)
       */
      assessment_ui_mode: {
        codename: 'assessment_ui_mode',
        id: 'f69a8052-84f2-439e-b92a-521bd56e6132',
        externalId: undefined,
        name: '⚙️ Assessment UI mode',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 📙 Assessment pages (modular_content)
       */
      assessments_pages: {
        codename: 'assessments_pages',
        id: '8f5aa6e8-c71e-4b94-810e-33bb3d59d24f',
        externalId: undefined,
        name: '📙 Assessment pages',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Assessments info (K-10 only) (rich_text)
       *
       * This is the Assessment call-out content
       */
      assessments_info: {
        codename: 'assessments_info',
        id: '3b52ecf2-9fcf-47fc-9a28-f838d1746596',
        externalId: undefined,
        name: '📜 Assessments info (K-10 only)',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📃 Assessments (K-10 only) (modular_content)
       */
      assessments: {
        codename: 'assessments',
        id: '43ac34b4-3e76-4b17-813d-b43eb4bea15d',
        externalId: undefined,
        name: '📃 Assessments (K-10 only)',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Course standards assessment info (Stage 6 only) (rich_text)
       */
      cs_assessments_info: {
        codename: 'cs_assessments_info',
        id: '3e3617b2-32ce-49e1-a3dc-2e192a4c65b7',
        externalId: undefined,
        name: '📜 Course standards assessment info (Stage 6 only)',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📃 Course standards assessments (Stage 6 only) (modular_content)
       */
      cs_assessments: {
        codename: 'cs_assessments',
        id: 'b4947f09-9e27-4ae3-a788-d6217e2613bc',
        externalId: undefined,
        name: '📃 Course standards assessments (Stage 6 only)',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 School-based assessment info (Stage 6 only) (rich_text)
       */
      sb_assessments_info: {
        codename: 'sb_assessments_info',
        id: '564b4730-f482-4ce1-91f9-b146a2257af6',
        externalId: undefined,
        name: '📜 School-based assessment info (Stage 6 only)',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📃 School-based assessments (Stage 6 only) (modular_content)
       */
      sb_assessments: {
        codename: 'sb_assessments',
        id: 'ea40de0f-3da3-49dc-89fa-6746c3883d23',
        externalId: undefined,
        name: '📃 School-based assessments (Stage 6 only)',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 HSC assessment info (Stage 6 only) (rich_text)
       */
      hsc_assessments_info: {
        codename: 'hsc_assessments_info',
        id: '8c8277a8-9263-4093-8117-d76b9f5aa16c',
        externalId: undefined,
        name: '📜 HSC assessment info (Stage 6 only)',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📃 HSC assessments (Stage 6 only) (modular_content)
       */
      hsc_assessments: {
        codename: 'hsc_assessments',
        id: 'c0e5366b-3bc4-4d27-8043-6f5816768519',
        externalId: undefined,
        name: '📃 HSC assessments (Stage 6 only)',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * 📜 Code (text)
       *
       * ⚠️ Not used. This is a code which is used to group together outgoing and incomming syllabuses.
       */
      code: {
        codename: 'code',
        id: '96603deb-bdac-4936-97b7-d8ddefe3d95d',
        externalId: undefined,
        name: '📜 Code',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '034c3824-27ae-4ad5-b556-30534e3f64f1',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Pathways (taxonomy)
       */
      pathways: {
        codename: 'pathways',
        id: 'ff2cabe4-167e-47d6-b6b5-5030ea3fc148',
        externalId: undefined,
        name: '🏷️ Pathways',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Language (taxonomy)
       *
       * ⚠️ For Modern and Classical Languages only.
       */
      languages: {
        codename: 'languages',
        id: '5fa90d1f-0be5-44b9-a64f-47274b70cf3c',
        externalId: undefined,
        name: '🏷️ Languages',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Syllabus Content Model (multiple_choice)
       */
      syllabus_content_model: {
        codename: 'syllabus_content_model',
        id: 'cd19e55d-45c5-4365-93f6-8cdac0c0153e',
        externalId: undefined,
        name: '⚙️ Syllabus Content Model',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Non-Standard Syllabuses - Hide content (multiple_choice)
       *
       * ⚠️ Leave blank for Standard reformed syllabuses. For Non Standard syllabuses select options to hide content tabs/sections on the website.
       */
      cec_content_hide: {
        codename: 'cec_content_hide',
        id: '57cb7247-0243-4e72-8a58-cb982f599cf8',
        externalId: undefined,
        name: '⚙️ Non-Standard Syllabuses - Hide content',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Non-Standard Syllabuses - Print mode (multiple_choice)
       *
       * ⚠️ Leave blank for Standard reformed syllabuses.
       */
      cec_print_mode: {
        codename: 'cec_print_mode',
        id: '591146e1-9d25-4ce5-8dc3-ae288483c46c',
        externalId: undefined,
        name: '⚙️ Non-Standard Syllabuses - Print mode',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Has Examples (multiple_choice)
       *
       * Yes = Show examples checkbox will be displayedNo = Show examples checkbox will not be displayed Field empty = Show examples checkbox will be displayed
       */
      has_examples: {
        codename: 'has_examples',
        id: 'fa00180b-4ef6-4bb6-b339-c57c6c2d765c',
        externalId: undefined,
        name: '⚙️ Has Examples',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Collapse Options List's aligned content (multiple_choice)
       *
       * Collapse Options List's aligned content on outcomes tab
       */
      collapse_optionslist_alignedcontent: {
        codename: 'collapse_optionslist_alignedcontent',
        id: 'adcda9cf-f43a-414e-9415-9b584e54cae9',
        externalId: undefined,
        name: "⚙️ Collapse Options List's aligned content",
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * Content Accordion (taxonomy)
       *
       * To enable the Show examples checkbox, add Stages/Years where examples are available.⚠️ Note that examples in senior life skills syllabuses are configured in the life skills itself, not in related mainstream syllabus.Ensure Year 11 and/or Year 12 options, as well as the Life Skills option, are selected for all Life Skills syllabuses. This ensures that the checkbox is displayed within the mainstream Year 11 and/or 12 accordions when switching to the Life Skills view.
       */
      has_examples_in: {
        codename: 'has_examples_in',
        id: 'f0799599-b46d-4a8d-9d3a-c68d2d5fd549',
        externalId: undefined,
        name: '🏷️ Enable Examples in Stage/Year',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 🗒️ Syllabus print tooltip (rich_text)
       */
      syllabus_print_tooltip: {
        codename: 'syllabus_print_tooltip',
        id: '3bffa458-241a-4150-906f-0effa3475eac',
        externalId: undefined,
        name: '🗒️ Syllabus print tooltip',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📅 From date (date_time)
       */
      from_date: {
        codename: 'from_date',
        id: '3336c8a4-e306-499e-ac2e-f94d8036224a',
        externalId: undefined,
        name: '📅 From date',
        required: true,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * 📅 To date (date_time)
       */
      to_date: {
        codename: 'to_date',
        id: 'cac2e1d8-8a1a-4351-b07c-4919af864cfc',
        externalId: undefined,
        name: '📅 To date',
        required: false,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * 📜 Keywords (text)
       */
      seo_keywords: {
        codename: 'seo_keywords',
        id: '23f13445-2865-4e5a-9f10-ff34c0e77225',
        externalId: undefined,
        name: '📜 Keywords',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description overview (text)
       */
      seo_description_overview: {
        codename: 'seo_description_overview',
        id: 'e0ad6732-c8d7-4f36-a5f3-9f2d105bf485',
        externalId: undefined,
        name: '📜 Description overview',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description course (text)
       */
      seo_description_course: {
        codename: 'seo_description_course',
        id: 'b881c4b9-74eb-401a-9a59-4289afec17b4',
        externalId: undefined,
        name: '📜 Description course',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description rationale (text)
       */
      seo_description_rationale: {
        codename: 'seo_description_rationale',
        id: '69d86ad8-876b-4259-a247-61d5128aaec8',
        externalId: undefined,
        name: '📜 Description rationale',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description aim (text)
       */
      seo_description_aim: {
        codename: 'seo_description_aim',
        id: '08ce0ed1-a141-4e0e-832f-f7322d72a93a',
        externalId: undefined,
        name: '📜 Description aim',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description outcomes (text)
       */
      seo_description_outcomes: {
        codename: 'seo_description_outcomes',
        id: '128eb039-d7a4-4a8c-b5de-85f875832f57',
        externalId: undefined,
        name: '📜 Description outcomes',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description content (text)
       */
      seo_description_content: {
        codename: 'seo_description_content',
        id: 'd0ab53b6-969f-4702-9f33-4db8c23f396a',
        externalId: undefined,
        name: '📜 Description content',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description assessment (text)
       */
      seo_description_assessment: {
        codename: 'seo_description_assessment',
        id: '076ed6f2-ea63-4079-996d-b70183849a25',
        externalId: undefined,
        name: '📜 Description assessment',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description glossary (text)
       */
      seo_description_glossary: {
        codename: 'seo_description_glossary',
        id: '0a713df7-7802-4da9-9711-2e4cef12732e',
        externalId: undefined,
        name: '📜 Description glossary',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description support (text)
       */
      seo_description_support: {
        codename: 'seo_description_support',
        id: 'bdcf58c9-ea9d-4eaa-8ee8-ebe0961ecb65',
        externalId: undefined,
        name: '📜 Description support',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Is redirect syllabus (multiple_choice)
       *
       * ⚠️ IMPORTANTYes = Links to redirect URL, if provided. Syllabus title displays without a link on landing pages if redirect URL is left blank. Syllabus content is not visible on curriculum.nsw.edu.au website.No = Redirect is disabled (new syllabus content will be live on curriculum.nsw.edu.au website).DO NOT change to 'No' until syllabus is ready to go live.
       */
      doredirect: {
        codename: 'doredirect',
        id: '0910fdd4-268f-473b-9da0-70d62ab01ade',
        externalId: undefined,
        name: '🔗 Is redirect syllabus',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect url (text)
       *
       * External Url if Syllabus content is hosted on external site
       */
      redirecturl: {
        codename: 'redirecturl',
        id: 'cf9dfbaa-98ce-47bc-83b5-df635c20667d',
        externalId: undefined,
        name: '🔗 Redirect url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ⚒️ Allow staging view (multiple_choice)
       *
       * Used on https://nesa-staging.vercel.app and https://nesa-uat-content.vercel.app to allow early preview for syllabus content in published mode.This is only used if the syllabus still redirects i.e. not yet published on NSW curriculum website.
       */
      allowpreview: {
        codename: 'allowpreview',
        id: 'aec3be20-1105-4809-9ec0-5bbdfb162687',
        externalId: undefined,
        name: '⚒️ Allow staging view',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 Web Page Learning Area
   * Last modified: Thu May 29 2025 06:24:53 GMT+0000 (Coordinated Universal Time)
   */
  wp_learningarea: {
    codename: 'wp_learningarea',
    id: '99e7bf4f-ffdd-41dd-afb1-d1fc10fe3ed9',
    externalId: undefined,
    name: '🌐 Web Page Learning Area',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'ae6e3dee-4e8d-46ad-8c48-776b47026f80',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🌐 Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: 'b1ab3b44-ca1c-4a2c-893d-ce6016ab73ef',
        externalId: undefined,
        name: '🌐 Subpages',
        required: false,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 📒 Syllabuses - DELETE after v23 KLA release (modular_content)
       */
      syllabuses: {
        codename: 'syllabuses',
        id: '3f586aa8-5544-47b1-8bfb-def32d8fc21d',
        externalId: undefined,
        name: '📒 Syllabuses - DELETE after v23 KLA release',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: 'cc1898ec-9e9c-4839-ad66-e80499a45a57',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Note that Multiple KLA option should only be used in Canonical KLA field.
       */
      key_learning_area__items: {
        codename: 'key_learning_area__items',
        id: 'd4be49ed-5b70-4bf1-8396-c4c4ba8a1877',
        externalId: undefined,
        name: 'Key Learning Area',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'key_learning_area',
      },
    },
  },

  /**
   * 🌐 Web Page Teaching Advice
   * Last modified: Tue Jun 24 2025 02:46:18 GMT+0000 (Coordinated Universal Time)
   */
  wp_teachingadvice: {
    codename: 'wp_teachingadvice',
    id: 'ac3b3e04-90e5-498c-8d74-c4eb377e472a',
    externalId: undefined,
    name: '🌐 Web Page Teaching Advice',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '180c1524-8de0-4298-8ca3-6c36f3bc0cb2',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: 'e4e7ed12-1c95-439d-9a71-1044d1b00347',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 🖇️ Show in-page navigation (multiple_choice)
       */
      show_in_page_navigation: {
        codename: 'show_in_page_navigation',
        id: '84967834-6502-40d2-aea3-c1c38ff9f363',
        externalId: undefined,
        name: '🖇️ Show in-page navigation',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect Url (text)
       */
      redirect_url: {
        codename: 'redirect_url',
        id: '8d0c41df-ab35-4319-9a0d-abdf355d280b',
        externalId: undefined,
        name: '🔗 Redirect Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📂 Collection Web Links
   * Last modified: Fri Jul 01 2022 03:57:21 GMT+0000 (Coordinated Universal Time)
   */
  collection_weblink: {
    codename: 'collection_weblink',
    id: '3d06ad68-3152-4f45-8248-ccc919c47241',
    externalId: undefined,
    name: '📂 Collection Web Links',
    elements: {
      /**
       * Items (modular_content)
       */
      items: {
        codename: 'items',
        id: '497d540c-972e-4444-91bb-3d0df465923a',
        externalId: undefined,
        name: 'Items',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Menu
   * Last modified: Tue May 26 2026 02:41:40 GMT+0000 (Coordinated Universal Time)
   */
  ui_menu: {
    codename: 'ui_menu',
    id: '24284152-dd5f-45d4-b4ab-7ef282d2211d',
    externalId: undefined,
    name: '💠 Web UI Menu',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'e7f9c20d-a369-4656-bc62-c7ac127825ad',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title Long (text)
       *
       * Used on level 1 main menu popup only
       */
      titlelong: {
        codename: 'titlelong',
        id: 'd8591f24-40bc-4c35-bf02-4c58ecbee5e1',
        externalId: undefined,
        name: '📜 Title Long',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Sub Title (text)
       */
      subtitle: {
        codename: 'subtitle',
        id: '27264d4e-25bb-4474-87d5-104e22d1dff6',
        externalId: undefined,
        name: '📜 Sub Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Item (modular_content)
       */
      item: {
        codename: 'item',
        id: '7b773b96-8200-4351-9ccf-07f91b8122c7',
        externalId: undefined,
        name: '🔗 Item',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📂 Subitems (modular_content)
       */
      subitems: {
        codename: 'subitems',
        id: '2fc1dec4-9c31-41a3-8e2b-0d0100f08f46',
        externalId: undefined,
        name: '📂 Subitems',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📑🔹Content Group
   * Last modified: Tue Oct 28 2025 02:22:40 GMT+0000 (Coordinated Universal Time)
   */
  contentgroup: {
    codename: 'contentgroup',
    id: '68a8d341-4f48-4882-baab-ac251e8b4741',
    externalId: undefined,
    name: '📑🔹Content Group',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '9a2de5dc-f0a9-46e2-a78c-df11d8079fc7',
        externalId: undefined,
        name: '📜 Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '87d7f488-127e-4da4-ac1a-35cfbd57321a',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content stage specific (modular_content)
       */
      content_staged: {
        codename: 'content_staged',
        id: 'bde51638-005c-478a-82f3-426c064e2524',
        externalId: undefined,
        name: '📜 Content stage specific',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📄 Content Items (modular_content)
       */
      content_items: {
        codename: 'content_items',
        id: '1072dc55-b015-4e24-a594-e64d3fcaaf46',
        externalId: undefined,
        name: '📄 Content Items',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🖇️ Curriculum connections links (modular_content)
       */
      chps_links: {
        codename: 'chps_links',
        id: 'e6bdf052-22b1-45c1-9d0a-a05ecd35725e',
        externalId: undefined,
        name: '🖇️ Curriculum connections links',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '6e2b82f1-90e2-406b-88c4-576da01cbc93',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * 📜 Code (text)
       *
       * ⚠️ Not used
       */
      code: {
        codename: 'code',
        id: '0e18ae2c-3e9f-43d3-90c8-d8ce91c24f1a',
        externalId: undefined,
        name: '📜 Code',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🗃️ ACE Subgroup
   * Last modified: Tue Jun 04 2024 06:28:09 GMT+0000 (Coordinated Universal Time)
   */
  ace_subgroup: {
    codename: 'ace_subgroup',
    id: '2fa95097-8fe3-4727-9a03-4d6645069298',
    externalId: undefined,
    name: '🗃️ ACE Subgroup',
    elements: {
      /**
       * 📜 Code (text)
       */
      code: {
        codename: 'code',
        id: 'd2cc31e6-b650-43a8-b897-506675e6ec25',
        externalId: undefined,
        name: '📜 Code',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '98466976-478c-4e81-832d-12b9b2f4d9c0',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📆 Last updated date (date_time)
       */
      lastupdateddate: {
        codename: 'lastupdateddate',
        id: '660c77c5-88c2-4f23-9b24-0c9ee791d881',
        externalId: undefined,
        name: '📆 Last updated date',
        required: true,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * 📜 Legislative Basis (rich_text)
       */
      legislativebasis: {
        codename: 'legislativebasis',
        id: '275c16f3-ec32-4a94-92d7-c2a9a45f1573',
        externalId: undefined,
        name: '📜 Legislative Basis',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Preamble Title (text)
       */
      preamble_title: {
        codename: 'preamble_title',
        id: '09b6a71d-42ee-45f3-952c-2bceac37f06c',
        externalId: undefined,
        name: '📜 Preamble Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Preamble Content (rich_text)
       *
       * Preamble text that applies to the entire subgroup
       */
      preamble_content: {
        codename: 'preamble_content',
        id: '86fb1b9c-30c4-4a8f-bc1a-25f474ea470c',
        externalId: undefined,
        name: '📜 Preamble Content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🗂️ Rules (modular_content)
       */
      rules: {
        codename: 'rules',
        id: 'b1717461-1004-4bae-89c7-0733bd5b00c7',
        externalId: undefined,
        name: '🗂️ Rules',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 💬 Footnotes (modular_content)
       *
       * Subgroup preamble footnotes
       */
      footnotes: {
        codename: 'footnotes',
        id: '2c24495d-9fb9-4072-94c3-410094c4a154',
        externalId: undefined,
        name: '💬 Footnotes',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔠 Glossary (modular_content)
       */
      glossary: {
        codename: 'glossary',
        id: '9ad6a63c-5ea4-4113-8f6d-206bce9a25d3',
        externalId: undefined,
        name: '🔠 Glossary',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * Stage (taxonomy)
       *
       * ⚠️ CMS field only, not used by the web application.
       */
      stages__stages: {
        codename: 'stages__stages',
        id: '9435534d-8938-4207-89ce-91a131f49561',
        externalId: undefined,
        name: '🏷️ Stages',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       *
       * ⚠️ CMS field only, not used by the web application.
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '5acbf85b-35c2-4299-af12-bd79673cff09',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ CMS field only, not used by the web application. If this rule applies to all syllabuses, select all Key Learning Areas.
       */
      key_learning_area__items: {
        codename: 'key_learning_area__items',
        id: '5b72b340-111b-464d-adea-c914fdc620f5',
        externalId: undefined,
        name: '🏷️ Key learning area',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 Web Page Learning Areas
   * Last modified: Tue Sep 27 2022 08:18:21 GMT+0000 (Coordinated Universal Time)
   */
  wp_learningareas: {
    codename: 'wp_learningareas',
    id: '71664279-a9d4-4589-80fd-5ebabedcadef',
    externalId: undefined,
    name: '🌐 Web Page Learning Areas',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '56489684-f711-4bf9-a4ec-4caf613b2640',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🌐 Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: 'be6d97ca-9f4b-4b5f-a781-7e28647334fb',
        externalId: undefined,
        name: '🌐 Subpages',
        required: true,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 💠 Links (modular_content)
       */
      links: {
        codename: 'links',
        id: 'e449f4e4-0c0b-4c39-bf75-d2cfa521bb5b',
        externalId: undefined,
        name: '💠 Links',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '0cecb70f-fbae-4a0f-9f53-60c60a9e08a6',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },
    },
  },

  /**
   * 📈 Focus Area Continuum
   * Last modified: Thu Oct 26 2023 14:12:09 GMT+0000 (Coordinated Universal Time)
   */
  focusareacontinuum: {
    codename: 'focusareacontinuum',
    id: '919827d5-bc4b-46f3-9e3a-404cca9155ae',
    externalId: undefined,
    name: '📈 Focus Area Continuum',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'fd5688ca-be40-4fab-a362-7d5933a0ffa4',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '99949c96-3b92-4dbf-9266-881290ad74fc',
        externalId: undefined,
        name: '📒 Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Code (text)
       */
      code: {
        codename: 'code',
        id: '283b4c6c-fcd2-4dc0-b3dd-83f4149fc6ef',
        externalId: undefined,
        name: 'Code',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🗂️ ACE Rule
   * Last modified: Wed Feb 18 2026 00:47:32 GMT+0000 (Coordinated Universal Time)
   */
  ace_rule: {
    codename: 'ace_rule',
    id: '4335c1f9-93c9-485e-9408-2effe71e8ba1',
    externalId: undefined,
    name: '🗂️ ACE Rule',
    elements: {
      /**
       * 📜 Code (text)
       *
       * ACE rule numbers, or future numbering system
       */
      code: {
        codename: 'code',
        id: '8c42beaa-226f-4cd3-b66f-0955da097a96',
        externalId: undefined,
        name: '📜 Code',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Rule Title (text)
       *
       * Title of the rule
       */
      title: {
        codename: 'title',
        id: '49dfb32e-0bee-42cb-bf2b-c13e69d7d3e5',
        externalId: undefined,
        name: '📜 Rule Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Preamble Title (text)
       */
      preamble_title: {
        codename: 'preamble_title',
        id: '6cd548b6-932f-43fc-a462-e127fc4d4245',
        externalId: undefined,
        name: '📜 Preamble Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Preamble Content (rich_text)
       */
      preamble_content: {
        codename: 'preamble_content',
        id: '909da403-64e6-4ac6-97fd-d2c7cf3bff83',
        externalId: undefined,
        name: '📜 Preamble Content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📑 Rule content items (modular_content)
       */
      items: {
        codename: 'items',
        id: 'a6fbc87c-da84-4742-8e85-f62ba0db1acd',
        externalId: undefined,
        name: '📑 Rule content items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📦 Resources Containers (modular_content)
       */
      resource_containers: {
        codename: 'resource_containers',
        id: '8bcce6eb-6758-4cea-90d6-e14414016386',
        externalId: undefined,
        name: '📦 Resources Containers',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📦 Resources other (modular_content)
       */
      resources_other: {
        codename: 'resources_other',
        id: 'e76670e7-04e9-493e-933a-9550d2391a3d',
        externalId: undefined,
        name: '📦 Resources other',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🗂️ Related rules (modular_content)
       */
      relatedrules: {
        codename: 'relatedrules',
        id: '519e5a32-3b67-4b7d-82be-023b5536171a',
        externalId: undefined,
        name: '🗂️ Related rules',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📨 Contact (modular_content)
       */
      contact: {
        codename: 'contact',
        id: '3cc85200-ebd8-47c4-be7c-7a678acd7163',
        externalId: undefined,
        name: '📨 Contact',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 💬 Footnotes (modular_content)
       */
      footnotes: {
        codename: 'footnotes',
        id: '9007d7b0-e885-4385-83f4-99a102874eed',
        externalId: undefined,
        name: '💬 Footnotes',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Keywords (text)
       */
      seo_keywords: {
        codename: 'seo_keywords',
        id: 'fd59484c-0fd7-4601-a8db-81d810e2847b',
        externalId: undefined,
        name: '📜 Keywords',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ACE Category (taxonomy)
       */
      ace_category: {
        codename: 'ace_category',
        id: '8ae39783-f004-4972-8282-cac7c065706f',
        externalId: undefined,
        name: '🏷️ ACE Category',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       *
       * ⚠️ CMS field only, not used by the web application.
       */
      stages__stages: {
        codename: 'stages__stages',
        id: '5b54084a-b61f-41d7-8be4-ef25a6173f84',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       *
       * ⚠️ CMS field only, not used by the web application.
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '2480c4e5-449d-4b28-9ec3-f54d1fbf5f7c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ CMS field only, not used by the web application. If this rule applies to all syllabuses, select all Key Learning Areas.
       */
      key_learning_area__items: {
        codename: 'key_learning_area__items',
        id: 'd702c5b4-bd6e-4500-a600-5f80229d5a97',
        externalId: undefined,
        name: '🏷️ Key learning area',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabuses_include__items: {
        codename: 'syllabuses_include__items',
        id: 'ad518b46-6097-4eba-962e-018290102998',
        externalId: undefined,
        name: 'Syllabus',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'syllabuses_include',
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabuses_exclude__items: {
        codename: 'syllabuses_exclude__items',
        id: 'a21fcda4-8cdc-4ed9-9758-304431b0a0c8',
        externalId: undefined,
        name: '🏷️ Exclude syllabuses',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'syllabuses_exclude',
      },
    },
  },

  /**
   * 📑 Access Content Item
   * Last modified: Wed Sep 10 2025 02:12:58 GMT+0000 (Coordinated Universal Time)
   */
  accesscontentitem: {
    codename: 'accesscontentitem',
    id: 'd1986268-7e60-4c13-a398-f875377919aa',
    externalId: undefined,
    name: '📑 Access Content Item',
    elements: {
      /**
       * 📜 Title (rich_text)
       */
      title: {
        codename: 'title',
        id: '4b84a9e6-c5be-4254-895c-9418aebd9452',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Examples (rich_text)
       *
       * Note: Bullet points CANNOT be used in Examples
       */
      examples: {
        codename: 'examples',
        id: 'abe0f6e4-d952-4ecd-b491-01df9279d3ad',
        externalId: undefined,
        name: '📜 Examples',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Including Statements (rich_text)
       */
      including_statements: {
        codename: 'including_statements',
        id: 'b218a884-eef6-4cee-9e54-e3440b6300ca',
        externalId: undefined,
        name: '📜 Including Statements',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '0a8bd8e5-34a9-419e-bde0-8fd6e362462f',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * National Literacy Learning Progression (taxonomy)
       */
      learningprogression_tags__literacy: {
        codename: 'learningprogression_tags__literacy',
        id: '5334fc75-ea6c-4c8b-a236-3e9f5321d6ae',
        externalId: undefined,
        name: '🔖 National Literacy Learning Progression',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'learningprogression_tags',
      },

      /**
       * National Numeracy Learning Progression (taxonomy)
       */
      learningprogression_tags__numeracy: {
        codename: 'learningprogression_tags__numeracy',
        id: '9183d2fe-8fab-4b2c-b51f-c86265f29d33',
        externalId: undefined,
        name: '🔖 National Numeracy Learning Progression',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'learningprogression_tags',
      },

      /**
       * Code (text)
       */
      code: {
        codename: 'code',
        id: '1013fed2-b787-4d20-a266-aa82d4d0587a',
        externalId: undefined,
        name: 'Code',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 Web Page Stage Group
   * Last modified: Mon Jun 23 2025 13:41:23 GMT+0000 (Coordinated Universal Time)
   */
  wp_stagegroup: {
    codename: 'wp_stagegroup',
    id: 'fa1d7210-fafb-4fa2-a5f6-2fa8734a74bf',
    externalId: undefined,
    name: '🌐 Web Page Stage Group',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '754765ad-5d60-42c9-977f-e3869046a948',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🌐 Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: 'f5bc87fd-0ca8-4ece-94e1-99318a984957',
        externalId: undefined,
        name: '🌐 Subpages',
        required: false,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 📒 Syllabuses - DELETE after v23 KLA release (modular_content)
       */
      syllabuses: {
        codename: 'syllabuses',
        id: '0d61cbf2-1d14-4911-b347-b33db984941c',
        externalId: undefined,
        name: '📒 Syllabuses - DELETE after v23 KLA release',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '54511cf9-e768-4f1b-aaa8-9752590d1a5d',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },
    },
  },

  /**
   * 🗒️ ACE Rule Content Item
   * Last modified: Tue Feb 17 2026 01:15:01 GMT+0000 (Coordinated Universal Time)
   */
  ace_ruleitem: {
    codename: 'ace_ruleitem',
    id: '1188ca78-28e0-4d22-94a6-8e387a4bbdf8',
    externalId: undefined,
    name: '🗒️ ACE Rule Content Item',
    elements: {
      /**
       * 📜 Title (text)
       *
       * This will become a section heading within the rule content area
       */
      title: {
        codename: 'title',
        id: '2cb9bc17-8f01-4891-a199-3463b283300a',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: 'f21d63f6-d8f4-4cba-95de-88bb934f658a',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'ad6bb7ea-3c71-4bb8-8f41-02f8ca4aa373',
        externalId: undefined,
        name: '🏷️ Stages',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '926cea31-bcdd-4231-912d-bb3edd6aea52',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ CMS field only, not used by the web application.If this rule applies to all syllabuses, select all Key Learning Areas.
       */
      key_learning_area__items: {
        codename: 'key_learning_area__items',
        id: '04682430-3a43-46d2-8de9-d0913122758b',
        externalId: undefined,
        name: '🏷️ Key learning area',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📑 Access Content Group
   * Last modified: Thu Oct 26 2023 14:12:14 GMT+0000 (Coordinated Universal Time)
   */
  accesscontentgroup: {
    codename: 'accesscontentgroup',
    id: '3107ca09-b0be-46d1-8573-ebf3439f91c1',
    externalId: undefined,
    name: '📑 Access Content Group',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '4c8258b5-58f5-4022-a286-6ad2166e7192',
        externalId: undefined,
        name: '📜 Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📄 Access Content Items (modular_content)
       */
      access_content_items: {
        codename: 'access_content_items',
        id: 'e0d7dd7b-dde7-4241-9e3c-4910d95ed598',
        externalId: undefined,
        name: '📄 Access Content Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '9660d4cf-2287-44e5-9490-3c6f963d6e05',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Code (text)
       */
      code: {
        codename: 'code',
        id: 'cfa8526e-4726-4134-92fc-e59c3f9425aa',
        externalId: undefined,
        name: 'Code',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Collection
   * Last modified: Wed Sep 28 2022 12:33:58 GMT+0000 (Coordinated Universal Time)
   */
  ui_collection: {
    codename: 'ui_collection',
    id: '16b8d520-01af-4168-8f4b-a9350df90b38',
    externalId: undefined,
    name: '💠 Web UI Collection',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '029c354b-7fac-4840-b0c1-bc864362908e',
        externalId: undefined,
        name: '📜 Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📂 Items (modular_content)
       */
      items: {
        codename: 'items',
        id: 'b3a23e69-887e-485f-863d-6d013ab337fd',
        externalId: undefined,
        name: '📂 Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🎨 Tile colour (multiple_choice)
       */
      tile_colour: {
        codename: 'tile_colour',
        id: '9c9a7d31-c0f8-4eef-8adf-c6db0cc6e8a0',
        externalId: undefined,
        name: '🎨 Tile colour',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 Web Page Glossary
   * Last modified: Tue Jun 24 2025 02:44:10 GMT+0000 (Coordinated Universal Time)
   */
  wp_glossary: {
    codename: 'wp_glossary',
    id: 'd8ab15c7-2b8b-42c9-9c3d-b97af6d45d0d',
    externalId: undefined,
    name: '🌐 Web Page Glossary',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '5436afa8-13ac-417e-bdd5-b3e733923b47',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🌐 Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: '52fd7578-72e4-4c4a-b35f-6c7a5f359ae3',
        externalId: undefined,
        name: '🌐 Subpages',
        required: false,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '4f3420e0-c9a3-442b-b618-984de87d4677',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 🖇️ Show in-page navigation (multiple_choice)
       */
      show_in_page_navigation: {
        codename: 'show_in_page_navigation',
        id: '5cf7e5cb-6831-4bcd-99ed-8e5a7df6c3b0',
        externalId: undefined,
        name: '🖇️ Show in-page navigation',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect Url (text)
       */
      redirect_url: {
        codename: 'redirect_url',
        id: 'd0155963-b179-4341-8894-7c42c2fda4cf',
        externalId: undefined,
        name: '🔗 Redirect Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠Web UI Video Tiles
   * Last modified: Tue Sep 27 2022 07:58:01 GMT+0000 (Coordinated Universal Time)
   */
  ui_video_tiles: {
    codename: 'ui_video_tiles',
    id: '7126e06b-d8f9-4e1b-be76-60d21110dad1',
    externalId: undefined,
    name: '💠Web UI Video Tiles',
    elements: {
      /**
       * 📜 Items (modular_content)
       */
      items: {
        codename: 'items',
        id: '43ae5e34-7cb8-4e9e-89a1-fb511fd45a06',
        externalId: undefined,
        name: '📜 Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Cards
   * Last modified: Thu Jul 24 2025 08:52:02 GMT+0000 (Coordinated Universal Time)
   */
  ui_cards: {
    codename: 'ui_cards',
    id: '5b5eff72-86c1-40a9-bf0a-ff06fdc6010b',
    externalId: undefined,
    name: '💠 Web UI Cards',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '017a7e95-9be3-4a82-bae9-4dc50b5b6cf5',
        externalId: undefined,
        name: '📜 Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Items (modular_content)
       */
      items: {
        codename: 'items',
        id: '72553524-4204-4955-a97d-7e28dc99c843',
        externalId: undefined,
        name: '📜 Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Display (multiple_choice)
       */
      display: {
        codename: 'display',
        id: '59b3242c-ed12-48b0-8afb-6d3de6ccba16',
        externalId: undefined,
        name: '⚙️ Display',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🎨 Theme (multiple_choice)
       */
      theme: {
        codename: 'theme',
        id: '9081c785-e970-403d-9106-fe30d20a5037',
        externalId: undefined,
        name: '🎨 Theme',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🔗 Web Link External
   * Last modified: Mon Dec 08 2025 06:23:52 GMT+0000 (Coordinated Universal Time)
   */
  weblinkext: {
    codename: 'weblinkext',
    id: 'c6e5c373-97a2-4215-be00-1fee2f045e0e',
    externalId: undefined,
    name: '🔗 Web Link External',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'dff5fa00-8ec2-4dd9-a9ae-e70b75a96af4',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Sub Title (text)
       */
      subtitle: {
        codename: 'subtitle',
        id: '1e5aad05-24ec-4cbe-8807-2f70dbaef18a',
        externalId: undefined,
        name: '📜 Sub Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Link Url (text)
       */
      link_url: {
        codename: 'link_url',
        id: 'a25e6d24-fc3c-47e1-bb36-a6d285e385c7',
        externalId: undefined,
        name: '🔗 Link Url',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Resource type (taxonomy)
       */
      resource_type: {
        codename: 'resource_type',
        id: 'e2904483-ad1e-4a76-b9b9-48d9585a7980',
        externalId: undefined,
        name: '🏷️ Resource Type',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 🏷️ Syllabus wide (multiple_choice)
       */
      syllabuswide: {
        codename: 'syllabuswide',
        id: '2caa1e51-e4db-4945-b009-2e17df7a9205',
        externalId: undefined,
        name: '🏷️ Syllabus wide',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '78de8a11-e7ec-4a1e-9ccb-a58949991a74',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       */
      syllabus_type: {
        codename: 'syllabus_type',
        id: 'dbbfabe1-277d-4918-8f94-5995e6fd18ea',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Note that Multiple KLA option should only be used in Canonical KLA field.
       */
      key_learning_area__items: {
        codename: 'key_learning_area__items',
        id: 'd4be49ed-5b70-4bf1-8396-c4c4ba8a1877',
        externalId: undefined,
        name: 'Key Learning Area',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'key_learning_area',
      },

      /**
       * 📆 Updated (date_time)
       */
      updated: {
        codename: 'updated',
        id: 'ba1560d9-c413-4b45-885f-36f80529fe0c',
        externalId: undefined,
        name: '📆 Updated',
        required: false,
        type: 'date_time',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🔠 Glossary
   * Last modified: Mon Feb 17 2025 23:28:33 GMT+0000 (Coordinated Universal Time)
   */
  glossary: {
    codename: 'glossary',
    id: '6e8ddfc7-87a9-4e46-84fd-56b17c934704',
    externalId: undefined,
    name: '🔠 Glossary',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '4b8b535f-139b-4a23-9f35-7d07113f2541',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (rich_text)
       */
      description: {
        codename: 'description',
        id: '631b5158-e8e3-449a-9f69-695a7033fd38',
        externalId: undefined,
        name: '📜 Description',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: 'c8536783-d458-46d7-8dea-d8e8fb2dedaf',
        externalId: undefined,
        name: '🏷️ Related Syllabuses',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Glossary Type (taxonomy)
       */
      type: {
        codename: 'type',
        id: 'caa5d750-6f6b-46b7-a69e-1384854dc452',
        externalId: undefined,
        name: '🏷️ Glossary Type',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * ACE Category (taxonomy)
       */
      ace_category: {
        codename: 'ace_category',
        id: 'e80190e9-ea81-49df-8640-0f9cb0751602',
        externalId: undefined,
        name: '🏷️ ACE Category',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title System (text)
       *
       * ⚠️ This is a hidden field that is never displayed to users e.g. an alternative version that would be used for sorting and filtering only.
       */
      title_system: {
        codename: 'title_system',
        id: 'e7ded6d2-f516-4ad9-8dee-c4399d883f9a',
        externalId: undefined,
        name: '📜 Title System',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Code (text)
       */
      code: {
        codename: 'code',
        id: 'b59ef167-44aa-470a-a67a-0ca52e3652fa',
        externalId: undefined,
        name: 'Code',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: 'f338cfde-cc81-490c-9ddd-877d345da052',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: '35ecfe8d-5187-4766-a903-66157fb40fc4',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌏 Homepage
   * Last modified: Tue Jun 23 2026 16:01:49 GMT+0000 (Coordinated Universal Time)
   */
  wp_homepage: {
    codename: 'wp_homepage',
    id: 'abeaab42-5c6f-4411-92e5-3fb2d33246b9',
    externalId: undefined,
    name: '🌏 Homepage',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '440ee774-89ed-4df9-946c-b7483b5a5b8b',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Subtitle (text)
       */
      subtitle: {
        codename: 'subtitle',
        id: '6cc0bef7-fe6d-478c-b704-8003813e619d',
        externalId: undefined,
        name: '📜 Subtitle',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content Panel (rich_text)
       */
      content_panel: {
        codename: 'content_panel',
        id: '42b9587e-bfc8-4910-9dc0-9b977f654925',
        externalId: undefined,
        name: '📜 Content Panel',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🌐 Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: '14cf2042-90a5-43aa-90c4-0debe407d8cb',
        externalId: undefined,
        name: '🌐 Subpages',
        required: false,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 📂 Main Menu (modular_content)
       */
      main_menu: {
        codename: 'main_menu',
        id: '74f7eb26-2d7c-45cf-833c-e83254280fda',
        externalId: undefined,
        name: '📂 Main Menu',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 💠 Global announcement - top (modular_content)
       *
       * ℹ️ For example Caretaker period alert. Only content fields will be displayed.
       */
      global_info: {
        codename: 'global_info',
        id: '86469d6c-6ff8-44dc-a1c2-24c1a0485ad7',
        externalId: undefined,
        name: '💠 Global announcement - top',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 💠 Global notification - ACE (modular_content)
       */
      global_alert_ace: {
        codename: 'global_alert_ace',
        id: '1cf533bf-7bfe-4a77-b678-6f04b15bc5bf',
        externalId: undefined,
        name: '💠 Global notification - ACE',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 💠 Global notification (modular_content)
       *
       * Other global infofmation notifications. All fileds can be used e.g. content and primary/secondary buttons.
       */
      global_alert: {
        codename: 'global_alert',
        id: '9eb73590-f53a-447c-9f2d-9270e62aeb2f',
        externalId: undefined,
        name: '💠 Global notification',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📂 Menu links (modular_content)
       *
       * Footer menu links
       */
      footer_menu_links: {
        codename: 'footer_menu_links',
        id: 'dd95ce4c-8c7c-4694-8767-442f352f9175',
        externalId: undefined,
        name: '📂 Menu links',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🗒️ K-10 Syllabus Outcomes - Related outcomes (rich_text)
       */
      syllabusoutcomes_relatedoutomes: {
        codename: 'syllabusoutcomes_relatedoutomes',
        id: '256133ed-2561-4935-8519-8201d9062582',
        externalId: undefined,
        name: '🗒️ K-10 Syllabus Outcomes - Related outcomes',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🗒️ S6 MS Syllabus Outcomes - Related outcomes (rich_text)
       */
      syllabussenioroutcomes_relatedoutomes: {
        codename: 'syllabussenioroutcomes_relatedoutomes',
        id: 'f350c845-6511-4039-a1ba-e2cd69317f86',
        externalId: undefined,
        name: '🗒️ S6 MS Syllabus Outcomes - Related outcomes',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🗒️ S6 LS Syllabus Outcomes - Related outcomes (rich_text)
       */
      syllabussenioroutcomes_relatedoutomes_ls: {
        codename: 'syllabussenioroutcomes_relatedoutomes_ls',
        id: '2b25c4ea-e042-4933-aa91-63387df2bea4',
        externalId: undefined,
        name: '🗒️ S6 LS Syllabus Outcomes - Related outcomes',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🗒️ Syllabus Outcomes - Aligned content (rich_text)
       */
      syllabusoutcomes_alignedcontent: {
        codename: 'syllabusoutcomes_alignedcontent',
        id: '59c7bf32-a768-47ac-b3a3-a968b7734429',
        externalId: undefined,
        name: '🗒️ Syllabus Outcomes - Aligned content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       *
       * Footer top content
       */
      footer_top_content: {
        codename: 'footer_top_content',
        id: '119acf47-b530-48a0-9fea-670f60ffd86a',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Social Links (modular_content)
       */
      social_links: {
        codename: 'social_links',
        id: '13d6ef58-2119-4ab3-9243-7196bcf2116e',
        externalId: undefined,
        name: '🔗 Social Links',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Acknowledgement (rich_text)
       *
       * Appears in the footer bottom
       */
      acknowledgement: {
        codename: 'acknowledgement',
        id: '4255b49e-e8f2-46df-9d19-a022fa34d5aa',
        externalId: undefined,
        name: '📜 Acknowledgement',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📂 Secondary links (modular_content)
       */
      secondary_links: {
        codename: 'secondary_links',
        id: '06820a17-3cbd-41d5-a269-33702919e99b',
        externalId: undefined,
        name: '📂 Secondary links',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📂 Copyright link (modular_content)
       */
      copyright_link: {
        codename: 'copyright_link',
        id: 'dd60dad0-09f1-4d30-9363-a3aa25b05764',
        externalId: undefined,
        name: '📂 Copyright link',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📦 Logo main (asset)
       */
      logo_main: {
        codename: 'logo_main',
        id: '0bc1c95d-1473-4b00-bb79-00e4919d3e07',
        externalId: undefined,
        name: '📦 Logo main',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * 📜 Site Title (text)
       *
       * Leave empty, if you don't want any site prefix
       */
      site_prefix: {
        codename: 'site_prefix',
        id: '5190cd96-3843-45ce-b3b0-7af96d3b1da6',
        externalId: undefined,
        name: '📜 Site Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📦 Favicon (asset)
       */
      favicon: {
        codename: 'favicon',
        id: '002e759f-e652-43e3-b6d1-8f28316fd35f',
        externalId: undefined,
        name: '📦 Favicon',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * 📜 Descriptor (text)
       *
       * Used as site descriptor
       */
      descriptor: {
        codename: 'descriptor',
        id: 'edbae2c6-d181-4c57-873a-15eca4fbeef1',
        externalId: undefined,
        name: '📜 Descriptor',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Palette (multiple_choice)
       */
      palette: {
        codename: 'palette',
        id: '42a61211-458e-4cb9-a6b4-8d00824cef27',
        externalId: undefined,
        name: '⚙️ Palette',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       */
      disabled_stages: {
        codename: 'disabled_stages',
        id: 'e04c00d8-f4fc-4977-b39b-d5b8efcbd039',
        externalId: undefined,
        name: '⚙️ Disabled Stages',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       */
      disabled_key_learning_areas: {
        codename: 'disabled_key_learning_areas',
        id: 'be606747-db13-44af-b885-ed89c20ef6f1',
        externalId: undefined,
        name: '⚙️ Disabled Key Learning Areas',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 💠Hero banner (modular_content)
       */
      hero_banner: {
        codename: 'hero_banner',
        id: '86b4ae66-cb11-4e42-956b-eda491a666eb',
        externalId: undefined,
        name: '💠Hero banner',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 💠Stages (modular_content)
       */
      stages: {
        codename: 'stages',
        id: 'da483490-e187-489b-b503-6b2f44bd3bbc',
        externalId: undefined,
        name: '💠Stages',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 💠Learning areas (modular_content)
       */
      learning_areas: {
        codename: 'learning_areas',
        id: 'f2c0a6f9-914b-4ec0-bb17-d5a0f7ada5f7',
        externalId: undefined,
        name: '💠Learning areas',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 💠Teaching and learning (modular_content)
       */
      teaching_and_learning: {
        codename: 'teaching_and_learning',
        id: '86751c7b-7025-427d-b8d0-3591588ef0b5',
        externalId: undefined,
        name: '💠Teaching and learning',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 💠ACE Rules (modular_content)
       */
      ace_rules: {
        codename: 'ace_rules',
        id: '57c5b650-750a-4604-8492-62e268564881',
        externalId: undefined,
        name: '💠ACE Rules',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 💠Links (modular_content)
       */
      links: {
        codename: 'links',
        id: 'c3d01b68-1cec-420a-bc8f-bbb0b49fca2a',
        externalId: undefined,
        name: '💠Links',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🗒️ Syllabus Content - Parallel content (rich_text)
       */
      syllabuscontent_parallelcontent: {
        codename: 'syllabuscontent_parallelcontent',
        id: '8eddde4b-1a4a-490f-ab19-b9109015d96d',
        externalId: undefined,
        name: '🗒️ Syllabus Content - Parallel content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 No content - parallel content (text)
       */
      nocontent_parallelcontent: {
        codename: 'nocontent_parallelcontent',
        id: '1e9e5787-bc68-4ad6-80a7-d54423cb0770',
        externalId: undefined,
        name: '📜 No content - parallel content',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI List items
   * Last modified: Thu Jun 30 2022 03:28:03 GMT+0000 (Coordinated Universal Time)
   */
  ui_listitems: {
    codename: 'ui_listitems',
    id: 'f03af4bc-f09e-405a-8fa6-937a184818a7',
    externalId: undefined,
    name: '💠 Web UI List items',
    elements: {
      /**
       * 📜 Items (modular_content)
       */
      items: {
        codename: 'items',
        id: 'bb533a51-650f-44bf-8ddf-3497c12aadf7',
        externalId: undefined,
        name: '📜 Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Display (multiple_choice)
       */
      display: {
        codename: 'display',
        id: '738c508f-953a-4c01-b0a3-c85167dbd3c9',
        externalId: undefined,
        name: '⚙️ Display',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🔹 Custom Editor (math/smallcaps)
   * Last modified: Tue Dec 16 2025 06:24:09 GMT+0000 (Coordinated Universal Time)
   */
  math_content: {
    codename: 'math_content',
    id: '8381338d-fc89-4726-9fe6-bbcbf8cf3410',
    externalId: undefined,
    name: '🔹 Custom Editor (math/smallcaps)',
    elements: {
      /**
       * 📜 Content (custom)
       */
      content: {
        codename: 'content',
        id: 'a5bdbdde-3455-48ed-b98e-921f362adc06',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'custom',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 WebPage Teaching Resources
   * Last modified: Tue Jun 24 2025 02:44:28 GMT+0000 (Coordinated Universal Time)
   */
  wp_resources: {
    codename: 'wp_resources',
    id: '214f5fcd-b244-45aa-bc0f-9b8691c2881d',
    externalId: undefined,
    name: '🌐 WebPage Teaching Resources',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '98f4faa6-da3f-46c4-94d9-36b1a565d858',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: 'fa38cfcb-fa8f-4f37-9849-e56e93c14462',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 🖇️ Show in-page navigation (multiple_choice)
       */
      show_in_page_navigation: {
        codename: 'show_in_page_navigation',
        id: '9fe66be0-2b50-428e-9c93-7e912a453ce2',
        externalId: undefined,
        name: '🖇️ Show in-page navigation',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect Url (text)
       */
      redirect_url: {
        codename: 'redirect_url',
        id: '543d5d38-bcf8-4579-8e74-59131f6b91b3',
        externalId: undefined,
        name: '🔗 Redirect Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠Web UI Horizontal Line
   * Last modified: Fri Aug 12 2022 03:31:17 GMT+0000 (Coordinated Universal Time)
   */
  ui_horizontal_line: {
    codename: 'ui_horizontal_line',
    id: '43cf7b71-c17d-4d36-ac77-077db02dd4cb',
    externalId: undefined,
    name: '💠Web UI Horizontal Line',
    elements: {},
  },

  /**
   * 🌐 Web Page Custom Download
   * Last modified: Sun Sep 21 2025 23:25:40 GMT+0000 (Coordinated Universal Time)
   */
  wp_custom_view: {
    codename: 'wp_custom_view',
    id: '211fd9e6-a8ab-486f-8ba5-e776b5cc8d97',
    externalId: undefined,
    name: '🌐 Web Page Custom Download',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'cd776aba-8c2a-4fee-879c-1361db43a895',
        externalId: undefined,
        name: '📜 Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 📜 Content - Download syllabus tab (rich_text)
       */
      content_custom_download_tab: {
        codename: 'content_custom_download_tab',
        id: '1388e885-5c45-49ea-88d6-f27e85ecbe02',
        externalId: undefined,
        name: '📜 Content - Download syllabus tab',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content - Custom view tab (rich_text)
       */
      content_custom_view_tab: {
        codename: 'content_custom_view_tab',
        id: '7a293857-f32a-435a-ae71-e61f7b756e00',
        externalId: undefined,
        name: '📜 Content - Custom view tab',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '538a7831-0cde-454a-bcbf-ee64127be750',
        externalId: undefined,
        name: 'Slug',
        required: false,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 🖇️ Show in-page navigation (multiple_choice)
       */
      show_in_page_navigation: {
        codename: 'show_in_page_navigation',
        id: '9e9bdf35-3e80-4e53-8e27-ad33dc345eb5',
        externalId: undefined,
        name: '🖇️ Show in-page navigation',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: 'e476a88e-ca42-43f3-afa1-dd0d73acb307',
        externalId: undefined,
        name: 'Subpages',
        required: false,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect Url (text)
       */
      redirect_url: {
        codename: 'redirect_url',
        id: '6f38d267-362b-4f6d-9afa-9d391f987cf2',
        externalId: undefined,
        name: '🔗 Redirect Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠Web UI Video Tile
   * Last modified: Wed Feb 18 2026 00:55:57 GMT+0000 (Coordinated Universal Time)
   */
  ui_video_tile: {
    codename: 'ui_video_tile',
    id: 'f6b03424-43e0-4428-b996-25c945816f27',
    externalId: undefined,
    name: '💠Web UI Video Tile',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '4d991140-89b8-4144-9620-111a930d2b93',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Caption (rich_text)
       */
      caption: {
        codename: 'caption',
        id: 'fe358400-402a-4068-9815-8bff49d83c07',
        externalId: undefined,
        name: '📜 Caption',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📅 Date (date_time)
       */
      date: {
        codename: 'date',
        id: '6d451270-9c58-4935-be27-4a4d0af7904e',
        externalId: undefined,
        name: '📅 Date',
        required: false,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * 📦 Transcript (modular_content)
       */
      transcript_container: {
        codename: 'transcript_container',
        id: '3d741c55-a7a7-4f80-8e6c-6e602aef2971',
        externalId: undefined,
        name: '📦 Transcript',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Video Url (text)
       */
      video_url: {
        codename: 'video_url',
        id: '94cc7b29-c7bf-4eae-9f36-94a9a1867453',
        externalId: undefined,
        name: '🔗 Video Url',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📦 Thumbnail (asset)
       */
      thumbnail: {
        codename: 'thumbnail',
        id: '03f4f51a-b109-4f3e-b93d-dc82e6fbfe1d',
        externalId: undefined,
        name: '📦 Thumbnail',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       */
      key_learning_area: {
        codename: 'key_learning_area',
        id: '8e525e2a-21c9-465b-95fd-0677dd2811aa',
        externalId: undefined,
        name: '🏷️ Key Learning Area',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '0fd57f30-8a56-4f02-93f5-4c099a52b700',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📜 Content Rich Text
   * Last modified: Tue Dec 17 2024 02:44:09 GMT+0000 (Coordinated Universal Time)
   */
  contentrichtext: {
    codename: 'contentrichtext',
    id: 'f1f6162f-48ea-4860-8a53-9fc030ff8b51',
    externalId: undefined,
    name: '📜 Content Rich Text',
    elements: {
      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '0126fa89-080d-46e3-9c14-c19e2bea0435',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       */
      stages: {
        codename: 'stages',
        id: '9ed13d63-fe86-4ccc-99a7-868388da5c15',
        externalId: undefined,
        name: '🏷️ Stages',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       */
      stage_years: {
        codename: 'stage_years',
        id: '0d4e4afb-a4d8-4f12-bbfa-f6de5bb9855f',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '04095799-08cb-4c43-9384-00befd94511f',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📄🔹Content Item
   * Last modified: Wed Sep 10 2025 02:08:59 GMT+0000 (Coordinated Universal Time)
   */
  contentitem: {
    codename: 'contentitem',
    id: '0bd86ad0-4862-477a-8a26-3939651ff455',
    externalId: undefined,
    name: '📄🔹Content Item',
    elements: {
      /**
       * 📜 Title (rich_text)
       */
      title: {
        codename: 'title',
        id: 'a822897f-771b-46ee-88ac-daf436ddfc2c',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Examples (rich_text)
       *
       * Note: Bullet points CANNOT be used in Examples
       */
      examples: {
        codename: 'examples',
        id: '4d26b171-54a8-45e4-9975-962ff4229d80',
        externalId: undefined,
        name: '📜 Examples',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Language example variants (modular_content)
       */
      examples_lang: {
        codename: 'examples_lang',
        id: '608290ab-4aab-43fb-9c99-1332c198b715',
        externalId: undefined,
        name: '📜 Language example variants',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Including Statements (rich_text)
       */
      including_statements: {
        codename: 'including_statements',
        id: 'cfbf91e9-7f9f-4c3d-8423-90e25b54e1f7',
        externalId: undefined,
        name: '📜 Including Statements',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '941089ee-4fb7-4d1a-9b41-a09d26142b0d',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Pathways (taxonomy)
       */
      pathway__pathway: {
        codename: 'pathway__pathway',
        id: 'f30d20f5-beeb-4511-8b34-0d2106b74dc5',
        externalId: undefined,
        name: '🏷️Pathway',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'pathway',
      },

      /**
       * National Literacy Learning Progression (taxonomy)
       */
      learningprogression_tags__literacy: {
        codename: 'learningprogression_tags__literacy',
        id: '5334fc75-ea6c-4c8b-a236-3e9f5321d6ae',
        externalId: undefined,
        name: '🔖 National Literacy Learning Progression',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'learningprogression_tags',
      },

      /**
       * National Numeracy Learning Progression (taxonomy)
       */
      learningprogression_tags__numeracy: {
        codename: 'learningprogression_tags__numeracy',
        id: '9183d2fe-8fab-4b2c-b51f-c86265f29d33',
        externalId: undefined,
        name: '🔖 National Numeracy Learning Progression',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'learningprogression_tags',
      },

      /**
       * 📜 Code (text)
       */
      code: {
        codename: 'code',
        id: '674ea232-b0e4-4e44-8125-c5f3f3f52f49',
        externalId: undefined,
        name: '📜 Code',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📃 Assessment - NOT USED
   * Last modified: Mon Mar 09 2026 03:34:33 GMT+0000 (Coordinated Universal Time)
   */
  assessment: {
    codename: 'assessment',
    id: '82ff2d1f-e448-4b9c-9ce3-6bcef211c5d2',
    externalId: undefined,
    name: '📃 Assessment - NOT USED',
    elements: {
      /**
       * 📜 Introduction (rich_text)
       */
      introduction: {
        codename: 'introduction',
        id: 'ac7a1534-772c-4f20-9ba1-132dd29047d5',
        externalId: undefined,
        name: '📜 Introduction',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Common grade scale (rich_text)
       */
      commongradescale: {
        codename: 'commongradescale',
        id: 'b380f520-0f77-4e3a-8772-802eeccd4407',
        externalId: undefined,
        name: '📜 Common grade scale',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Course performance descriptions (CPDs) (rich_text)
       */
      courseperformancedescriptions: {
        codename: 'courseperformancedescriptions',
        id: 'd3bb5a8c-f58d-4a19-9357-39afd322ff5b',
        externalId: undefined,
        name: '📜 Course performance descriptions (CPDs)',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Life skills (rich_text)
       */
      lifeskills: {
        codename: 'lifeskills',
        id: '13a70006-f92d-4228-82fd-73722c3ccdf5',
        externalId: undefined,
        name: '📜 Life skills',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Other information (rich_text)
       */
      otherinformation: {
        codename: 'otherinformation',
        id: 'b8bca412-2c4a-4866-bdc3-2a0033ce7776',
        externalId: undefined,
        name: '📜 Other information',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Related ACE rules (rich_text)
       *
       * ACE rules (Phase 3).
       */
      relatedacerules: {
        codename: 'relatedacerules',
        id: '4d8f1e07-5979-4cd9-81b9-c4a689403ee2',
        externalId: undefined,
        name: '📜 Related ACE rules',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Supporting text (modular_content)
       */
      pbd_supportingtext: {
        codename: 'pbd_supportingtext',
        id: 'c7ab7634-cd5f-47ed-993c-cc40b0641ce9',
        externalId: undefined,
        name: '📜 Supporting text',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Performance band descriptors (PBD) 6 (rich_text)
       */
      pbd_6: {
        codename: 'pbd_6',
        id: 'd5afdebd-9c74-4f4c-8d0c-e32fa36b3c2b',
        externalId: undefined,
        name: '📜 Performance band descriptors (PBD) 6',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Performance band descriptors (PBD) 5 (rich_text)
       */
      pbd_5: {
        codename: 'pbd_5',
        id: '7ceb124a-986a-47ee-8b0a-3576c9f74858',
        externalId: undefined,
        name: '📜 Performance band descriptors (PBD) 5',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Performance band descriptors (PBD) 4 (rich_text)
       */
      pbd_4: {
        codename: 'pbd_4',
        id: 'ddf73ff4-ff4e-400e-9845-f450a5e380b5',
        externalId: undefined,
        name: '📜 Performance band descriptors (PBD) 4',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Performance band descriptors (PBD) 3 (rich_text)
       */
      pbd_3: {
        codename: 'pbd_3',
        id: '0df7afdc-4169-444e-a781-e984e962cf4f',
        externalId: undefined,
        name: '📜 Performance band descriptors (PBD) 3',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Performance band descriptors (PBD) 2 (rich_text)
       */
      pbd_2: {
        codename: 'pbd_2',
        id: 'db720062-8ee4-405c-a3da-4a60158eac08',
        externalId: undefined,
        name: '📜 Performance band descriptors (PBD) 2',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Performance band descriptors (PBD) 1 (modular_content)
       */
      performance_band_descriptors__pbd__1: {
        codename: 'performance_band_descriptors__pbd__1',
        id: 'ff1c147f-a4b7-40cc-8e6c-a9d530883ad8',
        externalId: undefined,
        name: '📜 Performance band descriptors (PBD) 1',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Supporting text (modular_content)
       */
      examspec_supportingtext: {
        codename: 'examspec_supportingtext',
        id: 'c27dfa29-4350-4cb2-98e3-dcd7dc38909e',
        externalId: undefined,
        name: '📜 Supporting text',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 HSC specification (rich_text)
       */
      examspec_hscspecification: {
        codename: 'examspec_hscspecification',
        id: '7d90d7be-c549-4af8-8c46-28d528a109b9',
        externalId: undefined,
        name: '📜 HSC specification',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Sample material (rich_text)
       */
      examspec_samplematerial: {
        codename: 'examspec_samplematerial',
        id: 'b15a95c1-9c68-41ea-a457-a77d860f571f',
        externalId: undefined,
        name: '📜 Sample material',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Supporting text (modular_content)
       */
      majorwork_supportingtext: {
        codename: 'majorwork_supportingtext',
        id: '29799ad6-d1fe-4444-9b40-e3fbad610896',
        externalId: undefined,
        name: '📜 Supporting text',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Advice (rich_text)
       */
      majorwork_advice: {
        codename: 'majorwork_advice',
        id: '3c486b18-c214-492a-a730-b5ffa8f13489',
        externalId: undefined,
        name: '📜 Advice',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Supporting text (modular_content)
       */
      sba_supportingtext: {
        codename: 'sba_supportingtext',
        id: '4be0ca4b-cbb3-4689-b052-19b0056aa3cd',
        externalId: undefined,
        name: '📜 Supporting text',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 SBA - 11 (rich_text)
       */
      sba_11: {
        codename: 'sba_11',
        id: 'aa762c75-12d6-47d7-b02c-3fb11a783de3',
        externalId: undefined,
        name: '📜 SBA - 11',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 SBA - 12 (rich_text)
       */
      sba_12: {
        codename: 'sba_12',
        id: '0e40d2e1-204f-4936-8a86-3757d7f542b0',
        externalId: undefined,
        name: '📜 SBA - 12',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Supporting text: Assessment requirements (modular_content)
       */
      assessmentrequirements_supportingtext: {
        codename: 'assessmentrequirements_supportingtext',
        id: '4136ce49-02e6-48ae-a1d7-cdb9b6cfb2c9',
        externalId: undefined,
        name: '📜 Supporting text: Assessment requirements',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Assessment requirements (rich_text)
       */
      assessmentrequirements: {
        codename: 'assessmentrequirements',
        id: '440f86a1-238f-4a17-8221-b1a813dccc2f',
        externalId: undefined,
        name: '📜 Assessment requirements',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Supporting text (modular_content)
       */
      hsc_supportingtext: {
        codename: 'hsc_supportingtext',
        id: '9d4e3803-4a65-44aa-98f0-dfd779ed4f33',
        externalId: undefined,
        name: '📜 Supporting text',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 HSC examinations (rich_text)
       */
      hsc_examinations: {
        codename: 'hsc_examinations',
        id: '030152dc-118f-4932-9437-2c218a613ab6',
        externalId: undefined,
        name: '📜 HSC examinations',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '0d8f7634-58ff-4643-8413-050f2814c6c4',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 Web Page Stage
   * Last modified: Wed Jul 06 2022 06:34:05 GMT+0000 (Coordinated Universal Time)
   */
  wp_stage: {
    codename: 'wp_stage',
    id: '7f13920c-c08d-4402-af94-3db871391804',
    externalId: undefined,
    name: '🌐 Web Page Stage',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'f9d5c813-6a6a-4448-9363-8ea67c094adf',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🌐 Syllabuses (modular_content)
       */
      syllabuses: {
        codename: 'syllabuses',
        id: 'c61586bf-4145-4fae-8df7-c5c32640a234',
        externalId: undefined,
        name: '🌐 Syllabuses',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '7928dc99-4927-446e-8e26-a31a272609f9',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },
    },
  },

  /**
   * 💠Web UI Card Newsletter Subscription
   * Last modified: Tue Sep 27 2022 07:57:05 GMT+0000 (Coordinated Universal Time)
   */
  ui_card_newsletter_subscription: {
    codename: 'ui_card_newsletter_subscription',
    id: '4de60c50-569c-4dc1-bb4b-b77286f80ef5',
    externalId: undefined,
    name: '💠Web UI Card Newsletter Subscription',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '10f0625e-05e2-40a7-ad2f-7838735c3cb9',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Input Label (text)
       */
      input_label: {
        codename: 'input_label',
        id: 'bce05436-3b98-4411-9a46-dc14c63a4b90',
        externalId: undefined,
        name: '📜 Input Label',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Button Label (text)
       */
      button_label: {
        codename: 'button_label',
        id: '90dfa831-b68c-4155-8c20-6cda181ec577',
        externalId: undefined,
        name: '📜 Button Label',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ CreateSend Id (text)
       */
      createsend_id: {
        codename: 'createsend_id',
        id: '587040de-fc36-44d2-94bb-c235c678a1a8',
        externalId: undefined,
        name: '⚙️ CreateSend Id',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ CreateSend Action (text)
       */
      createsend_action: {
        codename: 'createsend_action',
        id: '1eeaf937-e7ff-477a-bee6-6cb09dd85fa9',
        externalId: undefined,
        name: '⚙️ CreateSend Action',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠Web UI Link List
   * Last modified: Thu Oct 13 2022 03:13:53 GMT+0000 (Coordinated Universal Time)
   */
  ui_link_list: {
    codename: 'ui_link_list',
    id: '8a14a616-1a42-4eff-9201-7dfd9a5df234',
    externalId: undefined,
    name: '💠Web UI Link List',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'a7754896-2160-4104-857a-9a03d68cd8b3',
        externalId: undefined,
        name: '📜 Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📂 Items (modular_content)
       */
      items: {
        codename: 'items',
        id: '732e7560-c6b2-4d02-a279-8c66eb17c0cb',
        externalId: undefined,
        name: '📂 Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Columns (multiple_choice)
       */
      columns: {
        codename: 'columns',
        id: '3d85c580-e788-4856-9458-37c663c98106',
        externalId: undefined,
        name: '⚙️ Columns',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🛠️ Print Configuration
   * Last modified: Tue May 26 2026 08:45:18 GMT+0000 (Coordinated Universal Time)
   */
  printconfiguration: {
    codename: 'printconfiguration',
    id: 'fb8e73bd-950a-4666-9ee6-2bdfd57ffa84',
    externalId: undefined,
    name: '🛠️ Print Configuration',
    elements: {
      /**
       * 🎴 Logo (asset)
       */
      logo: {
        codename: 'logo',
        id: 'f130953f-bb34-4645-aea1-e2848f21137d',
        externalId: undefined,
        name: '🎴 Logo',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * 📜 Document title (text)
       */
      document_title: {
        codename: 'document_title',
        id: '6bc88b2f-94aa-4e83-9e9b-17b5e6c8ead7',
        externalId: undefined,
        name: '📜 Document title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Copyright information (rich_text)
       */
      copyright_information: {
        codename: 'copyright_information',
        id: '57933261-f304-45f9-9768-592f0b4e8bf8',
        externalId: undefined,
        name: '📜 Copyright information',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 License information (rich_text)
       */
      license_information: {
        codename: 'license_information',
        id: '85567980-309c-4710-acff-dddfa22f226d',
        externalId: undefined,
        name: '📜 License information',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Table of contents title (text)
       */
      table_of_contents_title: {
        codename: 'table_of_contents_title',
        id: '0adf52b2-2db4-47e7-8ce4-5637b79b2683',
        externalId: undefined,
        name: '📜 Table of contents title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Life Skills outcomes note - Stage 4 only (rich_text)
       */
      life_skills_outcomes_note_stage4only: {
        codename: 'life_skills_outcomes_note_stage4only',
        id: '651714e7-635d-4fc3-a089-f473088f7be8',
        externalId: undefined,
        name: '📜 Life Skills outcomes note - Stage 4 only',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Life Skills outcomes note - Stage 5 only (rich_text)
       */
      life_skills_outcomes_note_stage5only: {
        codename: 'life_skills_outcomes_note_stage5only',
        id: '1f553746-fd6c-40f1-9cfd-9f1168ed5c59',
        externalId: undefined,
        name: '📜 Life Skills outcomes note - Stage 5 only',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Life Skills outcomes note - Stage 4/5 (rich_text)
       */
      life_skills_outcomes_note: {
        codename: 'life_skills_outcomes_note',
        id: '808dc8dd-798b-4800-86d9-761623ce01c5',
        externalId: undefined,
        name: '📜 Life Skills outcomes note - Stage 4/5',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 No content - glossary (text)
       *
       * No glossary items for this syllabus.
       */
      nocontent_glossary: {
        codename: 'nocontent_glossary',
        id: '7315398c-e5fe-4657-a57f-1735bf6208c4',
        externalId: undefined,
        name: '📜 No content - glossary',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 No content - outcomes and content (text)
       */
      nocontent_outcomescontent: {
        codename: 'nocontent_outcomescontent',
        id: 'ecb099c8-ad4c-4150-94e7-16b4fd321d27',
        externalId: undefined,
        name: '📜 No content - outcomes and content',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 No content - life skills (text)
       */
      nocontent_lifeskills: {
        codename: 'nocontent_lifeskills',
        id: '95445269-9e33-4750-8b0f-50d8550cccf2',
        externalId: undefined,
        name: '📜 No content - life skills',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 No content - teaching advice (text)
       *
       * No teaching advice content for this syllabus / stage.
       */
      nocontent_teachingadvice: {
        codename: 'nocontent_teachingadvice',
        id: 'a185f14f-39f8-419f-bc7a-82f2a8135f88',
        externalId: undefined,
        name: '📜 No content - teaching advice',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Overarching outcome message (text)
       */
      overarchingoutcome_message: {
        codename: 'overarchingoutcome_message',
        id: '477f4675-2bb1-4274-bda8-d70583d41bc8',
        externalId: undefined,
        name: '📜 Overarching outcome message',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Document title - Selections tool (text)
       *
       * ℹ️ e.g. HSC English Prescriptions
       */
      prescriptions_document_title_selections: {
        codename: 'prescriptions_document_title_selections',
        id: '2533d77b-d17f-4265-abc0-6f91c95357df',
        externalId: undefined,
        name: '📜 Document title - Selections tool',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Document title - List tool (text)
       *
       * ℹ️ e.g. HSC English Prescriptions Alphabetical list
       */
      prescriptions_document_title_list: {
        codename: 'prescriptions_document_title_list',
        id: '11f0eb28-bdb5-4dca-afa0-a998f57348ac',
        externalId: undefined,
        name: '📜 Document title - List tool',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Global Alert
   * Last modified: Thu Jan 23 2025 06:25:47 GMT+0000 (Coordinated Universal Time)
   */
  ui_globalalert: {
    codename: 'ui_globalalert',
    id: 'e201c53c-a9cf-4d8d-b24e-1ff2b536bfb9',
    externalId: undefined,
    name: '💠 Web UI Global Alert',
    elements: {
      /**
       * 📜 Intro (text)
       */
      intro: {
        codename: 'intro',
        id: '58492a24-0bfe-4a02-a591-0c2cb1da90de',
        externalId: undefined,
        name: '📜 Intro',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '870d7c1b-4e9e-431a-8a16-9e37ee9b52d9',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Button Primary - Text (text)
       */
      btn_primary_text: {
        codename: 'btn_primary_text',
        id: '40ba04e4-d793-4b50-a02b-b7edfb9d951c',
        externalId: undefined,
        name: '📜 Button Primary - Text',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Button Primary - Url (text)
       */
      btn_primary_url: {
        codename: 'btn_primary_url',
        id: 'e932433d-ea83-4d46-83f5-38964562e5ce',
        externalId: undefined,
        name: '🔗 Button Primary - Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Button Secondary - Text (text)
       */
      btn_secondary_text: {
        codename: 'btn_secondary_text',
        id: '9a544a66-fe30-4bef-9f97-17d8e2e24950',
        externalId: undefined,
        name: '📜 Button Secondary - Text',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Button Secondary - Url (text)
       */
      btn_secondary_url: {
        codename: 'btn_secondary_url',
        id: '47b85a4b-80cc-4556-af5a-e3425f2601a9',
        externalId: undefined,
        name: '🔗 Button Secondary - Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Type (multiple_choice)
       */
      type: {
        codename: 'type',
        id: 'cc04620d-027f-43d6-9fee-d79cb03c6baf',
        externalId: undefined,
        name: '⚙️ Type',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 Web Page Stages
   * Last modified: Tue Sep 27 2022 08:18:01 GMT+0000 (Coordinated Universal Time)
   */
  wp_stages: {
    codename: 'wp_stages',
    id: '720a7f16-cbe0-454a-b986-dfcc9fa1c05c',
    externalId: undefined,
    name: '🌐 Web Page Stages',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'f7cadda4-8c47-4246-aacd-8397a9d5cdc6',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🌐 Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: '008cf716-4686-45f9-8117-16315e761511',
        externalId: undefined,
        name: '🌐 Subpages',
        required: true,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 💠 Links (modular_content)
       */
      links: {
        codename: 'links',
        id: 'ae31f749-76c8-4df1-b36e-93fbd1216eb2',
        externalId: undefined,
        name: '💠 Links',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: 'a62cc8c7-0df1-4a89-a111-50bdab1338a6',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },
    },
  },

  /**
   * 📙 Syllabus Course - Content section
   * Last modified: Tue Dec 16 2025 00:49:51 GMT+0000 (Coordinated Universal Time)
   */
  course_contentsection: {
    codename: 'course_contentsection',
    id: '5c37e01a-a75c-4f1f-ad0e-0c91f9184dcc',
    externalId: undefined,
    name: '📙 Syllabus Course - Content section',
    elements: {
      /**
       * 🏷️ Section (multiple_choice)
       */
      section: {
        codename: 'section',
        id: '9131f377-52be-454d-b916-491ba731fd70',
        externalId: undefined,
        name: '🏷️ Section',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '4b9c3209-b30f-4854-abff-5361200124ca',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📦 Links (modular_content)
       */
      links: {
        codename: 'links',
        id: 'b5c03a66-d31f-4f87-af0c-a930d847ca9c',
        externalId: undefined,
        name: '📦 Links',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💬 ACE Footnote
   * Last modified: Thu Sep 17 2026 04:23:01 GMT+0000 (Coordinated Universal Time)
   */
  ace_footnote: {
    codename: 'ace_footnote',
    id: '170b8328-5e49-422c-a881-16d6858e70e2',
    externalId: undefined,
    name: '💬 ACE Footnote',
    elements: {
      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '4ad7b4a4-5444-49f6-90db-864145f73db9',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📨 ACE Contact
   * Last modified: Thu Oct 29 2026 10:14:45 GMT+0000 (Coordinated Universal Time)
   */
  ace_contact: {
    codename: 'ace_contact',
    id: '8424b28b-2923-4bf7-91cd-87e32fd4e58c',
    externalId: undefined,
    name: '📨 ACE Contact',
    elements: {
      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '399f1cb0-c80b-409e-a098-7aa32fe2a607',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 Web Page ACE Landing
   * Last modified: Mon Feb 03 2025 00:00:44 GMT+0000 (Coordinated Universal Time)
   */
  wp_ace_landing: {
    codename: 'wp_ace_landing',
    id: '5209babf-47a8-48de-a59c-b9e804557656',
    externalId: undefined,
    name: '🌐 Web Page ACE Landing',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '0f2e7b48-497f-4f9e-869d-235471c1e5c2',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🌐 Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: '3417d751-54dd-4f44-bc2d-7331d56face3',
        externalId: undefined,
        name: '🌐 Subpages',
        required: false,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '069fb944-35eb-4445-a2a9-34e09cb39b6f',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 🖇️ Show in-page navigation (multiple_choice)
       */
      show_in_page_navigation: {
        codename: 'show_in_page_navigation',
        id: 'e61dbc8c-da06-4df9-83ba-11567ec414ef',
        externalId: undefined,
        name: '🖇️ Show in-page navigation',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect Url (text)
       *
       * Relative or abosute url e.g. /child-page-slug or https://www.externalsite.com/path
       */
      redirect_url: {
        codename: 'redirect_url',
        id: '223e2dd2-7ad4-4b9f-9d61-6c915e9b8d86',
        externalId: undefined,
        name: '🔗 Redirect Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🔗 Web Link Video
   * Last modified: Wed Feb 18 2026 00:56:05 GMT+0000 (Coordinated Universal Time)
   */
  weblinkvideo: {
    codename: 'weblinkvideo',
    id: '8a487321-0910-49e8-a274-6ec53add0d4e',
    externalId: undefined,
    name: '🔗 Web Link Video',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'f96a57a8-8cbc-4a03-b722-3601edbe145a',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Video Url (text)
       */
      video_url: {
        codename: 'video_url',
        id: '8a702eac-4def-4d14-afcd-f1749491c2aa',
        externalId: undefined,
        name: '🔗 Video Url',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📅 Date (date_time)
       */
      date: {
        codename: 'date',
        id: 'd988f0cc-7f06-4c42-8273-db5da4e3112a',
        externalId: undefined,
        name: '📅 Date',
        required: false,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * 📦 Thumbnail (asset)
       */
      thumbnail: {
        codename: 'thumbnail',
        id: 'a0166bee-4c31-4c1b-abe5-1a19b7c121aa',
        externalId: undefined,
        name: '📦 Thumbnail',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * Resource type (taxonomy)
       */
      resource_type: {
        codename: 'resource_type',
        id: '76366c07-5601-4f64-8934-13378215cf3b',
        externalId: undefined,
        name: '🏷️ Resource Type',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 🏷️ Syllabus wide (multiple_choice)
       */
      syllabuswide: {
        codename: 'syllabuswide',
        id: '8cda744a-ec22-42dd-989e-16ff2422bfad',
        externalId: undefined,
        name: '🏷️ Syllabus wide',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '424da039-d515-4da6-bc3f-81583199f65c',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       */
      syllabus_type: {
        codename: 'syllabus_type',
        id: '90f63c63-fd24-4f06-a1c1-689dcc7d5322',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Note that Multiple KLA option should only be used in Canonical KLA field.
       */
      key_learning_area__items: {
        codename: 'key_learning_area__items',
        id: 'd4be49ed-5b70-4bf1-8396-c4c4ba8a1877',
        externalId: undefined,
        name: 'Key Learning Area',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'key_learning_area',
      },
    },
  },

  /**
   * 🌐 Web Page Search
   * Last modified: Tue Jun 24 2025 02:45:48 GMT+0000 (Coordinated Universal Time)
   */
  wp_search: {
    codename: 'wp_search',
    id: 'dec34edf-5ead-46db-a695-81ca7691e4cd',
    externalId: undefined,
    name: '🌐 Web Page Search',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '183d0634-308a-4461-9b6a-c8edce62a497',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 📜 No query message (rich_text)
       */
      no_search: {
        codename: 'no_search',
        id: 'b599f0da-920f-4ad7-93d9-c1e6a1ca814d',
        externalId: undefined,
        name: '📜 No query message',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🌐 Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: 'eff84555-2eed-4757-986e-3001f9d4d43f',
        externalId: undefined,
        name: '🌐 Subpages',
        required: false,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '315d9901-5038-42eb-8be5-dcabd31b9d3a',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 🖇️ Show in-page navigation (multiple_choice)
       */
      show_in_page_navigation: {
        codename: 'show_in_page_navigation',
        id: 'ba2f389f-30c6-4017-ad72-04fb24704281',
        externalId: undefined,
        name: '🖇️ Show in-page navigation',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect Url (text)
       *
       * Relative or abosute url
       */
      redirect_url: {
        codename: 'redirect_url',
        id: '1a03e9d1-85ff-4826-8993-96e6624311c5',
        externalId: undefined,
        name: '🔗 Redirect Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 Web Page ACE Contact Us
   * Last modified: Tue Jun 24 2025 02:41:49 GMT+0000 (Coordinated Universal Time)
   */
  wp_ace_contact: {
    codename: 'wp_ace_contact',
    id: 'eca06cac-eeaa-4c4b-a2a3-9075c7ba05a2',
    externalId: undefined,
    name: '🌐 Web Page ACE Contact Us',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '7bb9f56f-aefd-4c29-b7e8-868c296f64e7',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🌐 Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: '800272c9-fa59-4bc1-9e19-925e67536802',
        externalId: undefined,
        name: '🌐 Subpages',
        required: false,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 🌐 Left navigation links (modular_content)
       */
      left_navigation: {
        codename: 'left_navigation',
        id: '9008fa56-1831-4964-9298-ff73d2f1a3e4',
        externalId: undefined,
        name: '🌐 Left navigation links',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: 'cf405bcd-0e7e-45ab-95ee-ac00bd883ee8',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 🖇️ Show in-page navigation (multiple_choice)
       */
      show_in_page_navigation: {
        codename: 'show_in_page_navigation',
        id: '091c9656-c34d-4a73-be78-d3278df5bac8',
        externalId: undefined,
        name: '🖇️ Show in-page navigation',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect Url (text)
       *
       * Relative or abosute url e.g. /child-page-slug or https://www.externalsite.com/path
       */
      redirect_url: {
        codename: 'redirect_url',
        id: '09ff9348-ea41-480c-95ad-a81a9b8da978',
        externalId: undefined,
        name: '🔗 Redirect Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 Web Page ACE Recent Changes
   * Last modified: Tue Jun 24 2025 02:42:22 GMT+0000 (Coordinated Universal Time)
   */
  wp_ace_recentchanges: {
    codename: 'wp_ace_recentchanges',
    id: '55b2f19a-b494-4ab1-95f2-c761514d0c55',
    externalId: undefined,
    name: '🌐 Web Page ACE Recent Changes',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'c8acc234-21f6-411b-8392-2b46eea71201',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🌐 Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: 'f8219ee7-c158-40ec-a99f-a845907ec3e3',
        externalId: undefined,
        name: '🌐 Subpages',
        required: false,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 🌐 Left navigation links (modular_content)
       */
      left_navigation: {
        codename: 'left_navigation',
        id: '40fbaf9e-930b-4e50-bf81-d242d5eaa72f',
        externalId: undefined,
        name: '🌐 Left navigation links',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '4dd4ed28-ba98-4a44-b72a-c386b454df52',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 🖇️ Show in-page navigation (multiple_choice)
       */
      show_in_page_navigation: {
        codename: 'show_in_page_navigation',
        id: 'eb4e2f69-659c-44a6-9c55-8811710c4368',
        externalId: undefined,
        name: '🖇️ Show in-page navigation',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect Url (text)
       *
       * Relative or abosute url
       */
      redirect_url: {
        codename: 'redirect_url',
        id: '78622a69-7f13-413d-b8f9-f385ba72c107',
        externalId: undefined,
        name: '🔗 Redirect Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📜 Content - Accordion/Tab Item
   * Last modified: Sun Feb 02 2025 23:46:39 GMT+0000 (Coordinated Universal Time)
   */
  accordion_item: {
    codename: 'accordion_item',
    id: 'e2243a35-1d03-43fb-9a31-7a85f2cc0974',
    externalId: undefined,
    name: '📜 Content - Accordion/Tab Item',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '818dd490-a09d-4afb-94f8-aeab680b7896',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '28c7e51a-c70a-4b0a-8b7f-8dbb467721f8',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📜 Content - Outcomes Notification
   * Last modified: Wed Nov 22 2023 05:23:18 GMT+0000 (Coordinated Universal Time)
   */
  content_outcomenotification: {
    codename: 'content_outcomenotification',
    id: '9e46d0f7-f8ba-4117-8d61-568ad3d09fb8',
    externalId: undefined,
    name: '📜 Content - Outcomes Notification',
    elements: {
      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '9fbf7100-2c8c-4313-801e-b9b0c86a5dc6',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       */
      stages: {
        codename: 'stages',
        id: '9538edb0-8edd-42bd-93ea-9d38e44e0cc4',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       */
      stage_years: {
        codename: 'stage_years',
        id: '6ccac18b-57c4-47a7-91a8-88a11e5b39af',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: 'f4191c08-a3c9-4553-b4ae-112aa5293d50',
        externalId: undefined,
        name: '🏷️ Content Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       *
       * ⚠️ CMS field only, not used by the web application
       */
      syllabus: {
        codename: 'syllabus',
        id: '6f030a67-37f7-4f42-b9f5-1450afff3e33',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Display (multiple_choice)
       */
      display: {
        codename: 'display',
        id: 'c8478ffe-5353-4687-9c26-221e2ef8ed8e',
        externalId: undefined,
        name: '⚙️ Display',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📜 Content - Teaching Advice
   * Last modified: Mon Feb 03 2025 00:02:21 GMT+0000 (Coordinated Universal Time)
   */
  content_teachingadvice: {
    codename: 'content_teachingadvice',
    id: 'a1941724-ef26-4b35-acc7-792097dea484',
    externalId: undefined,
    name: '📜 Content - Teaching Advice',
    elements: {
      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '1dbe5ac4-f42f-4f4e-b22f-481c681fe2fa',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       */
      stages: {
        codename: 'stages',
        id: '46dcf5c4-8432-465f-b8dd-db01bf82c2f7',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       */
      stage_years: {
        codename: 'stage_years',
        id: '6ed715e2-19b7-4adc-8b0e-b7147530c9ac',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: 'e8b7c292-da19-4f08-9017-c2c5573cb775',
        externalId: undefined,
        name: '🏷️ Content Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       *
       * ⚠️ CMS field only, not used by the web application
       */
      syllabus: {
        codename: 'syllabus',
        id: '8d28545d-de2f-4799-a8f6-b379bf78cf08',
        externalId: undefined,
        name: '🔖 Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🚩 Change note - ACE KLA/Stage
   * Last modified: Tue Feb 17 2026 01:16:20 GMT+0000 (Coordinated Universal Time)
   */
  releasenote_ace_kla: {
    codename: 'releasenote_ace_kla',
    id: 'a26ccd63-0a87-4b21-b176-3cb69680ade4',
    externalId: undefined,
    name: '🚩 Change note - ACE KLA/Stage',
    elements: {
      /**
       * 📅 Release date (date_time)
       */
      releasedate: {
        codename: 'releasedate',
        id: '7ee4967f-65e1-4278-a02b-18a260c762c9',
        externalId: undefined,
        name: '📅 Release date',
        required: true,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'bca8af4d-2526-4591-88c5-02621564b502',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🗃️ Subgroup (modular_content)
       */
      subgroup: {
        codename: 'subgroup',
        id: '49285804-6092-4e14-aa4a-853b4c458bc1',
        externalId: undefined,
        name: '🗃️ Subgroup',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: 'f87880d1-7e9d-41a2-a431-9ba5a09f347a',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '069ebf78-9186-4da5-a37f-bdda6b2b75d5',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       *
       * Select Stages affected by this ACE Rule(s) update.
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'ae67ca7a-d753-47b2-9af9-c15442ebc3c4',
        externalId: undefined,
        name: '🏷️ Stage',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       *
       * Select Stage Years affected by this ACE Rule(s) update.
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '5fd53e10-d3c0-48bc-bd87-6af5cfc7022d',
        externalId: undefined,
        name: '🏷️ Stage Year',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Select Key Learning Areas affected by this ACE Rule(s) update. Leave blank for generic Stage/Year type updates.
       */
      key_learning_area__items: {
        codename: 'key_learning_area__items',
        id: '1f8c5ce2-c22a-48a3-a961-4378babc375e',
        externalId: undefined,
        name: '🏷️ Key learning area',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '0f4665f6-17d9-40ab-88cb-2cdae1f586b7',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: '3e9463ce-ce74-4344-b204-964b2accfb04',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🚩 Change note - ACE syllabuses
   * Last modified: Tue Feb 17 2026 01:17:09 GMT+0000 (Coordinated Universal Time)
   */
  releasenote_ace_syllabus: {
    codename: 'releasenote_ace_syllabus',
    id: '335e7af1-9871-40ac-921a-008ea2191f3a',
    externalId: undefined,
    name: '🚩 Change note - ACE syllabuses',
    elements: {
      /**
       * 📅 Release date (date_time)
       */
      releasedate: {
        codename: 'releasedate',
        id: '5d45a9c8-bab8-4a53-90e3-eb06e1bf7dd9',
        externalId: undefined,
        name: '📅 Release date',
        required: true,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'e6781c98-ea97-4c21-a25f-75e41a4d0a67',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🗃️ Subgroup (modular_content)
       */
      subgroup: {
        codename: 'subgroup',
        id: '09d1e5ac-1894-4175-acd9-87d20cd04b3d',
        externalId: undefined,
        name: '🗃️ Subgroup',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: 'b1d16c68-3138-4e6d-b593-f74c5fe02138',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       *
       * Select syllabuses affected by this ACE Rule(s) update.
       */
      syllabuses: {
        codename: 'syllabuses',
        id: '531990f9-c43a-4df2-a83a-75358087eef9',
        externalId: undefined,
        name: '🏷️ Syllabuses',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: 'a8f2e2d1-49f9-4ed8-8cb9-185fc506bdc5',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       *
       * Select Stages affected by this ACE Rule(s) update.
       */
      stages__stages: {
        codename: 'stages__stages',
        id: '5f1a879a-3433-49b2-a0b5-9ede880944a9',
        externalId: undefined,
        name: '🏷️ Stage',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       *
       * Select Stage Years affected by this ACE Rule(s) update.
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '7e744731-4806-4823-824b-eef8c146240e',
        externalId: undefined,
        name: '🏷️ Stage Year',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Select Key Learning Areas affected by this ACE Rule(s) update.
       */
      key_learning_area__items: {
        codename: 'key_learning_area__items',
        id: '817b70d9-d5d8-49d2-91c3-c3217a850141',
        externalId: undefined,
        name: '🏷️ Key learning area',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '8d4a31e5-27f6-4346-9c55-0a7eb1a6c0d3',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: '2ac34b4f-6059-4d44-a068-4298e8247615',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🚩 Change note - DC Syllabus
   * Last modified: Thu Apr 17 2025 06:51:49 GMT+0000 (Coordinated Universal Time)
   */
  releasenote_syllabus: {
    codename: 'releasenote_syllabus',
    id: 'c1e80fa8-ce7b-4e74-888c-d495302c0e2b',
    externalId: undefined,
    name: '🚩 Change note - DC Syllabus',
    elements: {
      /**
       * 📅 Release date (date_time)
       */
      releasedate: {
        codename: 'releasedate',
        id: '0e6b6181-7669-499e-a6ec-48894bba59e8',
        externalId: undefined,
        name: '📅 Release date',
        required: true,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'b8b62d34-531a-4cc2-ae24-119b420543d1',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '4f8c75f6-11c1-4934-bb7a-796b86c99080',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: 'da88dd74-ee98-40d3-8d80-2e5a822e82b9',
        externalId: undefined,
        name: '🏷️ Syllabuse',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '2fee54e5-e977-46a3-bb3f-7806b8e528f6',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       */
      stages__stages: {
        codename: 'stages__stages',
        id: '7697415f-ce5e-44b6-9df6-4cd35ab92f65',
        externalId: undefined,
        name: '🏷️ Stage',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '6f2c9d3f-d2a2-45c1-8d7a-d63d64cbcfef',
        externalId: undefined,
        name: '🏷️ Stage Year',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Note that Multiple KLA option should only be used in Canonical KLA field.
       */
      key_learning_area__items: {
        codename: 'key_learning_area__items',
        id: 'd4be49ed-5b70-4bf1-8396-c4c4ba8a1877',
        externalId: undefined,
        name: 'Key Learning Area',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'key_learning_area',
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '9cb5df51-5046-471e-9f78-f9d97f86f1b7',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: '601a64b4-5fe0-4b31-92a8-e424d4320b09',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🚩 Change note - DC Multiple Syllabuses
   * Last modified: Thu Apr 17 2025 06:51:38 GMT+0000 (Coordinated Universal Time)
   */
  releasenote_syllabus_multiple: {
    codename: 'releasenote_syllabus_multiple',
    id: 'ed7fdbec-980a-47e9-9936-26f2d3b3763f',
    externalId: undefined,
    name: '🚩 Change note - DC Multiple Syllabuses',
    elements: {
      /**
       * 📅 Release date (date_time)
       */
      releasedate: {
        codename: 'releasedate',
        id: '07fe815f-3b9a-4d6e-8c00-09389cf7a62e',
        externalId: undefined,
        name: '📅 Release date',
        required: true,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '0d35d391-c390-41e7-8f53-7394ea6b8028',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: 'c847cadf-28f5-446f-9440-a54655cf22bf',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       *
       * Link to specific syllabuses if this update does not affect all syllabuses within the given Stage/Year or KLA
       */
      syllabuses: {
        codename: 'syllabuses',
        id: '780d161e-2735-4933-af5b-bf3f5f8dc07e',
        externalId: undefined,
        name: '🏷️ Syllabuses',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: 'f0e04196-1eb7-4321-9e8a-a1920e0889d8',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       */
      stages__stages: {
        codename: 'stages__stages',
        id: '683954ba-18f0-45da-86a2-64ce1432a914',
        externalId: undefined,
        name: '🏷️ Stage',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '6994d3cb-727f-4847-80bd-0c6e5da65090',
        externalId: undefined,
        name: '🏷️ Stage Year',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Note that Multiple KLA option should only be used in Canonical KLA field.
       */
      key_learning_area__items: {
        codename: 'key_learning_area__items',
        id: 'd4be49ed-5b70-4bf1-8396-c4c4ba8a1877',
        externalId: undefined,
        name: 'Key Learning Area',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'key_learning_area',
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '71640beb-1a70-4884-9651-dff3073f16ed',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: '518b91c3-4f07-46fe-ae30-77b31556be23',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🚩 Change note - DC KLA/Stage
   * Last modified: Thu Apr 17 2025 06:51:27 GMT+0000 (Coordinated Universal Time)
   */
  releasenote_syllabus_kla: {
    codename: 'releasenote_syllabus_kla',
    id: '10e305e7-4cdf-4576-8908-c83f23346ee9',
    externalId: undefined,
    name: '🚩 Change note - DC KLA/Stage',
    elements: {
      /**
       * 📅 Release date (date_time)
       */
      releasedate: {
        codename: 'releasedate',
        id: 'd2c49aaf-d412-4cdb-8b2e-e8815c79bbcd',
        externalId: undefined,
        name: '📅 Release date',
        required: true,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'd436c6d0-faa0-4837-b5a4-8bca488c5025',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: 'c496c3f1-dbe4-42db-875d-6cd8dd734dae',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '7dea2729-5cd9-4bd4-9441-d73c065a7707',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'edda6e46-878f-420a-adea-9597f1abd0df',
        externalId: undefined,
        name: '🏷️ Stage',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: 'c19a1caf-1952-47af-a712-333a20de23f0',
        externalId: undefined,
        name: '🏷️ Stage Year',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Note that Multiple KLA option should only be used in Canonical KLA field.
       */
      key_learning_area__items: {
        codename: 'key_learning_area__items',
        id: 'd4be49ed-5b70-4bf1-8396-c4c4ba8a1877',
        externalId: undefined,
        name: 'Key Learning Area',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'key_learning_area',
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '2cf2a5f3-7f64-42b7-b8d9-0a228939bfeb',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: '3433bbc8-0dc5-447e-b075-5638359f56b8',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🚩 Change note - General
   * Last modified: Thu Apr 17 2025 06:52:00 GMT+0000 (Coordinated Universal Time)
   */
  releasenote_general: {
    codename: 'releasenote_general',
    id: '074414b8-fd4b-4768-bcee-6cf84fd56a08',
    externalId: undefined,
    name: '🚩 Change note - General',
    elements: {
      /**
       * 📅 Release date (date_time)
       */
      releasedate: {
        codename: 'releasedate',
        id: 'de5a9d76-6fe7-4d5a-93f9-a89abeb0c36b',
        externalId: undefined,
        name: '📅 Release date',
        required: true,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '720deda9-66c2-4cdc-8927-ebbd316361c0',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '17f441fe-0354-4c43-9014-479aae35225a',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       */
      stages__stages: {
        codename: 'stages__stages',
        id: '8f9147a5-8c75-4f77-9db6-41a133cfbe8f',
        externalId: undefined,
        name: '🏷️ Stage',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '08a5fdd6-133f-4470-bf8f-8017bf653588',
        externalId: undefined,
        name: '🏷️ Stage Year',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: 'b3d44356-1a38-4a7c-a587-a613a0bd1519',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: 'd8a242a5-3dcb-44a1-ad93-c17f32704f70',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 Web Page DC Recent Changes
   * Last modified: Tue Jun 24 2025 02:43:28 GMT+0000 (Coordinated Universal Time)
   */
  wp_dc_recentchanges: {
    codename: 'wp_dc_recentchanges',
    id: 'a048daca-7e14-4494-a450-5a8b1c9fd918',
    externalId: undefined,
    name: '🌐 Web Page DC Recent Changes',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'c7613424-4b5b-4e27-9676-b44472857a21',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🌐 Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: 'ae58c10d-a9d9-4cda-8067-e4e44daf0f8e',
        externalId: undefined,
        name: '🌐 Subpages',
        required: false,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 🌐 Left navigation links (modular_content)
       */
      left_navigation: {
        codename: 'left_navigation',
        id: '6bc537f9-9978-48c0-b9c1-f0ea02e583f6',
        externalId: undefined,
        name: '🌐 Left navigation links',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '372790cb-4c71-4271-b903-efde7208aa31',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 🖇️ Show in-page navigation (multiple_choice)
       */
      show_in_page_navigation: {
        codename: 'show_in_page_navigation',
        id: '458717d1-6e11-41e8-a3a2-ae0980933c7d',
        externalId: undefined,
        name: '🖇️ Show in-page navigation',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect Url (text)
       *
       * Relative or abosute url
       */
      redirect_url: {
        codename: 'redirect_url',
        id: '5a347e30-4510-407e-8692-57cc26264874',
        externalId: undefined,
        name: '🔗 Redirect Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🔢 ACE Ordered list paragraph
   * Last modified: Thu Sep 17 2026 04:22:46 GMT+0000 (Coordinated Universal Time)
   */
  ace_paragraph: {
    codename: 'ace_paragraph',
    id: '20a27a6c-cfaf-4306-8df2-d30c9eaf966f',
    externalId: undefined,
    name: '🔢 ACE Ordered list paragraph',
    elements: {
      /**
       * ⚙️ Internal title (text)
       *
       * ⚠️ CMS field only, not used by the web application.
       */
      internal_title: {
        codename: 'internal_title',
        id: '3da9c124-6239-44b5-9533-084a0c679f32',
        externalId: undefined,
        name: '⚙️ Internal title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔢 Ordered list - Start from (number)
       */
      orderedliststartfrom: {
        codename: 'orderedliststartfrom',
        id: '752a5328-9315-4255-82bb-009e6f994464',
        externalId: undefined,
        name: '🔢 Ordered list - Start from',
        required: true,
        type: 'number',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: 'f2acd898-4d2a-49bd-8271-bf47d965fff1',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🛠️ Redirect rule
   * Last modified: Thu Jun 06 2024 03:39:16 GMT+0000 (Coordinated Universal Time)
   */
  redirectrule: {
    codename: 'redirectrule',
    id: '25146624-dbb8-4c20-9f84-4889afeb55dd',
    externalId: undefined,
    name: '🛠️ Redirect rule',
    elements: {
      /**
       * 📜 From (text)
       *
       * ⚠️ Note that for Focus Area and Syllabus codename redirects, the old codename will be converted to slug format e.g. "hmsls_11_12_ls_fa_coll" will be used as "hmsls-11-12-ls-fa-coll"
       */
      from: {
        codename: 'from',
        id: 'bb4cb194-9dbb-4ddd-afd2-34de3ac4d547',
        externalId: undefined,
        name: '📜 From',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 To (text)
       */
      to: {
        codename: 'to',
        id: '33767944-68ea-43a1-bbcc-98294fed50d3',
        externalId: undefined,
        name: '📜 To',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Type (multiple_choice)
       */
      type: {
        codename: 'type',
        id: '5e5b31a8-d686-4e45-9498-aa21a6e63be2',
        externalId: undefined,
        name: '⚙️ Type',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '53d183dd-41d3-4f13-88b3-3e2d33cbb455',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🛠️ 404 Error Page
   * Last modified: Tue Aug 22 2023 05:45:43 GMT+0000 (Coordinated Universal Time)
   */
  web_404: {
    codename: 'web_404',
    id: '592e668d-7b82-4aab-8ce8-b93e60dca6c2',
    externalId: undefined,
    name: '🛠️ 404 Error Page',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '96660b40-2dd3-463b-9d3d-6a8ae3ec3e7b',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: 'dd6c86e4-81c5-4ffa-93cf-270add310ccb',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 🖇️ Show in-page navigation (multiple_choice)
       */
      show_in_page_navigation: {
        codename: 'show_in_page_navigation',
        id: '37895c09-ab76-4953-913c-fd20150e9fe7',
        externalId: undefined,
        name: '🖇️ Show in-page navigation',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect Url (text)
       *
       * Relative or abosute url
       */
      redirect_url: {
        codename: 'redirect_url',
        id: 'f6c22250-f5e4-4a9b-a44b-38aafb4054e1',
        externalId: undefined,
        name: '🔗 Redirect Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📜 Content - Language Example
   * Last modified: Mon Jan 15 2024 06:12:51 GMT+0000 (Coordinated Universal Time)
   */
  content_langexample: {
    codename: 'content_langexample',
    id: 'f51d7340-474b-43d8-af50-36025be8921e',
    externalId: undefined,
    name: '📜 Content - Language Example',
    elements: {
      /**
       * 📜 Content (rich_text)
       *
       * Note: Bullet points CANNOT be used in Examples
       */
      content: {
        codename: 'content',
        id: '2c3bacfd-3893-45d2-af67-3d8d81337089',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Language (taxonomy)
       */
      language: {
        codename: 'language',
        id: '27ae6687-09e4-4bd1-ae63-61a63a67b75f',
        externalId: undefined,
        name: '🏷️ Language',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       *
       * ⚠️ CMS field only, not used by the web application
       */
      syllabus: {
        codename: 'syllabus',
        id: '035aa9a3-54e4-46a2-9a52-8a37a1bdd47c',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       *
       * ⚠️ CMS field only, not used by the web application
       */
      stages: {
        codename: 'stages',
        id: 'b72928a3-6a5c-4a73-bbf1-e332016600ca',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       *
       * ⚠️ CMS field only, not used by the web application
       */
      stage_years: {
        codename: 'stage_years',
        id: '88c95899-29f4-48a4-9808-51493a7e74be',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🔗 Link Focus Area
   * Last modified: Thu Jul 03 2025 03:01:10 GMT+0000 (Coordinated Universal Time)
   */
  web_link_focusarea: {
    codename: 'web_link_focusarea',
    id: '46a9656d-c6eb-40e7-939f-87a5adc887c2',
    externalId: undefined,
    name: '🔗 Link Focus Area',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'f06b42f3-4ed5-4cff-bafb-abe256bc0c11',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Item (modular_content)
       */
      item: {
        codename: 'item',
        id: 'a5e43ebb-cc37-47af-9268-f425b92f2645',
        externalId: undefined,
        name: '🔗 Item',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Enable view side-by-side (taxonomy)
       */
      enable_compare_view__enable_compare_view: {
        codename: 'enable_compare_view__enable_compare_view',
        id: '6a071984-aba1-4a39-9ce3-eb395d7c588a',
        externalId: undefined,
        name: '⚙️ Enable view side-by-side',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'enable_compare_view',
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '23116447-d94a-4c7a-8dca-87c67afd24f7',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },

      /**
       * Stage (taxonomy)
       *
       * ⚠️ For mainstream links select 1 stage only.For secondary Life Skills links, select both Stage 4 and Stage 5.
       */
      stages__stages: {
        codename: 'stages__stages',
        id: '2fb2e181-818a-4cd5-ac04-786f20dc027e',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       *
       * ⚠️ Select 2 years within the stage for K-10 syllabuses and only 1 year for senior syllabuses. For secondary Life Skills links, select years from both Stage 4 and Stage 5.
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '32b3d419-0757-4cfd-8d45-c49fd448452a',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🔗 Link Content Group
   * Last modified: Thu Jul 03 2025 03:00:52 GMT+0000 (Coordinated Universal Time)
   */
  web_link_contentgroup: {
    codename: 'web_link_contentgroup',
    id: 'b036ea5d-f2c1-4f23-8ca2-350277b6f1a9',
    externalId: undefined,
    name: '🔗 Link Content Group',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'c5244b44-c62c-48d6-ba9a-8d73da78c0b0',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Item (modular_content)
       */
      item: {
        codename: 'item',
        id: 'bf576057-77c1-4e9f-9cc5-7b9d676849fe',
        externalId: undefined,
        name: '🔗 Item',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Enable view side-by-side (taxonomy)
       */
      enable_compare_view__enable_compare_view: {
        codename: 'enable_compare_view__enable_compare_view',
        id: '6a071984-aba1-4a39-9ce3-eb395d7c588a',
        externalId: undefined,
        name: '⚙️ Enable view side-by-side',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'enable_compare_view',
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: 'e605cb21-fae4-4819-9643-58dce36eefec',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },

      /**
       * Stage (taxonomy)
       *
       * ⚠️ For mainstream links select 1 stage only.For secondary Life Skills links, select both Stage 4 and Stage 5.
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'd1f64c2b-e45f-4345-aebe-3de6c16b5ad0',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       *
       * ⚠️ Select 2 years within the stage for K-10 syllabuses and only 1 year for senior syllabuses. For secondary Life Skills links, select years from both Stage 4 and Stage 5.
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '18cc0718-6319-4d86-81d1-25d187e5f187',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🔗 Link Teaching Advice
   * Last modified: Thu Jul 03 2025 03:01:50 GMT+0000 (Coordinated Universal Time)
   */
  web_link_teachingadvice: {
    codename: 'web_link_teachingadvice',
    id: 'ba38dbc5-ac62-4c68-9b17-fe1e4074821e',
    externalId: undefined,
    name: '🔗 Link Teaching Advice',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '15707d08-7545-416c-9258-7c514297201c',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Item (modular_content)
       */
      item: {
        codename: 'item',
        id: '5955b29d-b303-48aa-83af-029cc7e90970',
        externalId: undefined,
        name: '🔗 Item',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Enable view side-by-side (taxonomy)
       */
      enable_compare_view__enable_compare_view: {
        codename: 'enable_compare_view__enable_compare_view',
        id: '6a071984-aba1-4a39-9ce3-eb395d7c588a',
        externalId: undefined,
        name: '⚙️ Enable view side-by-side',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'enable_compare_view',
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: 'c9e5a35d-78e0-4a00-be77-692327610ed8',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },

      /**
       * Stage (taxonomy)
       *
       * ⚠️ For mainstream links select 1 stage only.For secondary Life Skills links, select both Stage 4 and Stage 5.
       */
      stages__stages: {
        codename: 'stages__stages',
        id: '85c18137-9693-461f-8ca6-9b026cf989c3',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       *
       * ⚠️ Select 2 years within the stage for K-10 syllabuses and only 1 year for senior syllabuses. For secondary Life Skills links, select years from both Stage 4 and Stage 5.
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '944bdfd3-f215-45b4-bf29-f76552e8c703',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📂🔸Options List
   * Last modified: Thu Aug 14 2025 02:59:53 GMT+0000 (Coordinated Universal Time)
   */
  optionslist: {
    codename: 'optionslist',
    id: '08278db3-5298-4a5a-9aac-361027e7b678',
    externalId: undefined,
    name: '📂🔸Options List',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '8db87526-2ee3-406d-97ff-19929816fd02',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '0d37ae7d-7947-4983-b5cd-10a0df92635d',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📃🔸Focus area options (modular_content)
       */
      focus_area_options: {
        codename: 'focus_area_options',
        id: '69e08ee5-780a-4b3d-b4fa-f04b95e38285',
        externalId: undefined,
        name: '📃🔸Focus area options',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '02b9b50a-f591-4325-8c05-837f4ac40dfa',
        externalId: undefined,
        name: '📒 Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * 📚 Course (modular_content)
       */
      course: {
        codename: 'course',
        id: 'bfcccd1e-2171-4c63-8d3d-f3372644a170',
        externalId: undefined,
        name: '📚 Course',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📃🔸Focus Area Option
   * Last modified: Wed Oct 28 2026 12:04:46 GMT+0000 (Coordinated Universal Time)
   */
  focusareaoption: {
    codename: 'focusareaoption',
    id: '3d54d0d8-32a8-47ad-952d-eb877110710c',
    externalId: undefined,
    name: '📃🔸Focus Area Option',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'd2efabf0-d9bc-4cd6-9555-e5c26c0fb3ee',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '0c738971-0404-47f0-ae5e-3f92c9c828ea',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content stage specific (modular_content)
       */
      content_staged: {
        codename: 'content_staged',
        id: '2511268b-4f97-412f-96c6-39691ef6d228',
        externalId: undefined,
        name: '📜 Content stage specific',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📑 Teaching Advice (modular_content)
       */
      teachingadvice: {
        codename: 'teachingadvice',
        id: '6497974e-2906-492b-9179-4affad181caf',
        externalId: undefined,
        name: '📑 Teaching Advice',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📃 Related Focus Areas (modular_content)
       *
       * Related Mainstream / Life Skills Focus Area
       */
      related_focusareas: {
        codename: 'related_focusareas',
        id: 'cca71d86-d6ac-4271-80cb-3528e62ef82e',
        externalId: undefined,
        name: '📃 Related Focus Areas',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📑 Content Groups (modular_content)
       */
      contentgroups: {
        codename: 'contentgroups',
        id: 'a4fa85aa-564e-46fb-af07-fd86215c9849',
        externalId: undefined,
        name: '📑 Content Groups',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📃 Outcomes (modular_content)
       */
      outcomes: {
        codename: 'outcomes',
        id: 'eaea31ef-e322-4196-8b53-3ab7bc0c684c',
        externalId: undefined,
        name: '📃 Outcomes',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📃 Related outcomes overwrite (modular_content)
       *
       * ⚠️ Used for PRINT only
       */
      related_outcomes: {
        codename: 'related_outcomes',
        id: 'efe11057-4a38-4ffb-9203-bc7bbc055d1e',
        externalId: undefined,
        name: '📃 Related outcomes overwrite',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📦 Resources Containers (modular_content)
       */
      resource_containers: {
        codename: 'resource_containers',
        id: 'ab78ba58-af72-4455-ad90-5feee5f936a0',
        externalId: undefined,
        name: '📦 Resources Containers',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📦 Resources other (modular_content)
       */
      resources_other: {
        codename: 'resources_other',
        id: '5c0b7ac8-2d08-4f7f-8ba5-353886668a11',
        externalId: undefined,
        name: '📦 Resources other',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '94a5a565-62d2-4342-9de9-055837cd4d51',
        externalId: undefined,
        name: '📒 Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: '39e97a54-ee05-4ef0-957f-303fb6dfbf27',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📖 Prescriptions (modular_content)
       */
      prescriptions: {
        codename: 'prescriptions',
        id: '1a09103e-1f94-4211-a57a-716b6d69eca4',
        externalId: undefined,
        name: '📖 Prescriptions',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📈 Focus Area Continuum Group (modular_content)
       */
      continuumgroups: {
        codename: 'continuumgroups',
        id: 'c601b14a-fe88-40d0-8506-197994c19dc0',
        externalId: undefined,
        name: '📈 Focus Area Continuum Group',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🖇️ Link Content Group - Curriculum Connections
   * Last modified: Thu Jul 03 2025 03:02:09 GMT+0000 (Coordinated Universal Time)
   */
  web_link_cc_contentgroup: {
    codename: 'web_link_cc_contentgroup',
    id: '0ac80a47-dbbd-4e05-a690-09c171bf868b',
    externalId: undefined,
    name: '🖇️ Link Content Group - Curriculum Connections',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '8d227c9b-fd19-4b4d-ba07-6c23195dd5f7',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Item (modular_content)
       */
      item: {
        codename: 'item',
        id: 'd303fee4-8423-4a81-8613-cf05148ef993',
        externalId: undefined,
        name: '🔗 Item',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Enable view side-by-side (taxonomy)
       */
      enable_compare_view__enable_compare_view: {
        codename: 'enable_compare_view__enable_compare_view',
        id: '6a071984-aba1-4a39-9ce3-eb395d7c588a',
        externalId: undefined,
        name: '⚙️ Enable view side-by-side',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'enable_compare_view',
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '5511e63e-877a-4c5b-93b4-cdf10fab4a7c',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },

      /**
       * Stage (taxonomy)
       */
      stages__stages: {
        codename: 'stages__stages',
        id: '6a050fad-1e66-4c00-a372-7362376b519f',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       *
       * ⚠️ Select 2 years within the stage for K-10 syllabuses and only 1 year for Senior syllabuses.
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: 'e9c1eb86-9a79-415d-8e1f-7032307a0e0b',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🖇️ Link Focus Area - Curriculum Connections
   * Last modified: Thu Jul 03 2025 03:02:25 GMT+0000 (Coordinated Universal Time)
   */
  web_link_cc_focusarea: {
    codename: 'web_link_cc_focusarea',
    id: 'a7540d09-4cdd-43a7-9fe3-066fe5373f2c',
    externalId: undefined,
    name: '🖇️ Link Focus Area - Curriculum Connections',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '696280a9-6fc6-48c5-8617-0ab97bda1f61',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Item (modular_content)
       */
      item: {
        codename: 'item',
        id: 'be1b71bd-ed4a-45ee-93a7-f1d3fa395ea1',
        externalId: undefined,
        name: '🔗 Item',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Enable view side-by-side (taxonomy)
       */
      enable_compare_view__enable_compare_view: {
        codename: 'enable_compare_view__enable_compare_view',
        id: '6a071984-aba1-4a39-9ce3-eb395d7c588a',
        externalId: undefined,
        name: '⚙️ Enable view side-by-side',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'enable_compare_view',
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: 'b93a2dfc-2820-4218-b55a-ef119817d1fb',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },

      /**
       * Stage (taxonomy)
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'b06436b5-f744-417e-8660-e209e74d899a',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       *
       * ⚠️ Select 2 years within the stage for K-10 syllabuses and only 1 year for Senior syllabuses.
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: 'a1b9ee95-05e1-4b28-a86b-d14ea0710912',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🖇️ Link Teaching Advice - Curriculum Connections
   * Last modified: Thu Jul 03 2025 03:02:41 GMT+0000 (Coordinated Universal Time)
   */
  web_link_cc_teachingadvice: {
    codename: 'web_link_cc_teachingadvice',
    id: 'f7328f83-8722-407b-baf8-7d78171ecfe9',
    externalId: undefined,
    name: '🖇️ Link Teaching Advice - Curriculum Connections',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '7d51764e-3df1-4de8-838d-6d86d629401f',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Item (modular_content)
       */
      item: {
        codename: 'item',
        id: 'de61d510-0c41-4759-8a61-2a9a77a9899a',
        externalId: undefined,
        name: '🔗 Item',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Enable view side-by-side (taxonomy)
       */
      enable_compare_view__enable_compare_view: {
        codename: 'enable_compare_view__enable_compare_view',
        id: '6a071984-aba1-4a39-9ce3-eb395d7c588a',
        externalId: undefined,
        name: '⚙️ Enable view side-by-side',
        required: false,
        type: 'taxonomy',
        snippetCodename: 'enable_compare_view',
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: 'a541bcbc-62df-44bb-8355-48655098667c',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },

      /**
       * Stage (taxonomy)
       */
      stages__stages: {
        codename: 'stages__stages',
        id: '3de23693-058f-4d9f-be98-a0eb0e91015f',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       *
       * ⚠️ Select 2 years within the stage for K-10 syllabuses and only 1 year for Senior syllabuses.
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '92a37e6b-727d-423d-8b45-019506c107ae',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🔗 Links placeholder - Overarching
   * Last modified: Mon Jan 15 2024 23:41:36 GMT+0000 (Coordinated Universal Time)
   */
  links_placeholder_overarching: {
    codename: 'links_placeholder_overarching',
    id: '4422e624-a1a3-44aa-a7a5-dbe74914dcf4',
    externalId: undefined,
    name: '🔗 Links placeholder - Overarching',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '0251399d-f211-4021-b9b7-a0514d13d393',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Overarching links (modular_content)
       */
      links: {
        codename: 'links',
        id: '3f7d2d1e-0bc7-418b-b30c-bf4a06fce611',
        externalId: undefined,
        name: '🔗 Overarching links',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🖇️ Links placeholder - Curriculum Connections
   * Last modified: Mon Jan 15 2024 23:40:55 GMT+0000 (Coordinated Universal Time)
   */
  links_placeholder_cc: {
    codename: 'links_placeholder_cc',
    id: '98ddd4be-3f6d-486a-aa56-4e4b63d8a739',
    externalId: undefined,
    name: '🖇️ Links placeholder - Curriculum Connections',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '56923add-cb91-4477-abcd-e3b42981e14f',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🖇️ Curriculum Connections links (modular_content)
       */
      links: {
        codename: 'links',
        id: 'b4d2e301-abd4-406c-b132-fea36b5acac6',
        externalId: undefined,
        name: '🖇️ Curriculum Connections links',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📒 Syllabus - External
   * Last modified: Tue Feb 17 2026 01:08:54 GMT+0000 (Coordinated Universal Time)
   */
  syllabus_external: {
    codename: 'syllabus_external',
    id: '22e867a8-c0a7-44cf-bb0d-116e1d44c590',
    externalId: undefined,
    name: '📒 Syllabus - External',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '8fdbbe7c-29fe-44fc-94d6-638c60b197c1',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📅 Publication year (text)
       *
       * ⚠️ If filled in, Publication year will be displayed in parentheses after Title.
       */
      publication_year: {
        codename: 'publication_year',
        id: 'bf68d795-3a74-477f-8bbb-123e31bc7890',
        externalId: undefined,
        name: '📅 Publication year',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect url (text)
       */
      redirecturl: {
        codename: 'redirecturl',
        id: '98f30a82-c3ff-4b81-a0b9-25d490238470',
        externalId: undefined,
        name: '🔗 Redirect url',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Status (taxonomy)
       */
      status: {
        codename: 'status',
        id: '65951a73-0326-4757-b97d-7fa96cac7f18',
        externalId: undefined,
        name: '🏷️ Status',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 📅 Status year (text)
       *
       * ⚠️ If filled in, Status year will be displayed after Status.
       */
      status_year: {
        codename: 'status_year',
        id: '0a3309c4-3059-4093-9de5-38894ba36443',
        externalId: undefined,
        name: '📅 Status year',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Keywords (text)
       */
      seo_keywords: {
        codename: 'seo_keywords',
        id: 'bf2bcb19-3f0f-4ff9-b3c7-4734c92952bd',
        externalId: undefined,
        name: '📜 Keywords',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: 'c7c9c5f8-1039-444d-b5eb-f75d12b03a33',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Note that Multiple KLA option should only be used in Canonical KLA field.
       */
      key_learning_area_default: {
        codename: 'key_learning_area_default',
        id: '77a2750e-4914-42e7-b5ba-3bc2f9d40ea5',
        externalId: undefined,
        name: '🏷️ Key Learning Area',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },
    },
  },

  /**
   * 📜 Content - Course
   * Last modified: Mon Feb 03 2025 00:02:07 GMT+0000 (Coordinated Universal Time)
   */
  content_course: {
    codename: 'content_course',
    id: '469c4dc3-3b80-4622-b752-fe0d6164d1f9',
    externalId: undefined,
    name: '📜 Content - Course',
    elements: {
      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '4a80a39d-0d1e-4bdf-8317-2d6df37370f0',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Resources
   * Last modified: Wed Feb 18 2026 00:55:43 GMT+0000 (Coordinated Universal Time)
   */
  ui_resources: {
    codename: 'ui_resources',
    id: '6301f641-62ed-4b17-9407-56b31b7b60be',
    externalId: undefined,
    name: '💠 Web UI Resources',
    elements: {
      /**
       * 📦 Resources Containers (modular_content)
       */
      resource_containers: {
        codename: 'resource_containers',
        id: '880c212e-4d55-4fc1-bbe2-7839a7962853',
        externalId: undefined,
        name: '📦 Resources Containers',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📙 Syllabus - Overview page
   * Last modified: Thu Aug 13 2026 05:04:53 GMT+0000 (Coordinated Universal Time)
   */
  syllabus_overviewpage: {
    codename: 'syllabus_overviewpage',
    id: 'a49e3c15-31d4-4a6d-8fa1-dbf2aa48a71c',
    externalId: undefined,
    name: '📙 Syllabus - Overview page',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '4e8e694e-e31a-4c1d-ab8c-8cb7f90cf671',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '5ca29206-e8bc-4747-add4-e6955b90967c',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: 'cb682239-49b5-4bb3-90bf-ca154a67d647',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: 'e551b7c0-a26a-4186-8878-e367b7ea1ff9',
        externalId: undefined,
        name: '📒 Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: '9babd850-d4c4-4fbe-a788-dbb0b5b62a17',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 Web Landing Page
   * Last modified: Sun Feb 02 2025 23:59:44 GMT+0000 (Coordinated Universal Time)
   */
  web_landing_page: {
    codename: 'web_landing_page',
    id: '3e59692d-685f-4e08-b8c6-d2fb4b4395be',
    externalId: undefined,
    name: '🌐 Web Landing Page',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '9b77226b-0db4-4888-a2cd-fe10ab385a58',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🔗 Redirect Url (text)
       *
       * Relative or abosute url e.g. /child-page-slug or https://www.externalsite.com/path
       */
      redirect_url: {
        codename: 'redirect_url',
        id: '89876c8c-2bbb-4563-967b-2e00661013b8',
        externalId: undefined,
        name: '🔗 Redirect Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🌐 Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: '7e26fff6-dd9b-4521-9108-eb7776bda214',
        externalId: undefined,
        name: '🌐 Subpages',
        required: false,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: 'f27c5bce-5426-41d4-a913-24b021599dea',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 🖇️ Show in-page navigation (multiple_choice)
       */
      show_in_page_navigation: {
        codename: 'show_in_page_navigation',
        id: '279d0d54-cf43-4d9f-a785-41bbec16c03b',
        externalId: undefined,
        name: '🖇️ Show in-page navigation',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🔗 Link Glossary
   * Last modified: Tue Dec 10 2024 12:57:56 GMT+0000 (Coordinated Universal Time)
   */
  link_glossary: {
    codename: 'link_glossary',
    id: '6fac1447-31ba-4f8a-9ab4-a0e0690a7475',
    externalId: undefined,
    name: '🔗 Link Glossary',
    elements: {
      /**
       * 🔗 Item (modular_content)
       */
      item: {
        codename: 'item',
        id: 'c3e0a2fe-f618-4f14-94d4-b9bbe28462bf',
        externalId: undefined,
        name: '🔗 Item',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🔗 Link Resource Container
   * Last modified: Tue Dec 17 2024 02:47:55 GMT+0000 (Coordinated Universal Time)
   */
  link_resource_file: {
    codename: 'link_resource_file',
    id: '1f7ca032-047d-4a61-b4a8-79a0e6a5ce7e',
    externalId: undefined,
    name: '🔗 Link Resource Container',
    elements: {
      /**
       * 🔗 Item (modular_content)
       */
      item: {
        codename: 'item',
        id: '259769b9-5f52-475e-9d6d-a705c1ce0a8f',
        externalId: undefined,
        name: '🔗 Item',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📦 Resource Container
   * Last modified: Thu Oct 22 2026 00:51:47 GMT+0000 (Coordinated Universal Time)
   */
  resource_container: {
    codename: 'resource_container',
    id: '768cdd8b-af00-4571-96f1-646210b27ffd',
    externalId: undefined,
    name: '📦 Resource Container',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'ab235812-6100-4946-adcd-3fd64599a23f',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 File Name (text)
       *
       * ⚠️ Use this optional field to overwrite the default filename set in the linked asset. If left blank, the default asset filename will be used when saving this resource file.
       */
      file_name: {
        codename: 'file_name',
        id: '51abd347-bc64-4805-bc09-32830bc8be23',
        externalId: undefined,
        name: '📜 File Name',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: '4a5a63f0-4e4c-46de-9656-769fcbed0128',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Resource type (taxonomy)
       */
      resource_type: {
        codename: 'resource_type',
        id: '497d9f55-c0cf-4e78-b071-5a5fb89cfe42',
        externalId: undefined,
        name: '🏷️ Resource type',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 🏷️ Syllabus wide (multiple_choice)
       */
      syllabuswide: {
        codename: 'syllabuswide',
        id: 'fe17e674-8931-4908-8578-e19490f81d75',
        externalId: undefined,
        name: '🏷️ Syllabus wide',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 📦 File (asset)
       */
      asset: {
        codename: 'asset',
        id: 'cbcef3bf-8250-4aa6-a526-2d8526f31d8d',
        externalId: undefined,
        name: '📦 File',
        required: true,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * 📅 Asset Published (date_time)
       *
       * ⚠️ Target date, not displayed to public. Used to order assets for different syllabuses published on different dates in the same month.
       */
      asset_published: {
        codename: 'asset_published',
        id: '54e40ba3-a3b7-4f74-b065-0f64699be724',
        externalId: undefined,
        name: '📅 Asset Published',
        required: true,
        type: 'date_time',
        snippetCodename: undefined,
      },

      /**
       * 🔗 TRIM ID (text)
       *
       * ℹ️ This field is for internal purposes only and is not displayed to the public.
       */
      trim_id: {
        codename: 'trim_id',
        id: 'b36f111b-5a31-4f9f-a15f-cd9434e65da7',
        externalId: undefined,
        name: '🔗 TRIM ID',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Keywords (text)
       */
      seo_keywords: {
        codename: 'seo_keywords',
        id: '0a07eacd-7aed-4453-8432-425180b0fe76',
        externalId: undefined,
        name: '📜 Keywords',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '8ccff055-e334-4581-ad23-4284f44dbeb7',
        externalId: undefined,
        name: '📒 Syllabus',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       */
      syllabus_type: {
        codename: 'syllabus_type',
        id: 'c97b2c0b-151d-45da-8ec5-10d9921593f3',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       *
       * ⚠️ Note that Multiple KLA option should only be used in Canonical KLA field.
       */
      key_learning_area__items: {
        codename: 'key_learning_area__items',
        id: '211d44f4-3438-4e4e-a03e-3f64bd87b6da',
        externalId: undefined,
        name: '🏷️ Key Learning Area',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'db08468f-10dd-4131-992e-3ff0aedf9829',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       */
      stages__stages: {
        codename: 'stages__stages',
        id: '70611d67-5fa1-41f3-ad7d-db57d8fcae54',
        externalId: undefined,
        name: '🏷️ Stages',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '7972f40f-f82a-4717-acc2-507352dd5374',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Language (taxonomy)
       */
      language: {
        codename: 'language',
        id: '3748e74e-56e8-4b4d-a1b8-e7298ac7ba96',
        externalId: undefined,
        name: '🏷️ Language',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📃 Outcome - Print dummy
   * Last modified: Sun May 11 2025 22:50:01 GMT+0000 (Coordinated Universal Time)
   */
  outcome_printdummy: {
    codename: 'outcome_printdummy',
    id: '801b1638-d39b-44e4-aae3-52053472743d',
    externalId: undefined,
    name: '📃 Outcome - Print dummy',
    elements: {
      /**
       * 📜 Code (text)
       */
      code: {
        codename: 'code',
        id: 'ba3ad421-843c-4b10-8200-9ed110c426f6',
        externalId: undefined,
        name: '📜 Code',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (rich_text)
       */
      description: {
        codename: 'description',
        id: 'a569195b-1549-4daa-a578-8f5c616d2947',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '963f303d-7f3a-460e-9236-4d3bb054dcf6',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 📚 Course (modular_content)
       */
      course: {
        codename: 'course',
        id: 'db2acf44-903a-48c2-b737-cf498d2d5567',
        externalId: undefined,
        name: '📚 Course',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Syllabus Type (taxonomy)
       *
       * Please select the Syllabus type for this resource
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: '132af31b-4f0d-4c71-ba94-bd0175566543',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'syllabus_type',
      },
    },
  },

  /**
   * 💠Web UI Syllabus Tile
   * Last modified: Wed May 28 2025 23:26:53 GMT+0000 (Coordinated Universal Time)
   */
  web_ui_syllabus_tile: {
    codename: 'web_ui_syllabus_tile',
    id: '02cd5f3b-0d28-4080-8275-321f80fe3ec2',
    externalId: undefined,
    name: '💠Web UI Syllabus Tile',
    elements: {
      /**
       * 🗒️ Left Syllabus tooltip (rich_text)
       */
      syllabus_tooltip_left: {
        codename: 'syllabus_tooltip_left',
        id: 'ee43aa91-7481-4bba-95b7-8691660266fb',
        externalId: undefined,
        name: '🗒️ Left Syllabus tooltip',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🗒️ Right Syllabus tooltip (rich_text)
       */
      syllabus_tooltip_right: {
        codename: 'syllabus_tooltip_right',
        id: '55034d02-81c9-42d1-8db5-d70b93ef5944',
        externalId: undefined,
        name: '🗒️ Right Syllabus tooltip',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📒 Left Syllabus(s) (modular_content)
       */
      syllabuses_left: {
        codename: 'syllabuses_left',
        id: '1aacd10a-81b1-4d47-814b-1bed5a8c4fd0',
        externalId: undefined,
        name: '📒 Left Syllabus(s)',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📒 Right Syllabus(s) (modular_content)
       */
      syllabuses_right: {
        codename: 'syllabuses_right',
        id: 'cee00b1d-c401-49ac-b092-7d0c229d70b1',
        externalId: undefined,
        name: '📒 Right Syllabus(s)',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Key learning area (taxonomy)
       */
      key_learning_area: {
        codename: 'key_learning_area',
        id: 'ea116ac5-fe16-4c04-8cde-4af869da98f4',
        externalId: undefined,
        name: '🏷️ Key Learning Area',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Group (taxonomy)
       */
      stages__stage_groups: {
        codename: 'stages__stage_groups',
        id: 'a5222385-0941-43a7-90fd-06b9440ebadb',
        externalId: undefined,
        name: '🏷️ Stage Groups',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage (taxonomy)
       *
       * Please select all 3 levels e.g. "Secondary" then "Stage 4" and  then "7" and/or "8"
       */
      stages__stages: {
        codename: 'stages__stages',
        id: 'a1eaaaa8-f318-4099-b7c9-477e2cd51093',
        externalId: undefined,
        name: '🏷️ Stages',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * Stage Year (taxonomy)
       */
      stages__stage_years: {
        codename: 'stages__stage_years',
        id: '15c84d16-af82-4481-9368-abcb5b07578c',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: true,
        type: 'taxonomy',
        snippetCodename: 'stages',
      },

      /**
       * 📜 Title Blank (text)
       *
       * ⚠️ Optional title to be displayed in place of an empty left or rigth cell
       */
      title_blank: {
        codename: 'title_blank',
        id: '3b7d23be-3ce3-4f26-ab82-a8c4a11aabda',
        externalId: undefined,
        name: '📜 Title Blank',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title Sort (text)
       *
       * ⚠️ Use this field to control the sort order of this tile when the left syllabus cell is empty. This field is not displayed on screen.
       */
      title_sort: {
        codename: 'title_sort',
        id: 'df624d3c-2f2a-4269-88d3-689b81227149',
        externalId: undefined,
        name: '📜 Title Sort',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🛠️ Website Configuration
   * Last modified: Tue May 26 2026 02:43:13 GMT+0000 (Coordinated Universal Time)
   */
  website_configuration: {
    codename: 'website_configuration',
    id: '68c9c69e-ebaa-4db4-bd80-e623a33d5900',
    externalId: undefined,
    name: '🛠️ Website Configuration',
    elements: {
      /**
       * 📜 Site Title (text)
       *
       * ℹ️ Leave empty, if you don't want any site prefix
       */
      site_prefix: {
        codename: 'site_prefix',
        id: '6f071d1e-a2f7-4d5b-9a0e-4683daf5aaf3',
        externalId: undefined,
        name: '📜 Site Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Descriptor (text)
       *
       * ℹ️ Used as site descriptor
       */
      descriptor: {
        codename: 'descriptor',
        id: 'bb91b2b6-d0e7-462f-8d55-ca32acc24c07',
        externalId: undefined,
        name: '📜 Descriptor',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📦 Favicon (asset)
       */
      favicon: {
        codename: 'favicon',
        id: '74c674e9-8fe6-46ed-9d7b-22ef480f76a8',
        externalId: undefined,
        name: '📦 Favicon',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * 📦 Logo main (asset)
       */
      logo_main: {
        codename: 'logo_main',
        id: '1b5b4015-169a-4b6f-b2c6-3a8799fc51fd',
        externalId: undefined,
        name: '📦 Logo main',
        required: false,
        type: 'asset',
        snippetCodename: undefined,
      },

      /**
       * 📧 Feedback (text)
       *
       * ℹ️ Email or Form embed link e.g.- mailto:curriculum@nesa.nsw.edu.au?subject=Feedback on NSW Curriculum websiteor- https://forms.office.com/Pages/ResponsePage.aspx?id=xyz...
       */
      feedback: {
        codename: 'feedback',
        id: 'bfcf5712-e140-4644-aeac-6493b52d7107',
        externalId: undefined,
        name: '📧 Feedback',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 NESA main website (text)
       */
      nesa_main_site: {
        codename: 'nesa_main_site',
        id: '3a00d9c5-69ba-4562-8bba-1dc3f00f0473',
        externalId: undefined,
        name: '🔗 NESA main website',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content top (rich_text)
       *
       * ℹ️ Footer top content
       */
      footer_top_content: {
        codename: 'footer_top_content',
        id: '5fdacfb0-29e6-43e8-bcd9-8a4e1a3b1381',
        externalId: undefined,
        name: '📜 Content top',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Social Links (modular_content)
       */
      social_links: {
        codename: 'social_links',
        id: '0821f3fc-4fab-4177-a147-ca49788c092c',
        externalId: undefined,
        name: '🔗 Social Links',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📂 Menu links (modular_content)
       *
       * ℹ️ Footer menu links
       */
      footer_menu_links: {
        codename: 'footer_menu_links',
        id: '730f4293-0474-4206-8af2-75346cba47dd',
        externalId: undefined,
        name: '📂 Menu links',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Acknowledgement (rich_text)
       *
       * ℹ️ Appears in the footer bottom
       */
      acknowledgement: {
        codename: 'acknowledgement',
        id: '23670bc6-3b2e-4f5c-b1bb-aacd5c7515ae',
        externalId: undefined,
        name: '📜 Acknowledgement',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📂 Secondary links (modular_content)
       */
      secondary_links: {
        codename: 'secondary_links',
        id: '21d60c87-0ffc-4788-90aa-b2f24264ea49',
        externalId: undefined,
        name: '📂 Secondary links',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📂 Copyright link (modular_content)
       */
      copyright_link: {
        codename: 'copyright_link',
        id: '2429a51f-3dd0-4b6a-9bcc-a016de5fccda',
        externalId: undefined,
        name: '📂 Copyright link',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 KLA / Stage page - Left column title (text)
       */
      kla_stage_page_left_column_title: {
        codename: 'kla_stage_page_left_column_title',
        id: '49ac461e-d58e-49af-abcb-e0c83bd13964',
        externalId: undefined,
        name: '📜 KLA / Stage page - Left column title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 KLA / Stage page - Right column title (text)
       */
      kla_stage_page_right_column_title: {
        codename: 'kla_stage_page_right_column_title',
        id: '7e9a00fb-1885-4bca-b734-15c0d0ab0f53',
        externalId: undefined,
        name: '📜 KLA / Stage page - Right column title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 View side-by-side - Link block message (rich_text)
       */
      message_splitview_linkblock: {
        codename: 'message_splitview_linkblock',
        id: '763ec518-2fe0-426e-a89d-c02e3d9218ad',
        externalId: undefined,
        name: '📜 View side-by-side - Link block message',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Download syllabus - Dialog message (rich_text)
       */
      message_download_syllabus_dialog: {
        codename: 'message_download_syllabus_dialog',
        id: '00678106-951a-454f-8f6e-1392b7dfea1d',
        externalId: undefined,
        name: '📜 Download syllabus - Dialog message',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Download syllabus - Language select message (rich_text)
       */
      message_select_language_dialog: {
        codename: 'message_select_language_dialog',
        id: '76910be4-1c9e-4f22-8911-cbc3573dd8ce',
        externalId: undefined,
        name: '📜 Download syllabus - Language select message',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Glossary Intro (rich_text)
       *
       * ℹ️ Glossary intro displayed on syllabus glossary tab.
       */
      glossary_intro: {
        codename: 'glossary_intro',
        id: 'a8b863d2-44a4-4cd2-b8b4-48f24b336ba4',
        externalId: undefined,
        name: '📜 Glossary Intro',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Overarching outcome message (text)
       *
       * ℹ️ Overarching outcome message displayed on syllabus outcome tab.
       */
      overarchingoutcome_message: {
        codename: 'overarchingoutcome_message',
        id: '2bca969a-fdf1-472d-8e39-633f24ca8531',
        externalId: undefined,
        name: '📜 Overarching outcome message',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 No Teaching Advice message (text)
       *
       * ℹ️ No Teaching Advice message displayed on syllabus focus area page.
       */
      nocontent_teachingadvice: {
        codename: 'nocontent_teachingadvice',
        id: '8cae1b20-1d63-49fb-a409-ca4aaae15679',
        externalId: undefined,
        name: '📜 No Teaching Advice message',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Prescriptions collections message (rich_text)
       *
       * ℹ️ Appears on Focus Area pages only where Text Prescriptions with collections (e.g. poetry/stories collections) are displayed
       */
      message_prescriptions_collections: {
        codename: 'message_prescriptions_collections',
        id: '41089db6-1bfd-41ba-8a19-6366829dc22d',
        externalId: undefined,
        name: '📜 Prescriptions collections message',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🗒️ K-10 Syllabus Outcomes - Related outcomes (rich_text)
       */
      syllabusoutcomes_relatedoutomes: {
        codename: 'syllabusoutcomes_relatedoutomes',
        id: '35c31c7c-fa1c-4aaf-9634-ab4420578c28',
        externalId: undefined,
        name: '🗒️ K-10 Syllabus Outcomes - Related outcomes',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🗒️ S6 MS Syllabus Outcomes - Related outcomes (rich_text)
       */
      syllabussenioroutcomes_relatedoutomes: {
        codename: 'syllabussenioroutcomes_relatedoutomes',
        id: '8491b2cc-2800-4011-8ace-ab66dfb3bdf3',
        externalId: undefined,
        name: '🗒️ S6 MS Syllabus Outcomes - Related outcomes',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🗒️ S6 LS Syllabus Outcomes - Related outcomes (rich_text)
       */
      syllabussenioroutcomes_relatedoutomes_ls: {
        codename: 'syllabussenioroutcomes_relatedoutomes_ls',
        id: '1f1d9a29-627a-432d-9b4d-3d7677e432ac',
        externalId: undefined,
        name: '🗒️ S6 LS Syllabus Outcomes - Related outcomes',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🗒️ Syllabus Outcomes - Aligned content (rich_text)
       */
      syllabusoutcomes_alignedcontent: {
        codename: 'syllabusoutcomes_alignedcontent',
        id: '054d4244-aa4c-4cd1-a59a-42bcdd31c91d',
        externalId: undefined,
        name: '🗒️ Syllabus Outcomes - Aligned content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Max syllabuses download (number)
       */
      max_download_syllabuses: {
        codename: 'max_download_syllabuses',
        id: 'c579194e-b74b-49c3-a334-509358b1acef',
        externalId: undefined,
        name: '⚙️ Max syllabuses download',
        required: true,
        type: 'number',
        snippetCodename: undefined,
      },

      /**
       * 📜 Max syllabuses download message (text)
       */
      max_download_syllabuses_message: {
        codename: 'max_download_syllabuses_message',
        id: 'acf98a25-e3ed-4cc8-8dd6-2ffb425f4da6',
        externalId: undefined,
        name: '📜 Max syllabuses download message',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📙 Syllabus - Assessment page
   * Last modified: Fri Jun 19 2026 09:06:45 GMT+0000 (Coordinated Universal Time)
   */
  syllabus_assessmentpage: {
    codename: 'syllabus_assessmentpage',
    id: 'fefa3996-f866-4b86-a6f2-b91f9649561e',
    externalId: undefined,
    name: '📙 Syllabus - Assessment page',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'a039d790-6238-4484-bee8-d2eb4d9eabdf',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Assessment Info (rich_text)
       */
      info: {
        codename: 'info',
        id: 'd8c0fe98-8126-4911-9544-2594f5bbdf9d',
        externalId: undefined,
        name: '📜 Assessment Info',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📃 Assessments (modular_content)
       */
      assessments: {
        codename: 'assessments',
        id: '735a7191-d3f6-4623-87e3-55bd1642ebc1',
        externalId: undefined,
        name: '📃 Assessments',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '15fc62bc-021d-4d56-9cdc-a8d659ffd5ee',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Description (text)
       */
      seo_description: {
        codename: 'seo_description',
        id: 'e0940d35-e9c0-4c1b-8faa-647d699f9bbc',
        externalId: undefined,
        name: '📜 Description',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: 'a74ebdf9-37d8-49f5-9c1f-60356cbaf4b0',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '226538f8-d769-476b-8ddd-2a948721154d',
        externalId: undefined,
        name: '📒 Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🛠️ Syllabus Custom Download Configuration
   * Last modified: Sun Aug 03 2025 04:47:58 GMT+0000 (Coordinated Universal Time)
   */
  custom_download_config: {
    codename: 'custom_download_config',
    id: '73e82c93-6e0c-4d3f-98f5-f89bf0c66759',
    externalId: undefined,
    name: '🛠️ Syllabus Custom Download Configuration',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '0d47b822-384b-4fea-9034-43511a1dd748',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '0eb25384-e83d-4cd0-bfdd-4e777bb85077',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Stages (multiple_choice)
       */
      stages: {
        codename: 'stages',
        id: '36f2fbe5-74f0-4e71-a1e0-392bfe737229',
        externalId: undefined,
        name: '⚙️ Stages',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: 'ec241bca-8251-4027-bf3f-988d638770e3',
        externalId: undefined,
        name: '⚙️ Syllabuses',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Syllabus elements (multiple_choice)
       */
      syllabus_elements: {
        codename: 'syllabus_elements',
        id: '18df8b70-f2b4-445f-9e9a-57bec27d5af1',
        externalId: undefined,
        name: '⚙️ Syllabus elements',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🛠️ Custom Error Page
   * Last modified: Fri Jul 25 2025 06:42:35 GMT+0000 (Coordinated Universal Time)
   */
  wp_custom_error: {
    codename: 'wp_custom_error',
    id: '5d7eb82a-bab6-491d-8f3e-5218655406bf',
    externalId: undefined,
    name: '🛠️ Custom Error Page',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '5bf53cb6-4d72-4b8e-92cb-04af5eee9d6b',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Error message (modular_content)
       */
      error_message: {
        codename: 'error_message',
        id: '5a73102e-016c-4097-9c5f-2b096a15b235',
        externalId: undefined,
        name: '📜 Error message',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 🔗 Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '1bcf021c-1c6d-46ad-b7a5-52982e6335d7',
        externalId: undefined,
        name: '🔗 Slug',
        required: true,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },
    },
  },

  /**
   * 🗒️ Content Shared Tooltip
   * Last modified: Wed Dec 10 2025 13:59:40 GMT+0000 (Coordinated Universal Time)
   */
  content_shared_tooltip: {
    codename: 'content_shared_tooltip',
    id: 'd9191516-83bc-4d85-a712-faff3516e301',
    externalId: undefined,
    name: '🗒️ Content Shared Tooltip',
    elements: {
      /**
       * 🗒️ Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '38197340-c804-4eba-8ca9-181b5a38ecc2',
        externalId: undefined,
        name: '🗒️ Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📜 Content Rich Text - Staged
   * Last modified: Thu Oct 16 2025 21:15:35 GMT+0000 (Coordinated Universal Time)
   */
  content_rich_text_staged: {
    codename: 'content_rich_text_staged',
    id: '786c37fe-5708-44e6-ad91-df10d2120f5d',
    externalId: undefined,
    name: '📜 Content Rich Text - Staged',
    elements: {
      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: 'd20cdb6d-ae20-4e07-971e-a692c67d93e8',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Stage (taxonomy)
       */
      stages: {
        codename: 'stages',
        id: '202ba8c9-79bf-4b7b-86f1-0a04c2d324d8',
        externalId: undefined,
        name: '🏷️ Stages',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Stage Year (taxonomy)
       */
      stage_years: {
        codename: 'stage_years',
        id: '285b0e6b-42c1-441d-af7c-162da235bdcf',
        externalId: undefined,
        name: '🏷️ Stage Years',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Syllabus Type (taxonomy)
       */
      syllabus_type__items: {
        codename: 'syllabus_type__items',
        id: 'a0ab51bd-2b45-49c1-90ba-cfe7129d3491',
        externalId: undefined,
        name: '🏷️ Syllabus Type',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📗 Prescription Work
   * Last modified: Tue Jun 16 2026 16:03:29 GMT+0000 (Coordinated Universal Time)
   */
  prescription_work: {
    codename: 'prescription_work',
    id: '6cc6018f-18c3-4464-a816-7f793014a588',
    externalId: undefined,
    name: '📗 Prescription Work',
    elements: {
      /**
       * 📜 Author (text)
       */
      author: {
        codename: 'author',
        id: '96e396b4-bbbf-49b0-9862-1c740cb7bab0',
        externalId: undefined,
        name: '📜 Author',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title (rich_text)
       */
      title: {
        codename: 'title',
        id: 'ee147316-cc85-472b-b295-90980282f62e',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Title link (modular_content)
       */
      title_link: {
        codename: 'title_link',
        id: '60a954dc-e298-442d-969d-ef3bea832b93',
        externalId: undefined,
        name: '🔗 Title link',
        required: false,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Subtitles (text)
       */
      subtitles: {
        codename: 'subtitles',
        id: '58a481e0-ff86-4f76-8965-01eb1ae6fd99',
        externalId: undefined,
        name: '📜 Subtitles',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Publication details (text)
       */
      publication: {
        codename: 'publication',
        id: '50033ff8-2f98-4765-919a-b91ecda262c8',
        externalId: undefined,
        name: '📜 Publication details',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * Prescription Type (taxonomy)
       */
      prescription_type: {
        codename: 'prescription_type',
        id: 'eec2e4be-2277-464a-bbe7-0a4794f23b8c',
        externalId: undefined,
        name: '🏷️ Prescription Type',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Prescription Form (taxonomy)
       */
      prescription_form: {
        codename: 'prescription_form',
        id: '84524dcf-7e03-4d53-90b9-6eea302e16dc',
        externalId: undefined,
        name: '🏷️ Prescription Form',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Is Shakespeare (multiple_choice)
       */
      is_shakespeare: {
        codename: 'is_shakespeare',
        id: 'b9ceeba3-ebce-4bce-b719-d9c709f9d2fa',
        externalId: undefined,
        name: '⚙️ Is Shakespeare',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📘 Prescription Study
   * Last modified: Tue May 26 2026 08:07:12 GMT+0000 (Coordinated Universal Time)
   */
  prescription_study: {
    codename: 'prescription_study',
    id: 'c023fcf8-55be-475d-a911-dbb7703e329d',
    externalId: undefined,
    name: '📘 Prescription Study',
    elements: {
      /**
       * 📜 Author (text)
       */
      author: {
        codename: 'author',
        id: 'b1223410-d393-4e49-86d0-171d081cb598',
        externalId: undefined,
        name: '📜 Author',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '1bbf05f1-0a9b-4a6c-a7f5-ae2e618e8aaf',
        externalId: undefined,
        name: '📜 Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: 'be27e424-0881-46ef-9400-c92a10b389f8',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Prescription Type (taxonomy)
       */
      prescription_type: {
        codename: 'prescription_type',
        id: '4e206989-ff55-42c4-86dd-74c7330434c6',
        externalId: undefined,
        name: '🏷️ Prescription Type',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Prescription Form (taxonomy)
       */
      prescription_form: {
        codename: 'prescription_form',
        id: 'eb8c9916-4357-4021-ae95-3507e43f709a',
        externalId: undefined,
        name: '🏷️ Prescription Form',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📚 Prescription Work Bundle
   * Last modified: Wed Apr 29 2026 08:09:25 GMT+0000 (Coordinated Universal Time)
   */
  prescription_work_bundle: {
    codename: 'prescription_work_bundle',
    id: '503a1cba-2f7e-4c37-b3ce-36e5cc8d2eac',
    externalId: undefined,
    name: '📚 Prescription Work Bundle',
    elements: {
      /**
       * 📗 Prescription works (modular_content)
       *
       * ℹ️ Select 2 prescription works to create a bundle e.g. all works listed here are selected as a bundle.
       */
      prescription_work: {
        codename: 'prescription_work',
        id: 'f569111a-7165-480f-930d-b4fd85efa095',
        externalId: undefined,
        name: '📗 Prescription works',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🗂️ Prescriptions List
   * Last modified: Fri May 01 2026 06:55:07 GMT+0000 (Coordinated Universal Time)
   */
  prescriptions_list: {
    codename: 'prescriptions_list',
    id: '6496f352-3682-44e9-a76e-d0657222fb5e',
    externalId: undefined,
    name: '🗂️ Prescriptions List',
    elements: {
      /**
       * 📜 Title 1 (text)
       *
       * ℹ️ e.g. Text Prescriptions
       */
      title: {
        codename: 'title',
        id: 'e5a8dfbe-4e5e-4045-944c-db1d0877888c',
        externalId: undefined,
        name: '📜 Title 1',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title 2 - English Extension 1 (text)
       *
       * ℹ️ e.g. Prescriptions
       */
      title_ext1: {
        codename: 'title_ext1',
        id: '5840ab42-064e-40e8-aef9-2f1388e7439e',
        externalId: undefined,
        name: '📜 Title 2 - English Extension 1',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Title 3 - English Extension 2 (text)
       *
       * ℹ️ e.g. Prescriptions
       */
      title_ext2: {
        codename: 'title_ext2',
        id: 'a055ae7e-ead9-4582-ac1c-98009869941d',
        externalId: undefined,
        name: '📜 Title 3 - English Extension 2',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Years (text)
       *
       * ℹ️ e.g. 2027-2028
       */
      years: {
        codename: 'years',
        id: 'bd743cb1-25db-44c2-8184-8c8745b2e278',
        externalId: undefined,
        name: '📜 Years',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Status (multiple_choice)
       */
      status: {
        codename: 'status',
        id: '99012326-e487-4b57-965f-cc4eb228628f',
        externalId: undefined,
        name: '⚙️ Status',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚠️ Status message (rich_text)
       */
      status_message: {
        codename: 'status_message',
        id: 'fe2ce90a-7fbf-4edc-99d5-9d1f4110b612',
        externalId: undefined,
        name: '⚠️ Status message',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🗂️ Prescription Group
   * Last modified: Wed May 13 2026 06:20:51 GMT+0000 (Coordinated Universal Time)
   */
  prescription_group: {
    codename: 'prescription_group',
    id: 'a3de5034-368b-4ec1-91be-e814ed027716',
    externalId: undefined,
    name: '🗂️ Prescription Group',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '0f3611c1-b3b3-4a54-8ac0-c19483783e65',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📗 Prescription works (modular_content)
       *
       * Select 📗 Prescription Works or 📚 Prescription Work Bundles
       */
      prescription_work: {
        codename: 'prescription_work',
        id: 'c7a835a1-0796-40b6-9e0d-5a0e8a5c93a8',
        externalId: undefined,
        name: '📗 Prescription works',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '9265f943-fac2-4daf-878e-80bdf59dadc5',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 🗂️ Prescription List (modular_content)
       */
      prescription_list: {
        codename: 'prescription_list',
        id: 'ae6ae112-b8d7-4db4-aac4-9a420f9c55fe',
        externalId: undefined,
        name: '🗂️ Prescription List',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📂 Prescription Option
   * Last modified: Wed May 13 2026 06:22:59 GMT+0000 (Coordinated Universal Time)
   */
  prescription_option: {
    codename: 'prescription_option',
    id: '2d384b76-9215-4469-b5ad-39d9ef6feaf2',
    externalId: undefined,
    name: '📂 Prescription Option',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: '3f98ec79-2ec9-43a9-9c3c-54758bc77b58',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: 'f8967e34-7fb8-455b-95d0-850436d2b424',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 🗂️ Prescription Groups / Studies (modular_content)
       *
       * Select 🗂️ Prescription Group or 📘 Prescription Study
       */
      prescriptions: {
        codename: 'prescriptions',
        id: '65976231-f120-454e-b506-f5c5a3af14c9',
        externalId: undefined,
        name: '🗂️ Prescription Groups / Studies',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: 'ee6fe8ea-7ee7-4162-8d32-b2b7c6855f8c',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 🗂️ Prescription List (modular_content)
       */
      prescription_list: {
        codename: 'prescription_list',
        id: 'b56a7d9f-f5b6-45d0-a2ff-e47b3761468f',
        externalId: undefined,
        name: '🗂️ Prescription List',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🛠️ Prescription Requirements Configuration
   * Last modified: Wed May 13 2026 06:26:44 GMT+0000 (Coordinated Universal Time)
   */
  prescription_requirement_course: {
    codename: 'prescription_requirement_course',
    id: 'd194e703-f84b-4293-9f38-ac29da28d552',
    externalId: undefined,
    name: '🛠️ Prescription Requirements Configuration',
    elements: {
      /**
       * 📜 Title (text)
       *
       * ℹ️ This is what will appear on the prescription tool accordion title for this course
       */
      title: {
        codename: 'title',
        id: '51abd125-6504-4476-9a1e-98f487bc391a',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Selection Type (multiple_choice)
       */
      selection_type: {
        codename: 'selection_type',
        id: 'f49504ac-d105-45e4-8cc4-d3b802b38699',
        externalId: undefined,
        name: '⚙️ Selection Type',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Total Selection QTY (multiple_choice)
       */
      selection_qty: {
        codename: 'selection_qty',
        id: '73b37c67-317a-4bbf-bd18-5b83144c7885',
        externalId: undefined,
        name: '⚙️ Total Selection QTY',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Focus Area Selection QTY (modular_content)
       */
      focusarea_selection_qty: {
        codename: 'focusarea_selection_qty',
        id: 'e60f89d9-2ba0-4ade-b959-875e9c7449b4',
        externalId: undefined,
        name: '⚙️ Focus Area Selection QTY',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 📜 Requirements summary (modular_content)
       */
      requirements_summary: {
        codename: 'requirements_summary',
        id: 'a2244138-96ca-494e-acd0-3f1809628c13',
        externalId: undefined,
        name: '📜 Requirements summary',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚠️ Requirements rules (modular_content)
       */
      requirements_rules: {
        codename: 'requirements_rules',
        id: 'e4ddd895-2ec8-4dc2-8071-719593e4facb',
        externalId: undefined,
        name: '⚠️ Requirements rules',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🎯 Selection Rules (multiple_choice)
       */
      selection_rules: {
        codename: 'selection_rules',
        id: 'aa9a3512-5125-41c4-b665-7966a35c8656',
        externalId: undefined,
        name: '🎯 Selection Rules',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 📜 Confirmation Message (rich_text)
       */
      confirmation_message: {
        codename: 'confirmation_message',
        id: 'c27d82ec-3847-4f0b-82e9-4c13bf045eea',
        externalId: undefined,
        name: '📜 Confirmation Message',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '0b7f24cb-562e-4dba-9c90-a6afde10b085',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * ⚠️ Prescription Requirement - Text Selection
   * Last modified: Fri Feb 06 2026 05:19:14 GMT+0000 (Coordinated Universal Time)
   */
  prescription_requirement_text: {
    codename: 'prescription_requirement_text',
    id: '588d7ea8-aee9-4829-a921-136e90840399',
    externalId: undefined,
    name: '⚠️ Prescription Requirement - Text Selection',
    elements: {
      /**
       * Prescription Type (taxonomy)
       *
       * ℹ️ Match any of the selected elements
       */
      prescription_type: {
        codename: 'prescription_type',
        id: '1444ceea-6022-44a5-8e25-66ced609de23',
        externalId: undefined,
        name: '🏷️ Prescription Type',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * Prescription Form (taxonomy)
       *
       * ℹ️ Match any of the selected elements
       */
      prescription_form: {
        codename: 'prescription_form',
        id: 'fb93cd2b-66a4-420e-b3c3-8fc76cfba9ad',
        externalId: undefined,
        name: '🏷️ Prescription Form',
        required: false,
        type: 'taxonomy',
        snippetCodename: undefined,
      },

      /**
       * 📜 Validation Message (text)
       */
      validation_message: {
        codename: 'validation_message',
        id: '03f45b80-1c99-4634-ab6a-a5b2554a9c6e',
        externalId: undefined,
        name: '📜 Validation Message',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 📜 Content - Text Requirements
   * Last modified: Thu Jun 18 2026 08:20:36 GMT+0000 (Coordinated Universal Time)
   */
  content_textrequirements: {
    codename: 'content_textrequirements',
    id: '34a6bfae-4ce5-4d02-a2f9-8eca8c9ed4b8',
    externalId: undefined,
    name: '📜 Content - Text Requirements',
    elements: {
      /**
       * 📜 Content (rich_text)
       */
      content: {
        codename: 'content',
        id: '41654a91-9962-453a-a0fd-bc0c27847938',
        externalId: undefined,
        name: '📜 Content',
        required: true,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       *
       * ⚠️ CMS field only, not used by the web application
       */
      syllabus: {
        codename: 'syllabus',
        id: '176b81e2-8a1a-46ed-880b-11ff312bd6c9',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Card Carousel
   * Last modified: Wed May 13 2026 06:45:00 GMT+0000 (Coordinated Universal Time)
   */
  web_ui_card_carousel: {
    codename: 'web_ui_card_carousel',
    id: '4325d781-8783-43cc-a1e6-b5007000134e',
    externalId: undefined,
    name: '💠 Web UI Card Carousel',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'e8156056-3e9f-4ef9-8cda-9b2e727502c4',
        externalId: undefined,
        name: '📜 Title',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Items (modular_content)
       */
      items: {
        codename: 'items',
        id: '2789668c-7033-4f61-b51f-10a98b8bd9af',
        externalId: undefined,
        name: '📜 Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * 🎨 Theme (multiple_choice)
       */
      theme: {
        codename: 'theme',
        id: '034196dc-c68d-4a8b-a096-617d93e85a14',
        externalId: undefined,
        name: '🎨 Theme',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Display (multiple_choice)
       */
      display: {
        codename: 'display',
        id: '897975b7-a219-45e2-af44-4170dbf10f7e',
        externalId: undefined,
        name: '⚙️ Display',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Pagination (multiple_choice)
       */
      pagination: {
        codename: 'pagination',
        id: '1f9745b2-461f-4328-99d9-b6abef5dc3c8',
        externalId: undefined,
        name: '⚙️ Pagination',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Content Blocks
   * Last modified: Wed May 13 2026 07:48:39 GMT+0000 (Coordinated Universal Time)
   */
  web_ui_content_blocks: {
    codename: 'web_ui_content_blocks',
    id: '6b533113-b577-491f-9f60-8e84554374d0',
    externalId: undefined,
    name: '💠 Web UI Content Blocks',
    elements: {
      /**
       * 📜 Items (modular_content)
       */
      items: {
        codename: 'items',
        id: '935e5f62-a655-42c5-beae-4e00d6b23ce3',
        externalId: undefined,
        name: '📜 Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Display (multiple_choice)
       */
      display: {
        codename: 'display',
        id: '60c70a14-7d5d-4576-9f9e-06c2b20dab8c',
        externalId: undefined,
        name: '⚙️ Display',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🎨 Theme (multiple_choice)
       */
      theme: {
        codename: 'theme',
        id: '046a7e5f-7819-4676-8f94-58acf2ce787a',
        externalId: undefined,
        name: '🎨 Theme',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 💠 Web UI Section
   * Last modified: Wed Apr 29 2026 23:48:20 GMT+0000 (Coordinated Universal Time)
   */
  web_ui_section: {
    codename: 'web_ui_section',
    id: '89b5c9dc-900d-4885-b515-9bff676d57bf',
    externalId: undefined,
    name: '💠 Web UI Section',
    elements: {
      /**
       * 📜 Items (modular_content)
       */
      items: {
        codename: 'items',
        id: 'edef1ec4-abf1-4997-9212-ab88415e335b',
        externalId: undefined,
        name: '📜 Items',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Vertical spacing (multiple_choice)
       */
      vertical_spacing: {
        codename: 'vertical_spacing',
        id: 'f648aa1f-0da4-4932-9f5d-a626c7c833db',
        externalId: undefined,
        name: '⚙️ Vertical spacing',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * 🎨 Colour (multiple_choice)
       */
      colour: {
        codename: 'colour',
        id: '88d5a54a-f3b4-4bb4-907f-6be4418e86df',
        externalId: undefined,
        name: '🎨 Colour',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * ⚙️ Focus Area QTY Selector
   * Last modified: Wed May 13 2026 06:43:04 GMT+0000 (Coordinated Universal Time)
   */
  focusarea_qty: {
    codename: 'focusarea_qty',
    id: '940fbd44-267a-4baa-805d-41c63bfe74b9',
    externalId: undefined,
    name: '⚙️ Focus Area QTY Selector',
    elements: {
      /**
       * 📃🔹Focus Area (modular_content)
       */
      focus_area: {
        codename: 'focus_area',
        id: '31f05f39-a7b6-43b5-9491-a2991fe402e0',
        externalId: undefined,
        name: '📃🔹Focus Area',
        required: true,
        type: 'modular_content',
        snippetCodename: undefined,
      },

      /**
       * ⚙️ Selection QTY (multiple_choice)
       */
      selection_qty: {
        codename: 'selection_qty',
        id: 'cd2b1efd-a220-4545-83b3-30a8a4758f23',
        externalId: undefined,
        name: '⚙️ Selection QTY',
        required: true,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * Syllabus (taxonomy)
       */
      syllabus: {
        codename: 'syllabus',
        id: '5f88ef35-55dd-464c-9bd1-0a880f448762',
        externalId: undefined,
        name: '🏷️ Syllabus',
        required: true,
        type: 'taxonomy',
        snippetCodename: undefined,
      },
    },
  },

  /**
   * 🌐 Web Page Prescriptions Tools
   * Last modified: Fri Jun 05 2026 21:23:44 GMT+0000 (Coordinated Universal Time)
   */
  web_page_prescriptions_tools: {
    codename: 'web_page_prescriptions_tools',
    id: '214ca75b-7b0b-4903-8d16-8cf2737ec327',
    externalId: undefined,
    name: '🌐 Web Page Prescriptions Tools',
    elements: {
      /**
       * 📜 Title (text)
       */
      title: {
        codename: 'title',
        id: 'dc87be8b-b361-42b2-b225-19ddf3ee77bf',
        externalId: undefined,
        name: '📜 Title',
        required: true,
        type: 'text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content (rich_text)
       */
      web_content_rtb__content: {
        codename: 'web_content_rtb__content',
        id: '0f9bc8e7-294b-4d36-bd85-b40789a81739',
        externalId: undefined,
        name: '📜 Content',
        required: false,
        type: 'rich_text',
        snippetCodename: 'web_content_rtb',
      },

      /**
       * 📜 Content - Selection tab (rich_text)
       */
      content_selection_tab: {
        codename: 'content_selection_tab',
        id: '9e6e257c-db93-43f6-85f3-9af10032e0f7',
        externalId: undefined,
        name: '📜 Content - Selection tab',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * 📜 Content - List tab (rich_text)
       */
      content_list_tab: {
        codename: 'content_list_tab',
        id: '9e8b2003-8d4b-4c98-a03b-cd4dd81f0dee',
        externalId: undefined,
        name: '📜 Content - List tab',
        required: false,
        type: 'rich_text',
        snippetCodename: undefined,
      },

      /**
       * Slug (url_slug)
       */
      slug: {
        codename: 'slug',
        id: '7b269f73-f40a-4acb-b3c0-aaaac38dc37c',
        externalId: undefined,
        name: 'Slug',
        required: false,
        type: 'url_slug',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Canonical URL (text)
       */
      seo__canonical_url: {
        codename: 'seo__canonical_url',
        id: '440da44d-add4-58e0-89dc-422779bf5fb4',
        externalId: 'd7ee1702-d35d-4c51-a179-c8b26c87b467',
        name: '🔗 Canonical URL',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Title (text)
       */
      seo__title: {
        codename: 'seo__title',
        id: '9ca3abe2-e63e-5f9c-925b-79a95eb23525',
        externalId: '28610917-4e68-48ef-9a7d-012f286325c7',
        name: '📜 SEO Title',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Description (text)
       */
      seo__description: {
        codename: 'seo__description',
        id: '3072a2d9-3e2c-59e6-bf81-85d9bc696a50',
        externalId: 'a50872bb-2bf5-4b45-8cd7-caff7d4a66fa',
        name: '📜 SEO Description',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * 📜 SEO Keywords (text)
       */
      seo__keywords: {
        codename: 'seo__keywords',
        id: '94c37747-eb31-5521-b6c6-69813bca4ab1',
        externalId: 'f2b4c652-7248-4a31-8d2c-4e485a1dfe39',
        name: '📜 SEO Keywords',
        required: false,
        type: 'text',
        snippetCodename: 'seo',
      },

      /**
       * ⚙️ Robots meta tag (multiple_choice)
       */
      seo__robots: {
        codename: 'seo__robots',
        id: '40c147cd-ba16-5ff1-beed-0228c3dc0494',
        externalId: '81b73859-a544-4eb9-9468-2d93e423c9f9',
        name: '⚙️ Robots meta tag',
        required: false,
        type: 'multiple_choice',
        snippetCodename: 'seo',
      },

      /**
       * 🖇️ Show in-page navigation (multiple_choice)
       */
      show_in_page_navigation: {
        codename: 'show_in_page_navigation',
        id: 'c0663324-0c83-4339-aa87-0bc71faf258c',
        externalId: undefined,
        name: '🖇️ Show in-page navigation',
        required: false,
        type: 'multiple_choice',
        snippetCodename: undefined,
      },

      /**
       * Subpages (subpages)
       */
      subpages: {
        codename: 'subpages',
        id: 'e4aa0e06-02a0-4d1a-b155-9137993e4ce9',
        externalId: undefined,
        name: 'Subpages',
        required: false,
        type: 'subpages',
        snippetCodename: undefined,
      },

      /**
       * 🔗 Redirect Url (text)
       */
      redirect_url: {
        codename: 'redirect_url',
        id: '7a6ee274-ed7f-4a54-a40f-dd65d6c4517b',
        externalId: undefined,
        name: '🔗 Redirect Url',
        required: false,
        type: 'text',
        snippetCodename: undefined,
      },
    },
  },
};
